import './Footer.scss'

import { MailFilled } from '@ant-design/icons'
import { Button, Col, Collapse, Divider, Modal, Row } from 'antd'
import CenteredLayout, { DEFAULT_MAX_WIDTH } from 'components/centered-layout/CenteredLayout'
import AppContext from 'context/AppContext'
import akbank from 'images/akbank.png'
import finans from 'images/finans.png'
import okulSepetiLogo from 'images/okulsepeti_logo.png'
import logoImg from 'images/visa1.png'
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DEV_BACKEND_DOMAIN } from 'utils/const'

import { AppRoutes } from '../../App'
import {Okul} from "../../gql/StaticTypes";
import useMediaQuery from '../../hooks/useMediaQuery'
import { scrollToTop } from '../../utils/helpers'
import { AuthState } from '../../utils/types'
import { ReactComponent as AdminIcon } from './svg/admin.svg'
import { ReactComponent as CallCenterIcon } from './svg/call-center.svg'
import { ReactComponent as TeacherIcon } from './svg/teacher.svg'
import { FooterGroup, FooterModalConfig, isFooterClickableItem } from './types'

const Panel = Collapse.Panel

interface OkulYonetimTabsProps {
  okul: Okul
}
const FooterComponent: React.FC<OkulYonetimTabsProps> = ({ okul }) => {
  const [modalConfig, setModalConfig] = useState<FooterModalConfig | null>(null)
  const [modalOpen, setModalOpen] = useState(false)
  const navigate = useNavigate()
  const { slug } = useContext(AppContext)
  const appContext = useContext(AppContext)
  const isMobile = useMediaQuery(768)

  // const primaryColor = appContext?.okul?.renk1 ?? DEFAULT_PRIMARY_COLOR

  const footerItems: FooterGroup[] = [
    [
      {
        title: (
          <div className="login-buttons">
            <Button
              className="footer-login-button"
              onClick={() => {
                window.open(`https://${slug}.${DEV_BACKEND_DOMAIN}/v1/okulyonetim/`)
              }}
              icon={<TeacherIcon />}
            >
              <span>Öğretmen</span>
              <span>Girişi</span>
            </Button>
            <Button
              className="footer-login-button"
              onClick={() => {
                window.open(`https://${slug}.${DEV_BACKEND_DOMAIN}/v1/okulyonetimadmin/`)
              }}
              icon={<AdminIcon />}
            >
              <span>Yönetici </span>
              <span>Giriş </span>
            </Button>
          </div>
        ),
      },

      {
        title: <br />,
      },
      {
        title: (
          <div className="footer-logo-home">
            <img src={okulSepetiLogo} alt="logo" />
          </div>
        ),
      },
    ],

    [
      { title: <h2 className="font-ayarlama">Okul Sepeti</h2> },
      {
        title: 'Hakkımızda',
        modalConfig: {
          title: 'Hakkımızda',
          content: (
            <div>
              <p>
                2021 - 2022 okul sezonu itibari ile Türkiyenin her ilinden toplamda 40 özel okula hizmet veren{' '}
                <strong>Okul Sepeti Pazarlama A.Ş.</strong> firmamız,
              </p>

              <p>2012 yılında Özel Okullarımıza ve velilerimize hizmet vermek amacıyla faaliyete başlamıştır.</p>

              <p>
                Sizleri okul sezonlarının yoğunluğundan kurtararak zaman tasarrufu yapabilmeniz için kaliteli hizmet,
                güvenli alışveriş , ideal fiyat prensiplerini ilke edinerek sektöründe öncü firmalardan biri olmayı
                başarmıştır.
              </p>

              <p>
                <u>Projemizin faydalı olabileceği konular</u>
              </p>

              <ul>
                <li>"Veli ve öğrencilerimiz özgür" diye tanımladığımız bu modelde</li>

                <li>Okul yönetimlerimizin belirlediği ürünler arasından istediklerinizi seçebilmeniz.</li>

                <li>Zaman tasarrufu</li>

                <li>
                  Yanlış ürün, baskısı eski kitaplar, orijinal olmayan ürün vs .. bu hataları önleyebilmek için
                  çalışıyoruz
                </li>

                <li>Taksit ile alışveriş imkanı</li>

                <li>
                  Müfredat değişiklikleri sonucu "baskısı geciken" - "iptal olan ürünler" ile ilgili okul yönetimi ile
                  velilerimiz arasında iletişim köprüsü olmak.
                </li>
              </ul>
            </div>
          ),
        },
      },
      {
        title: 'Sıkça Sorulan Sorular',
        modalConfig: {
          title: 'Sıkça Sorulan Sorular',
          content: (
            <>
              <div>
                Okulsepeti olarak tüm çabamıza rağmen sizlere tek seferde kargo gönderimi sağlayamadığımız durumlar
                oluşmaktadır. Amacımız, sizlerin bu alışveriş için fazla zaman harcamanızı engellemek ve eksiklerinizi
                takip ederek en kısa sürede sizlere ulaştırmaktır.
              </div>
              <Divider />
              <Collapse accordion>
                <Panel header="Siparişim kaç gün içerisinde kargoya verilir?" key="1">
                  <p>
                    Siparişleriniz üç iş günü içerisinde kargoya teslim edilmektedir. Paketiniz kargoya teslim
                    edildiginde cep telefonunuza bir bilgilendirme SMS’i gönderilmektedir.
                  </p>
                </Panel>
                <Panel
                  header="Siparişimizde olduğu halde henüz gönderilmemiş ürünlerimin neler olduğunu ve gönderilmeme sebeplerini nereden takip edebilirim?"
                  key="2"
                >
                  <p>
                    Bu durumda size gönderilen paketin üzerinde irsaliye ile birlikte gönderilen Eksik Bildirim
                    Formu’nda ürünlerin hangi ürünlerin hangi sebeplerle gönderilemediğinin bilgisi yer almaktadir. Bu
                    bilgi aynı zamanda sitemizin siparişlerim bölümünden de takip edilebilir(Sistem güncellemesi
                    yapılması gerekli). Son olarak siparişiniz ile ilgili herhangi bir sevk oluşturulduğunda mail
                    adresinize son eksik ürünlerin güncel halini içeren bir mail de gönderilmektedir(Sistem güncellemesi
                    yapılması gereklidir).
                  </p>
                </Panel>
                <Panel header="Eksik Türkçe kaynak kitaplarım ne zaman gönderilecek?" key="3">
                  <p>
                    Türkçe kaynak kitapların gönderilmemesinin en önemli nedeni müfredat değişikliği sebebi ile geç
                    basılan kitaplardır. Bu durumda yapılan satış kesinlikle okulunuzun bilgisi ve onayı ile
                    gerçekleşmektedir ve kitabın basılacağı tarih olarak yayınevinden bildirilen tarih ilgili
                    öğretmenleriniz tarafından kabul edilmiş bir tarihtir ve buna göre ders işlenmektedir. Bu durumda
                    kitabın basım tarihi tarafımızdan çok sıkı bir şekilde takip edilmekte ve ürün çıkar çıkmaz ilgili
                    öğrencilere gönderilmektedir. Böylece kitapların ne zaman çıkacağının takip zorluğunu sizlere
                    yaşatmadan çözüme kavuşturmaktayız. ÖNEMLİ NOT: Bazı durumlarda beklenen kitabın bir başkası
                    tarafından piyasadan temin edildiği yönünde bilgilerle karşılaşabilirsiniz. Bu durum çok büyük
                    olasılıkla söz konusu kitabın eski basımının piyasada satılmasından kaynaklı oldugu bilinmelidir.
                    Unutmayın ki bir kitap piyasaya çıkmışsa mutlaka size gönderilecektir. Eksik ürün gönderimlerinde
                    ayrıca bir kargo ücreti alınmamaktadır.
                  </p>
                </Panel>
                <Panel header="Eksik Türkçe okuma kitaplarım ne zaman gönderilecek?" key="4">
                  <p>
                    Türkçe okuma kitabının eksik gönderilme durumu, bir kitabın baskısının tükenmesi ve yeni baskı
                    tarihinin öğretmeniniz tarafından kitapla ilgili işleyeceği dersin tarihi ile uyumlu olması ile
                    listede yer almasını onaylaması durumlarında karşılaşılan bir durumdur. Gerek sipariş detaylarında
                    görebileceğiniz, gerekse mail ve evinize gelen koli üzerinde yer alan Eksik Bildirim Formunda da
                    belirttiğimiz kitabın yayın evi tarafından bildirilen basım tarihi, tarafımızca hassasiyetle takip
                    edilecek ve ürün çıktığı gibi sizlere ulaştırılacaktır. ÖNEMLİ NOT: Bazı durumlarda belirtilen kitap
                    yayınevinde tükenmiş olmasina rağmen bazı perakende noktalarının raflarında tek tük bulunabilir.
                    Ancak okulunuz öğrenci sayısı kadar temin edilemediği için bizde olmaması doğaldır. Sınıfın
                    tamamının ürünü bulması mümkün olmayacağından öğretmeniniz yayınevinin yeni baskısına göre hareket
                    edecektir. Dolayısı ile bu size bir dezavantaj yaratmayacaktır. Eksik ürün gönderimlerinde ayrıca
                    bir kargo ücreti alınmamaktadır.
                  </p>
                </Panel>
                <Panel header="Eksik yabancı dil kitaplarım ne zaman gönderilecek?" key="5">
                  <p>
                    Bu durum genellikle ithalat gecikmesinden kaynaklanmaktadır. Ithalatçı firmalar ile çok sık diyalog
                    ve işi hızlandırma adına alınabilecek tüm tedbirleri almaya çalışmaktayız. Konu ilgili öğretmeninize
                    aktarılmış olup kendileri ile birlikte hareket edilmektedir. Söz konusu kitap çoğunlukla hiçbir
                    ögrencide bulunmamaktadir. Eksik ürün gönderimlerinde ayrıca bir kargo ücreti alınmamaktadır.
                  </p>
                </Panel>
                <Panel header="Eksik kırtasiye ürünlerim ne zaman gönderilecek?" key="6">
                  <p>
                    Bu durum genellikle anlık stok sorunundan kaynaklıdır ve en kısa sürede gönderilecektir. Bu yöndeki
                    acil taleplerinizi bilgi@okulsepeti.com.tr adresine göndereceğiniz bir mail ile bizlere iletmeniz
                    halinde detaylı bilgi verilecek işlem gereği yapılacaktır. Eksik ürün gönderimlerinde ayrıca bir
                    kargo ücreti alınmamaktadır.
                  </p>
                </Panel>
                <Panel
                  header="Siparişlerim adresime ulaştı .İrsaliyede yer almasına rağmen paketimizden çıkmayan ürünler bulunmaktadır, ne yapmalıyım?"
                  key="7"
                >
                  <p>
                    Eksik olduğunu tespit ettiğiniz ürün, sipariş ile ilgili talep-görüş ve şikayetlerinizi
                    bilgi@okulsepeti.com.tr adresine iletmenizi rica edeceğiz. Size en kısa sürede cevap verilecektir.
                    ÖNEMLİ NOT: İrsaliyenizde yer almasına rağmen kolinizde yer almayan bazı ürünler aslında sizin
                    adınıza okula teslim edilecek ürünler olabilir. Örneğin yıl içerisinde yapılacak sınav ücretleri
                    gibi. Bu ürün belirlenen tarihlerde parça parça okulunuza teslim edilmektedir. Ayrıca ebadının
                    büyüklüğünden ya da hassasiyetinden dolayı kargoda zarar görmesi muhtemel bazı ürünleri de okula
                    öğrenci adına teslim etmekteyiz. Her iki durumda olan ürünleri de paketinizin üzerinde yer alan ve
                    ayrıca üyeliğinizden de takip edebileceğiniz ‘’Eksik Ürün Bildirim Formu’’nda bu ürünlerle ilgili
                    açıklamalar yer almaktadir.
                  </p>
                </Panel>
                <Panel
                  header="Siparişlerim adresime ulaştı .Paketimde kırık ve/veya hasarli-ı ürünler bulunmaktadır, ne yapmalıyım?
                  "
                  key="8"
                >
                  <p>
                    Eksik olduğunu tespit ettiğiniz ürün, sipariş ile ilgili talep-görüş ve şikayetlerinizi
                    bilgi@okulsepeti.com.tr adresine iletmenizi rica edeceğiz. Size en kısa sürede cevap verilecektir.
                  </p>
                </Panel>
                <Panel
                  header="İade etmek istediğim ürünler var. İadeler nasıl yapılmaktadır?
                  "
                  key="9"
                >
                  <p>
                    Sitemiz Hesabım-Siparişlerim bölümünden iade etmek istediğiniz ürünleri seçerek iade kodu almanız
                    gerekmektedir. İade kodu ile birlikte ürünlerinizi Yurtiçi Kargo aracılığıyla tarafımıza ücretsiz
                    olarak gönderebilirsiniz. İadeniz tarafımıza ulaştığında alışveriş yapmış olduğunuz kartınıza ücret
                    iadesi yapılacaktır.
                  </p>
                </Panel>
                <Panel
                  header="Ürün iade edildikten sonra tutar iadesi nasıl yapılmaktadır?
                  "
                  key="10"
                >
                  <p>
                    İade ürünler depoya ulaştıktan sonra müşteriden teyit alınarak sisteme işlenir ve iade süreci
                    başlatılır.
                  </p>
                </Panel>
                <Panel
                  header="Kredi kartı ile yapılan alışverişlerde iade işlemi yapıldıktan sonra Banka uygulaması gereği kredi kartı iadelerinde bankanız tutarı 3 iş gününde kartınıza yansıtmış olacaktır.
                  "
                  key="11"
                >
                  <p>
                    Kapıda ödeme veya havale ile yapılan ödemelerde müşteriden Iban bilgisi talep edilir. Hesaba iade
                    işlemi 7 gün içerisinde gerçekleştirilir.
                  </p>
                </Panel>
                <Panel header="Hangi ödeme yöntemlerini kullanabilirim?" key="12">
                  <p>
                    Kredi Kartı - Peşin Kredi Kartı - Taksitli (Kuveyt Türk kartına taksit yapılmamakta. Diğer banka
                    kartları 3 taksite kadar vade farkı uygulamamaktadır.) Havale (Akbank-İs Bankası-Yapı
                    Kredi-Garanti-Finansbank)
                  </p>
                </Panel>
                <Panel header="Sipariş verdikten sonra siparişe yeni ürün ekleyebilir miyim?" key="13">
                  <p>
                    Maalesef bu islem yapılamamaktadır. Yeni talep edilen ürün için tekrardan sipariş oluşturulmalıdır.
                  </p>
                </Panel>
                <Panel header="Sipariş verdiğim ürünlerin bazıları neden okula teslim edilmekte?" key="14">
                  <p>
                    50*50 ve üstü ölçülerde bulunan Tuval kargoda hasar görmemesi adına okula teslim edilmektedir.
                    İlgili ders işleneceği tarihte öğrenci adı ile okula teslim edilmektedir. Bazı hassas ürünler,
                    örneğin strafor objeler, 70x100 cm. Kraft kağıt gibi, yine kargo ile gönderimde hasar görecekleri
                    için adınıza okula teslim edilmektedir. Sınav Ücreti ve KAP Denemeleri gibi ürünler yıl içerisinde
                    periyodik zamanlarda kullanılacagı için Okul Yönetimi bilgisinde öğrenci adı ile aralıklarla okula
                    teslim edilmektedir.
                  </p>
                </Panel>
                <Panel header="Okula teslim ürünlerin teslimi hakkında nasıl bilgi alabiliriz?" key="15">
                  <p>
                    Ürünler okula teslim edildiğinde bilgi@okulsepeti.com.tr mail adresinden hangi ürünün kime teslim
                    edildiğine dair bilgilendirme maili gönderilmektedir.
                  </p>
                </Panel>
                <Panel
                  header="Siparişte olan bir ürün (yayınevi-tedarikçi kaynaklı veya okul yönetimi talebiyle) iptal edildiğinde veya değiştirildiğinde nasıl bilgim olacak?"
                  key="16"
                >
                  <p>
                    Siparişinizde bulunan kitap, test, materyaller, yayınevi, tedarikçi veya Okul Yönetimi talebiyle
                    iptal veya değişim kararı verildiğinde “ bilgi@okulsepeti.com.tr” adresinden detaylı bilgilendirme
                    yapılmaktadır. Aynı bilgilendirme ile tutar iadesi yapılmasını gerektiren durumlar da bildirilecek
                    ve iade makbuzunuz gönderilecektir.
                  </p>
                </Panel>
              </Collapse>
            </>
          ),
        },
      },
      {
        title: 'Satış Sözleşmesi',
        modalConfig: {
          title: 'Satış Sözleşmesi',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: okul?.okul_satis_sozlezmesi || `<div>
                            

          <p><strong>SATIŞA İLİŞKİN ÖN BİLGİLENDİRME BELGESİ VE SÖZLEŞME METNİ</strong><br>
          <strong>MADDE 1 - TARAFLAR</strong></p>
          
          <p><strong>SATICI</strong><br>
          <br>
          Satıcı: Okul Sepeti Pazarlama A.Ş. Adresi: İnönü Cad. No: 15/3 Sahrayıcedid Kadıköy - İstanbul Telefon: 0850 333 22 02 Web Adresi: <a href="https://okulsepeti.com.tr/" target="_blank" rel="noreferrer">okulsepeti.com.tr</a> E-Posta: <a href="mailto:bilgi@okulsepeti.com.tr">bilgi@okulsepeti.com.tr</a></p>
          
          <p><strong>ALICI</strong><br>
          <br>
          Adı/Soyadı/Ünvanı :<br>
          Adresi :<br>
          Telefon :<br>
          E-Posta :</p>
          
          <p><strong>MADDE 2- KONU</strong></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">İşbu sözleşmenin konusu, ALICI' nın SATICI' ya ait</span><a href="https://okulsepeti.com.tr/"  target="_blank"  rel="noreferrer"><span style="font-size:10.0pt;font-family:
          &quot;Arial&quot;,sans-serif;color:#0782C1">okulsepeti.com.tr</span></a><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:#333333">internet sitesi üzerinden elektronik ortamda yaptığı aşağıda nitelikleri ve satış fiyatı belirtilen ürünün satışı ve teslimi ile ilgili olarak 4077 sayılı Tüketicilerin Korunması Hakkındaki Kanun ve Mesafeli Sözleşmeler Uygulama Esas ve Usulleri Hakkında Yönetmelik hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">ALICI, satışa konu ürünlerin temel nitelikleri, satış fiyatı, ödeme şekli, teslimat koşulları vs. satışa konu ürün ile ilgili tüm ön bilgiler ve cayma hakkı konusunda bilgi sahibi olduğunu ve bu ön bilgileri elektronik ortamda teyid ettiğini ardından işbu sözleşmeye konu ürünü sipariş verdiğini kabul ve beyan eder.</span><a href="https://okulsepeti.com.tr/"  target="_blank"  rel="noreferrer"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:#0782C1">okulsepeti.com.tr</span></a><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:#333333">internet sitesinde yer alan ön bilgiler ve fatura işbu sözleşmenin ayrılmaz bir parçasıdır.<o:p></o:p></span></p>
          
          <p><strong>MADDE 3- TESLİMAT VE ÜCRETİ</strong></p>
          
          <p>Ürün Teslimat Ücreti :.................... TL' dir. Bu ücret ALICI tarafından ödenir.<br>
          Teslimat Adresi :<br>
          Teslim Edilecek Kişi :<br>
          Fatura Adresi :</p>
          
          <p style="text-align:justify;line-height:115%"><span style="font-size:10.0pt;
          line-height:115%;font-family:&quot;Arial&quot;,sans-serif;color:#333333">Ön siparişler hariç, Sözleşme konusu ürün, yasal 30 günlük süreyi aşmamak koşulu ile her bir ürün için ALICI' nın yerleşim yerinin uzaklığına bağlı olarak internet sitesinde teslimat ve sipariş bölümünde açıklanan sürede ALICI veya gösterdiği adresteki kişi/kuruluşa teslim edilir. Bu süre daha önceden yazılı olarak bildirilmek koşuluyla en fazla 10 gün uzatılabilir.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">SATICI, sözleşme konusu ürünün sağlam, eksiksiz, siparişte belirtilen niteliklere uygun ve varsa garanti belgeleri ve kullanım kılavuzları ile teslim edilmesinden sorumludur.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">Sözleşme konusu ürün, ALICI' dan başka bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun teslimatı kabul etmemesinden SATICI sorumlu tutulamaz.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">Sözleşme konusu ürünün teslimatı için irsaliyeli faturanın satıcıya veya ürünü teslim alacak 3. (Üçüncü) şahsa ulaştırılmış olması ve bedelinin ALICI' nın tercih ettiği ödeme şekli ile ödenmiş olması şarttır. Herhangi bir nedenle ürün bedeli ödenmez veya banka kayıtlarında iptal edilir ise, SATICI ürünün teslimi yükümlülüğünden kurtulmuş kabul edilir.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">Ürünün tesliminden sonra ALICI' ya ait kredi kartının ALICI' nın kusurundan kaynaklanmayan bir şekilde yetkisiz kişilerce haksız veya hukuka aykırı olarak kullanılması nedeni ile ilgili banka veya finans kuruluşunun ürün bedelini SATICI' ya ödememesi halinde, ALICI kendisine teslim edilmiş olması kaydıyla ürünü 3 gün içinde SATICI' ya göndermekle yükümlüdür. Bu takdirde kargo ücreti ALICI' ya aittir.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">ALICI, sözleşme konusu ürünü teslim almadan önce muayene edecek ezik, kırık, ambalajı yırtılmış vb. hasarlı ve ayıplı ürünü kargo şirketinden teslim almayacaktır. Teslim alınan ürünün hasarsız ve sağlam olduğu kabul edilecektir. Teslimden sonra ürünün özenle korunması borcu, alıcıya aittir. Cayma hakkı kullanılacaksa ürün kullanılmamalıdır.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">Garanti belgesi ile satılan ürünlerden olan veya garanti belgesi olmayan ürünlerden arızalı veya bozuk olan ürünler, garanti şartları içinde gerekli onarımın yapılması için SATICI' ya gönderilebilir, bu takdirde kargo giderleri SATICI tarafından karşılanacaktır.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">SATICI, sözleşme konusu ürünün tesliminin imkansızlaştığını ileri sürerek, sözleşme konusu yükümlülüklerini yerine getiremiyorsa, bu durumu sözleşmeden doğan ifa yükümlülüğü süresi dolmadan ALICI’ ya bildirir ve ödenmiş olan tüm bedeli 10 gün içinde ALICI’ ya iade eder.<o:p></o:p></span></p>
          
          <p><strong>MADDE 4- SÖZLEŞMEYE KONU ÜRÜNÜN ÖZELLİKLERİ</strong></p>
          
          <p><span style="text-align: justify; font-size: 10pt; font-family: Arial, sans-serif;">Ürün/Ürünlerin Cinsi ve türü, Miktarı, Marka/Modeli, Rengi ve Tüm Vergiler Dahil Satış Bedeli</span><a href="https://okulsepeti.com.tr/" style="text-align: justify;" target="_blank"  rel="noreferrer"><span style="font-size: 10pt; font-family: Arial, sans-serif;">okulsepeti.com.tr</span></a><span style="text-align: justify; font-size: 10pt; font-family: Arial, sans-serif;">web adresinde yayınlanan ürün tanıtım bilgilerinde ve bu sözleşmenin ayrılmaz bir parçası olan faturada belirtildiği gibidir.</span></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;color:#333333"><o:p></o:p></span></p>
          
          <p><strong>MADDE 5-SATIŞ FİYATI</strong></p>
          
          <p><span style="font-size: 10pt; font-family: Arial, sans-serif;">Tüm Vergiler Dahil Peşin Satış Fiyatı: Fatura içeriğinde mevcuttur.<b><o:p></o:p></b></span></p>
          
          <p><span style="font-size: 10pt; line-height: 107%; font-family: Arial, sans-serif;">Peşinat Miktarı : Fatura içeriğinde mevcuttur.<br>
          Faiz Miktarı : Ödemler kredi kartı/havale yolu ile peşin olarak yapılacağından faiz uygulanmayacaktır.<br>
          Vadeye göre Faiz ile Birlikte Ödenecek Toplam Satış Fiyatı : Fatura içeriğinde mevcuttur.<br>
          Ödeme Şekli : Havale/Kredi Kartı<br>
          Faizin Hesaplandığı Yıllık Faiz Oranı: Ödemler kredi kartı/havale yolu ile peşin olarak yapılacağından faiz uygulanmayacaktır.</span></p>
          
          <p><strong>ÖDEME PLANI:</strong></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">ALICI’ nın, kredi kartı ile ve taksitle alışveriş yapması durumunda siteden seçmiş olduğu taksit biçimi geçerlidir. Taksitlendirme işlemlerinde, ALICI ile kart sahibi banka arasında imzalamış bulunan sözleşmenin ilgili hükümleri geçerlidir. Kredi kartı ödeme tarihi banka ile ALICI arasındaki sözleşme hükümlerince belirlenir. ALICI, ayrıca bankanın gönderdiği hesap özetinden taksit sayısını ve ödemelerini takip edebilir.<o:p></o:p></span></p>
          
          <p><strong>GECİKME FAİZİ :</strong>Ödeme peşin ya da kredi kartı ile peşin olarak yapılacağı için SATICI tarafından gecikme faizi uygulanmaz.</p>
          
          <p><strong><span style="font-size: 10pt; font-family: Arial, sans-serif;">MADDE 6- CAYMA HAKKI</span></strong></p>
          
          <p style="text-align:justify"><span style="font-size: 10pt; font-family: Arial, sans-serif;">ALICI, sözleşme konusu ürünün kendisine veya gösterdiği adresteki kişi/kuruluşa tesliminden itibaren 7 gün içinde cayma hakkını kullanabilir. Cayma hakkının kullanılması için bu süre içinde SATICI' ya faks, email veya telefon ile bildirimde bulunulması, ürünün kullanılmamış olması ve ürünün 7. madde de belirtilen ürünlerden olmaması şarttır. Bu hakkın kullanılması halinde, 3. kişiye veya ALICI' ya teslim edilen ürüne ilişkin fatura aslının iadesi zorunludur. Cayma hakkına ilişkin ihbarın ulaşmasını takip eden 7 gün içinde ürün bedeli ALICI' ya iade edilir ve 20 günlük süre içinde ürün iade alınır. Fatura asli gönderilmez ise KDV ve varsa sair yasal yükümlülükler iade edilemez. Cayma hakkı nedeni ile iade edilen ürünün kargo bedeli SATICI tarafından karşılanır.<o:p></o:p></span></p>
          
          <p><span style="font-size: 10pt; line-height: 107%; font-family: Arial, sans-serif;">ALICI’nın hiçbir hukuki ve cezai sorumluluk üstlenmeksizin ve hiçbir gerekçe göstermeksizin malı teslim aldığı veya sözleşmenin imzalandığı tarihten itibaren yedi gün içerisinde malı veya hizmeti reddederek sözleşmeden cayma hakkının var olduğunu ve cayma bildiriminin satıcı veya sağlayıcıya ulaşması tarihinden itibaren malı geri almayı taahhüt ederiz.</span></p>
          
          <p><strong>MADDE 7- CAYMA HAKKI KULLANILAMAYACAK ÜRÜNLER</strong></p>
          
          <p style="text-align:justify"><span style="font-size: 10pt; font-family: Arial, sans-serif;">Niteliği itibarıyla iade edilemeyecek ürünler, hızla bozulma ve son kullanma tarihi geçen ürünler, tek kullanımlık ürünler, kopyalanabilir her türlü yazılım ve programlardır. Aşağıdaki ürünlerde cayma hakkının kullanılması, ürünün ambalajının açılmamış, bozulmamış ve ürünün kullanılmamış olması şartına bağlıdır.<o:p></o:p></span></p>
          
          <p><span style="font-size: 10pt; line-height: 107%; font-family: Arial, sans-serif;">-Her türlü yazılım ve programlar<br>
          -DVD, VCD, CD ve kasetler<br> 
          -Bilgisayar ve kırtasiye sarf malzemeleri</span></p>
          <p>Müşteri, okul ile yapılan anlaşma neticesinde paket olarak almış olduğu ürünleri aldığı şekilde paket olarak iade etme hakkına sahiptir. Tüketiciye paket olarak satılan ürünlerin tüketiciye tek tek satışı yoktur.</p>
          
          <p><strong>MADDE 8- GÜVENLİK-GİZLİLİK, KİŞİSEL BİLGİLER VE FİKRİ-SINAİ HAKLAR İLE İLGİLİ KURALLAR</strong></p>
          
          <p style="text-align:justify"><span style="font-size: 10pt; font-family: Arial, sans-serif;">ALICI tarafından İNTERNET SİTESİ'nde girilen bilgilerin ve işlemlerin güvenliği için gerekli önlemler, SATICI tarafındaki sistem altyapısında, bilgi ve işlemin mahiyetine göre günümüz teknik imkanları ölçüsünde alınmıştır. Bununla beraber, söz konusu bilgiler ALICI cihazından girildiğinden ALICI tarafında korunmaları ve ilgisiz kişilerce erişilememesi için, virüs ve benzeri zararlı uygulamalara ilişkin olanlar dahil, gerekli tedbirlerin alınması sorumluluğu ALICI ’ya aittir.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size: 10pt; font-family: Arial, sans-serif;">ALICI’ nın sair suretle verdiği kişisel veri ve ticari elektronik iletişimlerine dair izin-onaylarının yanı sıra ve teyiden; ALICI’nın İNTERNET SİTESİ'ne üyeliği ve alışverişleri sırasında edinilen bilgileri SATICI tarafından muhtelif ürün/hizmetlerin sağlanması ve her türlü bilgilendirme, reklam-tanıtım, iletişim, promosyon, satış, pazarlama, mağaza kartı ve üyelik uygulamaları amaçlı yapılacak elektronik ve diğer ticari-sosyal iletişimler için, belirtilenler ve halefleri nezdinde süresiz olarak veya öngörecekleri süre ile kayda alınabilir, basılı/manyetik arşivlerde saklanabilir, gerekli görülen hallerde güncellenebilir, paylaşılabilir, aktarılabilir, transfer edilebilir, kullanılabilir ve sair suretlerle işlenebilir. Bu veriler ayrıca kanunen gereken durumlarda ilgili Merci ve Mahkemelere iletilebilir. ALICI kişisel olan-olmayan mevcut ve yeni bilgilerinin, kişisel verilerin korunması hakkında mevzuat ile elektronik ticaret mevzuatına uygun biçimde yukarıdaki kapsamda kullanımına, paylaşımına, işlenmesine ve kendisine ticari olan-olmayan elektronik iletişimler ve diğer iletişimler yapılmasına muvafakat ve izin vermiştir.<o:p></o:p></span></p>
          
          <p style="text-align:justify"><span style="font-size: 10pt; font-family: Arial, sans-serif;">ALICI, SATICI'ya belirtilen iletişim kanallarından ulaşarak veri kullanımı-işlenmelerini ve/veya aynı kanallardan ulaşarak ya da kendisine gönderilen elektronik iletişimlerdeki red hakkını kullanarak iletişimleri her zaman için durdurabilir. ALICI’nın bu husustaki açık bildirimine göre, kişisel veri işlemleri ve/veya tarafına iletişimler yasal azami süre içinde durdurulur; ayrıca dilerse, hukuken muhafazası gerekenler ve/veya mümkün olanlar haricindeki bilgileri, veri kayıt sisteminden silinir ya da kimliği belli olmayacak biçimde anonim hale getirilir. ALICI isterse kişisel verilerinin işlenmesi ile ilgili işlemler, aktarıldığı kişiler, eksik veya yanlış olması halinde düzeltilmesi, düzeltilen bilgilerin ilgili üçüncü kişilere bildirilmesi, verilerin silinmesi veya yok edilmesi, otomatik sistemler ile analiz edilmesi sureti ile kendisi aleyhine bir sonucun ortaya çıkmasına itiraz, verilerin kanuna aykırı olarak işlenmesi sebebi ile zarara uğrama halinde giderilmesi gibi konularda SATICI'ya her zaman yukarıdaki iletişim kanallarından başvurabilir ve bilgi alabilir. Bu hususlardaki başvuru ve talepleri yasal azami süreler içinde yerine getirilecek yahut hukuki gerekçesi tarafına açıklanarak kabul edilmeyebilecektir.</span><span style="font-family: Arial, sans-serif; font-size: 10pt;"></span></p>
          
          <p style="text-align:justify"><span style="font-size: 10pt; font-family: Arial, sans-serif;">INTERNET SİTESİ'ne ait her türlü bilgi ve içerik ile bunların düzenlenmesi, revizyonu ve kısmen/tamamen kullanımı konusunda; tüm fikri-sınai haklar ve mülkiyet hakları SATICI'ya aittir.<o:p></o:p></span></p>
          
          <p><span style="font-size: 10pt; line-height: 107%; font-family: Arial, sans-serif;">SATICI yukarıdaki konularda gerekli görebileceği her türlü değişikliği yapma hakkını saklı tutar; bu değişiklikler SATICI tarafından INTERNET SİTESİ'nden veya diğer uygun yöntemler ile duyurulduğu andan itibaren geçerli olur</span></p>
          
          <p></p>
          
          <p><strong>MADDE 9- TEMERRÜD</strong></p>
          
          <p style="text-align:justify"><span style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
          color:#333333">ALICI, kredi kartı ile yapmış olduğu işlemlerinde temerrüde düşmesi halinde kart sahibi bankanın kendisi ile yapmış olduğu kredi kartı sözleşmesi çerçevesinde faiz ödeyecek ve bankaya karşı sorumlu olacaktır. Bu durumda ilgili banka hukuki yollara başvurabilir; doğacak masrafları ve vekâlet ücretini ALICI’ dan talep edebilir. Borçlunun temerrüde düşmesi halinde, borçlu borcun gecikmeli ifasından dolayı alacaklının oluşan zarar ve ziyanını ödemeyi kabul eder.<o:p></o:p></span></p>
          
          <p><strong>MADDE 10- YETKİLİ MAHKEME</strong><br>
          İşbu sözleşmenin uygulanmasında, Ticaret Bakanlığınca ilan edilen değere kadar Tüketici Hakem Heyetleri ile Alıcının ve Satıcının Yerleşim yerlerindeki Tüketici Mahkemeleri yetkilidir.</p>
          
          <p><strong>MADDE 11- SÖZLEŞMENİN DÜZENLENDİĞİ TARİH :</strong></p>
          
          <p>SATICI : Okul Sepeti Pazarlama A.Ş.<br>
          <br>
          ALICI<br>
          Adı/Soyadı :<br>
          Tarih :</p>
                                  </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'Gizlilik ve Güvenlik',
        modalConfig: {
          title: 'Gizlilik ve Güvenlik',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: `<div>
          <p style="margin: 0px 0px 11.2px; font-size: 12px; line-height: normal; font-family: Arial; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;"><b>Alışveriş Güvenliği ve SSL Sertifikası</b></span></p>

<p style="margin: 0px 0px 11.2px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;">Sitemizde kredi kartınızla yapacağınız tüm alışverişleriniz Geotrust RapidSSL sertifikasıyla güvence altına alınmıştır. Kart bilgileriniz 2048 bit koruma ile şifrelenerek iletilmektedir. SSL (Secure Soket Layer) bağlantısının hangi durumda aktif olduğunu, sipariş işlemleri sırasında kart bilgilerinizi girdiğiniz sayfamıza geçtiğiniz sırada, tarayıcınızın adres çubuğunun hemen yanında görüntülenecek olan kilit simgesinden anlayabilirsiniz.</span></p>

<p style="margin: 0px 0px 11.2px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;">Kredi Kartı bilgilerinizi girdiğiniz sayfanın sağ alt köşesinde bulunan kilit resmi bu sayfanın SSL ile şifrelendiğini gösterir ve üzerine tıkladığınızda şifrelemenin hangi firmaya ait olduğunu belirtir.Web sitemize kayıt olurken kullandığınız üyelik ve kişisel bilgileriniz gizli tutulmakta olup sizin onayınız dışında hiç kimseyle paylaşılamaz. SSL yazılımları , müşteri-işletme-banka arasındaki bilgi akışının,çözülme ihtimali matematiksel olarak çok düşük ve teknik açıdan zor olan 64 bit teknolojileriyle şifreli olarak yapılmasını sağlamaktadır</span></p>

<p style="margin: 0px 0px 11.2px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;"><b>ÖDEME GÜVENLİĞİ</b></span></p>

<p style="margin: 0px 0px 11.2px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;">Ödemeleriniz sırasında optimum güvenliğin sağlanması için, ödeme trafiğini sağlamada "3D Secure" sistemleri kullanmaktayız. Ödemenin gerçekleştirilmesi için gerekli olan bilgiler (Örnek: Kredi kart numarası ) okulsepeti.com.tr tarafından saklanmamaktadır. Bu bilgiler aracısız olarak anlaşmalı olduğumuz bankalara aktarılmaktadır. Bilgilerin aktarımı SSL-Tabanlı 2048-Bit kodlama ile gerçekleştirilmektedir.</span></p>

<p style="margin: 0px 0px 11.2px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;"><b>BİLGİ GİZLİLİĞİ</b></span></p>

<p style="margin: 0px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;">İstisnasız tüm müşterilerimize ait kişisel bilgiler, kati suretle gizlilik içerisinde alınmaktadır. Bununla beraber iş sürecimizin sorunsuz ilerlemesi için müşteri bilgilerimizin saklanması ve kullanımı kısmen gereklidir.Siparişlerin en iyi şekilde karşılanması için, işin tamamlanmasına yönelik bilgiler okulsepeti.com.tr‘de saklanır ve gerektiğinde teslimat sırasında lojistik ve kargo firmalarına aktarılır. Bunun haricinde kişisel bilgiler kesinlikle 3. şahıslara iletilmemektedir. </span><span style="color: rgb(50, 51, 51); font-family: Verdana; font-size: 14px; line-height: normal; -webkit-text-stroke-color: rgb(50, 51, 51);">okulsepeti.com.tr</span><span style="font-size:14px;">müşteri bilgilerini yeni satış kampanyaları hakkında bilgi vermek, ürün ve hizmet sunumunu iyileştirmek üzere saklar ve kullanır.</span></p>

<p style="margin: 0px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"></p>

<p style="margin: 0px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"></p>
      </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'İade ve Değişim',
        modalConfig: {
          title: 'İade ve Değişim',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: `<div>
            <p style="margin: 0px 0px 11.2px; font-size: 12px; line-height: normal; font-family: Arial; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;"><b>İade</b></span></p>

<p style="margin: 0px 0px 11.2px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;">İnternet sitemizde almış olduğunuz ürünlerde bir sorun olması durumunda, teslimat sonrasında iade edebilirsiniz. Ürünlerin iadesi için belirtilen yasal süre 14 gündür ancak biz Okul Sepeti Pazarlama A.Ş. olarak internet sitemizden satın aldığınız ürününüzü tekrar satılabilir özelliğini yitirmemiş olması kaydıyla teslimat tarihinden itibaren toplam 30 gün içerisinde faturanız ile iade edebilir veya değişimini sağlayabilirsiniz. Havale ile vermiş olduğunuz bir siparişi iade etmek istediğinizde ürünü kargoya teslim ettikten sonra 0850 333 22 02 numaralı telefondan veya bilgi@okulsepeti.com.tr dentarafımıza ulaşarak iadenin yapılacağı banka hesap bilginizi ya da IBAN numaranızı iletmeniz gereklidir. Ya da iade etmek istediğin ürünü Yurtiçi kargoya teslim ederken içerisine iade nedeninizi ve hesap veya IBAN bilginizi paylaşabilirsiniz.</span></p>


<p style="margin: 0px 0px 11.2px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"></p>

<p style="margin: 0px 0px 11.2px; font-size: 12px; line-height: normal; font-family: Arial; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;"><b>Değişim</b></span></p>

<p style="margin: 0px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"><span style="font-size:14px;">Değişim bulunmamaktadır. Siparişinizde bulunan ürünlerde sorun yaşamanız durumunda elinizdeki ürünü iade etmeniz ve öğrencimizin ihtiyacını kısa sürede karşılamak amacıyla doğru ürün için yeni sipariş vermeniz gerekmektedir.</span></p>

<p style="margin: 0px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"></p>

<p style="margin: 0px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"></p>

<p style="margin: 0px; -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"></p>

<p style="margin: 0px; font-size: 9px; line-height: normal; font-family: Verdana; color: rgb(50, 51, 51); -webkit-text-stroke-color: rgb(50, 51, 51); -webkit-text-stroke-width: initial;"></p>
        </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'Bize Ulaşın',
        modalConfig: {
          title: 'Bize Ulaşın',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: `<div>
          <p>Okul Sepeti Pazarlama A.Ş.</p>

<p><strong style="box-sizing: border-box; margin: 0px; padding: 0px; color: rgb(147, 147, 147); font-family: 'Segoe UI', Frutiger, 'Frutiger Linotype', 'Dejavu Sans', 'Helvetica Neue', Arial, sans-serif; font-size: 14px; line-height: 20px; text-align: justify; -webkit-text-stroke-color: rgb(50, 51, 51);"><font color="#777777" face="Segoe UI, Frutiger, Frutiger Linotype, Dejavu Sans, Helvetica Neue, Arial, sans-serif" style="box-sizing: border-box; margin: 0px; padding: 0px;"><span style="box-sizing: border-box; margin: 0px; padding: 0px;">Adres    : Emek Mah. Nato Yolu Cad. No:280 Kat:1 Sancaktepe-İstanbul </span></font></strong></p>

<p><b style="font-size: 14px; line-height: 20px; -webkit-text-stroke-color: rgb(50, 51, 51); color: rgb(119, 119, 119); font-family: &quot;Segoe UI&quot;, Frutiger, &quot;Frutiger Linotype&quot;, &quot;Dejavu Sans&quot;, &quot;Helvetica Neue&quot;, Arial, sans-serif; text-align: justify;">bilgi@okulsepeti.com.tr</b></p>

<p style="text-align: justify; "><font color="#777777" face="Segoe UI, Frutiger, Frutiger Linotype, Dejavu Sans, Helvetica Neue, Arial, sans-serif"><span style="font-size: 14px; line-height: 20px; -webkit-text-stroke-color: rgb(50, 51, 51);"><b>Tel       : 0850 333 22 02</b></span></font></p>
      </div>`,
              }}
            />
          ),
        },
      },
      {
        title: appContext.authState === AuthState.LOGGED_IN ? 'Hesabım' : 'Üyelik',
        onClick: () => {
          if (appContext.authState === AuthState.LOGGED_IN) {
            navigate(`/${AppRoutes.account.root}/${AppRoutes.account.myAccountInformation}`)
          } else {
            navigate(`/${AppRoutes.auth}`)
          }
          scrollToTop()
        },
      },
      {
        title: 'Sipariş Takibi',
        onClick: () => {
          if (appContext.authState === AuthState.LOGGED_IN) {
            navigate(`/${AppRoutes.account.root}/${AppRoutes.account.orders}`)
          } else {
            navigate(`/${AppRoutes.auth}`)
          }
          scrollToTop()
        },
      },
    ],
    [
      { title: <h2 className="font-ayarlama">KVKK</h2> },
      {
        title: 'Kişisel Verilerin Korunma Politikası',
        modalConfig: {
          title: 'Kişisel Verilerin Korunma Politikası',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: okul?.okul_kisisel_verilerin_korunmasi_kanunu || `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h1>Kişisel Verilerin Korunması ve İşlenmesi Politikası</h1>

<h2>1. Giriş</h2>

<h3>1.1. Politikanın Amacı</h3>

<p>6698 sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”) kapsamında<br>
OKULSEPETİ PAZARLAMA ANONİM ŞİRKETİ (“Şirket”) olarak, kişisel verilerin yasalara uygun olarak işlenmesi ve korunması en önemli önceliklerimiz arasındadır. Tüm planlama ve iş faaliyetlerimizde de aynı önceliği takip etmekteyiz. Bu çerçevede Kanun’un 10. maddesi gereğince sizleri aydınlatmak; kişisel verilerin işlenmesi ve korunması kapsamında uygulayacağımız bütün idari ve teknik tedbirleri bildirmek amacıyla işbu Kişisel Verilerin İşlenmesi ve Korunması Politikası’nı (“Politika”) sizlerin bilgisine sunarız.</p>

<p></p>

<p>Bu Politika’da Şirket tarafından, hangi verilerin kişisel veri olduğu, hangi kişisel verilerin saklandığı, kişisel verilerin korunmasına ilişkin alınan idari ve teknik tedbirler ile kişisel verilerin işlenmesinde, muhafaza edilmesinde, kişisel veri sahiplerinin aydınlatılması ve bilgilendirilmesinde, üçüncü kişilere aktarılması ve korunmasına ilişkin detaylı açıklamalara yer verilmektedir.</p>

<h3>1.2. Kapsamı</h3>

<p>İşbu Politika; müşterilerin, potansiyel müşterilerin, çalışan adaylarının, Şirket hissedarlarının, Şirket yetkililerinin, ziyaretçilerin, iş birliği içinde olunan şirketlerin çalışanları, hissedarları ve yetkililerinin ve üçüncü kişilerin otomatik olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla işlenen tüm kişisel verilerine ilişkindir. Bu kapsamda; tamamen veya kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla işlenen, Şirket’in müşterilerinin, potansiyel müşterilerinin, çalışanlarının, çalışan adaylarının, Şirket hissedarlarının, yetkililerinin, Şirket web sitelerimiz, Şirket e-ticaret siteleri ve Şirket tarafından işletilmekte olan mağaza ziyaretçilerinin, iş ortaklığı olan kurum çalışanlarının, hissedarlarının ve yetkililerinin ve üçüncü kişilerin rızası ile toplanan kişisel verilerine ilişkindir.</p>

<p>Kanun ve ilgili yasal mevzuat uyarınca veri sorumlusu olan Şirket, kişisel verilerin işlenmesi ve korunmasında benimsenen temel ilkeleri, kişisel verilerin korunmasına ilişkin alınan idari ve teknik tedbirler ile işlendikleri amaç için gerekli olan azami süreyi belirleme, silme, yok etme ve anonim hale getirme işlemlerine ilişkin usul ve esasları işbu Politika ile belirlemektedir.</p>

<p>İstatistiki değerlendirmeler veya çalışmalar için elde edilen kişisel veri içermeyen veriler gibi anonim hale gelmiş ve tanımlanamayan veriler ile tüzel kişilere ilişkin veriler kişisel veri olarak kabul edilmemekte olup, işbu Politika’ya tabi değildir.</p>

<p><br>
İşbu Politika, Şirket’in ve kontrolü altındaki iştiraklerinin gerçek kişi müşterileri ile Şirket ve kontrolü altındaki iştirakleri ile belirli bir çerçeve sözleşmesi olmayan diğer gerçek kişilere de uygulanmaktadır. Bu Politikada yer alan Şirket ifadeleri kurum ve kontrolü altındaki iştiraklerini de kapsayacaktır.</p>

<p></p>

<h3>1.3. Tanımlar</h3>

<table border="0" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td style="height:32px;">
<p><strong>İş Ortakları</strong></p>
</td>
<td style="width:493px;height:32px;">
<p>Şirket’in ticari faaliyetleri çerçevesinde sözleşmesel ilişkiler kapsamında ortaklık kurduğu kişiler</p>
</td>
</tr>
<tr>
<td style="height:31px;">
<p><strong>Açık Rıza</strong></p>
</td>
<td style="width:493px;height:31px;">
<p>Belirli bir konuya ilişkin, bilgilendirilmeye dayanan ve özgür iradeyle açıklanan rıza</p>
</td>
</tr>
<tr>
<td style="height:47px;">
<p><strong>Kişisel Veri</strong></p>
</td>
<td style="width:493px;height:47px;">
<p>Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgi. Örneğin; isim- soy isim, T.C. Kimlik Numarası, e-posta adresi, telefon bilgileri, adres, doğum tarihi, kredi kartı numarası vb.</p>
</td>
</tr>
<tr>
<td style="height:61px;">
<p><strong>Özel Nitelikli Kişisel Veri</strong></p>
</td>
<td style="width:493px;height:61px;">
<p>Irk, etnik köken, siyasi düşünce, felsefi inanç, din, mezhep veya diğer inançlar, kılık kıyafet, dernek, vakıf ya da sendika üyeliği, sağlık, cinsel hayat, ceza mahkumiyeti ve güvenlik tedbirleriyle ilgili veriler ile biyometrik ve genetik veriler</p>
</td>
</tr>
<tr>
<td style="height:18px;">
<p><strong>Veri Sahibi</strong></p>
</td>
<td style="width:493px;height:18px;">
<p>Kişisel verisi işlenen gerçek kişi</p>
</td>
</tr>
<tr>
<td style="height:47px;">
<p><strong>Anonim Hale Getirme</strong></p>
</td>
<td style="width:493px;height:47px;">
<p>Daha öncesinde bir kişiyle ilişkilendirilmiş olan verilerin, başka verilerle eşleştirilerek dahi hiçbir surette kimliği belirli veya belirlenebilir gerçek bir kişiyle ilişkilendirilemeyecek hale gelmesi</p>
</td>
</tr>
<tr>
<td style="height:15px;">
<p><strong>Çalışan</strong></p>
</td>
<td style="width:493px;height:15px;">
<p>Şirket çalışanları</p>
</td>
</tr>
<tr>
<td style="height:32px;">
<p><strong>Çalışan Adayı</strong></p>
</td>
<td style="width:493px;height:32px;">
<p>Şirket’e herhangi bir yolla iş başvurusunda bulunmuş ya da özgeçmiş ve ilgili bilgilerini Kurumun incelemesine açmış olan gerçek kişiler</p>
</td>
</tr>
<tr>
<td style="height:15px;">
<p><strong>Anayasa</strong></p>
</td>
<td style="width:493px;height:15px;">
<p>Türkiye Cumhuriyeti Anayasası</p>
</td>
</tr>
<tr>
<td style="height:32px;">
<p><strong>Kanun</strong></p>
</td>
<td style="width:493px;height:32px;">
<p>7 Nisan 2016 tarihli ve 29677 sayılı Resmi Gazete’de yayımlanan 6698 sayılı Kişisel Verilerin Korunması Kanunu</p>
</td>
</tr>
<tr>
<td style="height:15px;">
<p><strong>KVK Kurulu</strong></p>
</td>
<td style="width:493px;height:15px;">
<p>Kişisel Verileri Koruma Kurulu</p>
</td>
</tr>
<tr>
<td style="height:16px;">
<p><strong>KVK Kurumu</strong></p>
</td>
<td style="width:493px;height:16px;">
<p>Kişisel Verileri Koruma Kurumu</p>
</td>
</tr>
<tr>
<td style="height:15px;">
<p><strong>KVK Kurumu</strong></p>
</td>
<td style="width:493px;height:15px;">
<p>Kişisel Verileri Koruma Kurumu</p>
</td>
</tr>
<tr>
<td style="height:62px;">
<p><strong>Kişisel Verilerin İşlenmesi</strong></p>
</td>
<td style="width:493px;height:62px;">
<p>Kişisel verilerin tamamen veya kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması, devralınması, elde edilebilir hâle getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi gibi veriler üzerinde gerçekleştirilen her türlü işlem.</p>
</td>
</tr>
<tr>
<td style="height:46px;">
<p><strong>Müşteri</strong></p>
</td>
<td style="width:493px;height:46px;">
<p>Şirketimizle herhangi bir sözleşmesel ilişkisi olup olmadığına bakılmaksızın Şirketimizin sunmuş olduğu ürün ve hizmetleri kullanan veya kullanmış olan gerçek kişiler</p>
</td>
</tr>
<tr>
<td style="height:32px;">
<p><strong>Veri İşleyen</strong></p>
</td>
<td style="width:493px;height:32px;">
<p>Veri sorumlusunun verdiği yetkiye dayanarak onun adına kişisel veri işleyen gerçek ve tüzel kişidir.</p>
</td>
</tr>
<tr>
<td style="height:31px;">
<p><strong>Veri Kayıt Sistemi</strong></p>
</td>
<td style="width:493px;height:31px;">
<p>Kişisel verilerin belirli kriterlere göre yapılandırılarak işlendiği kayıt sistemi</p>
</td>
</tr>
<tr>
<td style="height:16px;">
<p><strong>Veri Sahibi</strong></p>
</td>
<td style="width:493px;height:16px;">
<p>Kişisel verisi işlenen gerçek kişi</p>
</td>
</tr>
<tr>
<td style="height:46px;">
<p><strong>Veri Sorumlusu</strong></p>
</td>
<td style="width:493px;height:46px;">
<p>Kişisel verilerin işlenme amaçlarını ve vasıtalarını belirleyen, verilerin sistematik bir şekilde tutulduğu yeri (veri kayıt sistemi) kuran ve yöneten gerçek veya tüzel kişi veri sorumlusudur.</p>
</td>
</tr>
<tr>
<td style="height:47px;">
<p><strong>Veri Sorumluları Sicili</strong></p>
</td>
<td style="width:493px;height:47px;">
<p>KVK Kurulu gözetiminde, KVK Kurumu Başkanlığı tarafından tutulan ve kamuya açık olan Veri Sorumluları Sicili</p>
</td>
</tr>
<tr>
<td style="height:31px;">
<p><strong>Ziyaretçi</strong></p>
</td>
<td style="width:493px;height:31px;">
<p>Şirket’in sahip olduğu fiziksel yerleşkelere çeşitli amaçlarla girmiş olan veya internet sitelerini ziyaret eden gerçek kişiler</p>
</td>
</tr>
<tr>
<td style="height:109px;">
<p style="margin-right: 20px"><strong>İşbirliği İçerisinde Olduğumuz Kurumların, Çalışanların, Hissedarları ve Yetkilileri</strong></p>
</td>
<td style="width:493px;height:109px;">
<p>Okulsepeti ile iş ilişkisi içerisinde bulunan kurumların (ifa yardımcısı, iş ortağı, tedarikçi, program ortağı vb. başta olmak ve fakat bunlarla sınırlı olmamak üzere) çalışanları, hissedarları ve yetkilileri olan gerçek kişiler</p>
</td>
</tr>
<tr>
<td style="height:31px;">
<p><strong>Okulsepeti Tedarikçileri</strong></p>
</td>
<td style="width:493px;height:31px;">
<p>Sözleşme temelli Okulsepeti’nin ürün ve/veya hizmet aldığı üçüncü kişiler</p>
</td>
</tr>
<tr>
<td style="height:47px;">
<p><strong>Potansiyel Müşteri</strong></p>
</td>
<td style="width:493px;height:47px;">
<p>Ürün ve hizmetlerimizi satın alma ve/veya kullanma talebinde bulunmuş veya bulunacağı ticari teamül ve dürüstlük kurallarına uygun olarak değerlendirilmiş gerçek kişiler</p>
</td>
</tr>
<tr>
<td style="height:31px;">
<p><strong>Politika</strong></p>
</td>
<td style="width:493px;height:31px;">
<p>Okulsepeti Ticaret A.Ş. Kişisel Verilerin İşlenmesi ve Korunması Politikası</p>
</td>
</tr>
<tr>
<td style="height:15px;">
<p><strong>Şirket/Firma</strong></p>
</td>
<td style="width:493px;height:15px;">
<p>Okulsepeti Pazarlama Anonim Şirketi</p>
</td>
</tr>
<tr>
<td style="height:32px;">
<p><strong>Şirket Hissedarları</strong></p>
</td>
<td style="width:493px;height:32px;">
<p>Okulsepeti hissedarı gerçek kişiler</p>
</td>
</tr>
<tr>
<td style="height:15px;">
<p style="margin-right: 20px"><strong>Şirket Yetkilisi</strong></p>
</td>
<td style="width:493px;height:15px;">
<p>Okulsepeti yönetim kurulu üyesi ve diğer yetkili gerçek kişiler</p>
</td>
</tr>
<tr>
<td style="height:47px;">
<p style="margin-right: 20px"><strong>Okulsepeti Veri Sahibi Başvuru Formu</strong></p>
</td>
<td style="width:493px;height:47px;">
<p>Veri sahiplerinin, KVK Kanunu’nun 11. Maddesinde yer alan haklarına ilişkin başvurularını kullanırken yararlanacakları başvuru formu</p>
</td>
</tr>
<tr>
<td style="height:62px;">
<p><strong>Üçüncü Kişi</strong></p>
</td>
<td style="width:493px;height:62px;">
<p>Yukarıda tanımlanan taraflarla Okulsepeti arasındaki ticari işlem güvenliğini sağlamak veya bahsi geçen tarafların haklarını korumak ve menfaat temin etmek üzere bu taraflarla ilişki içerisinde olan üçüncü gerçek kişiler</p>
</td>
</tr>
</tbody>
</table>

<h3></h3>

<h3></h3>

<h3>1.4. Politikanın Yürürlüğü</h3>

<p>Başta Kanun olmak üzere yürürlükteki mevzuat ile bu Politika’da yer verilen düzenlemelerin çelişmesi halinde mevzuat hükümleri uygulanır.</p>

<p>Şirket, yasal düzenlemelere paralel olarak Politika’da değişiklik yapma hakkını saklı tutar. Politika’nın güncel haline Şirket (www.okulsepeti.com.tr) web sitesinden erişilebilirsiniz.</p>

<h2>2. Şirket’in Yürüttüğü Kişisel Veri İşleme Faaliyetlerine Yönelik Bilgiler</h2>

<p>Şirket, kişisel verilerin hukuka uygun işlenmesini sağlamak için, teknolojik imkânlar ve uygulama maliyetine göre teknik ve idari tedbirler almaktadır. Çalışanlar, öğrendikleri kişisel verileri Kanun hükümlerine aykırı olarak başkasına açıklayamayacağı ve işleme amacı dışında kullanamayacağı ve bu yükümlülüğün görevden ayrılmalarından sonra da devam edeceği konusunda bilgilendirilmekte ve bu doğrultuda kendilerinden gerekli taahhütler alınmaktadır.</p>

<p></p>

<p>Şirket’in kişisel veri işleme faaliyeti, hiçbir kısıtlama olmaksızın, otomatik olan, yarı otomatik olan veya otomatik olmayan yollar kullanılarak veriye yönelik gerçekleştirilen her türlü eylemi kapsar.<br>
<br>
Şirket, hizmetlerinin kullanıldığı süre boyunca ve ilişkinin sona ermesinin ardından da aşağıda yer verilen ilkelere uymak suretiyle, bir veri sahibinin bilgilerini işleme hakkına sahiptir.<br>
<br>
Şirket’in veri sorumlusu olarak kişisel verileri işlerken uymak zorunda olduğu yükümlülükler ve bu konuda geliştirdiği hukuksal, idari ve teknik tedbirlere uyma zorunluluğu kurumun tedarikçi, iş ortağı gibi çeşitli sıfatlarla ilişkide olduğu veri işleyen kurumlara, veri işleme konusunda gerçekleştirdikleri faaliyetin niteliğiyle uyumlu bir şekilde yükletilmektedir.<br>
<br>
Şirket, kişisel verilerin güvenli ortamlarda saklanması ve hukuka aykırı amaçlarla yok edilmesini, kaybolmasını veya değiştirilmesini önlemek için teknolojik imkânlar ve uygulama maliyetine göre gerekli teknik ve idari tedbirleri almaktadır.</p>

<p><br>
<br>
Şirket, Kanunu’nun 12. maddesine uygun olarak, kendi bünyesinde gerekli denetimleri yapmakta veya yaptırmaktadır. Bu denetim sonuçları raporlanmakta ve alınan tedbirlerin iyileştirilmesi için gerekli faaliyetler yürütülmektedir.</p>

<p><br>
Şirket, Kanunu’nun 12. maddesine uygun olarak işlenen kişisel verilerin kanuni olmayan yollarla başkaları tarafından elde edilmesi halinde bu durumu en kısa sürede ilgili kişisel veri sahibine ve KVK Kurulu’na bildirilmesini sağlayan sistemi yürütmektedir.</p>

<h3>2.1. Kişisel Verilerin İşlenmesinin Kapsamı</h3>

<p>Şirket’in hizmetlerinin kullanıldığı süre boyunca ve ilişkinin sona ermesinin ardından Şirket, işbu Politikada belirtilen ilkelere uymak suretiyle, bir veri sahibinin bilgilerini işleme hakkına sahip olacaktır.</p>

<p></p>

<p>Şirket tarafından yapılan kişisel veri işleme, hiçbir kısıtlama olmaksızın, otomatik olan, yarı otomatik olan veya otomatik olmayan yollar kullanılarak veriye yönelik gerçekleştirilen her türlü eylemi kapsar. Diğer bir ifadeyle kişisel veri işleme; transfer etme, yayma veya farklı yollarla sunma, gruplama veya birleştirme, bloke etme, silme veya imha etme amaçlarıyla veri sahibi veya üçüncü taraflardan veri alınması, toplanması, kaydedilmesi, fotoğraflanması, ses kaydı alınması, video kaydı alınması, organize edilmesi, depolanması, değiştirilmesi, eski haline getirilmesi, geri alınması veya açıklanması, verilerin tamamen veya kısmen otomatik olan ya da herhangi bir kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması, yurtdışına aktarılması, devralınması, elde edilebilir hale getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi anlamına gelir.</p>

<h3>2.2. Kişisel Verilerin İşlenme Amaçları</h3>

<p>Şirket, aşağıdakiler dahil olmak ancak bununla sınırlı olmamak üzere, veri sahibinin veya veri sahibi tarafından belirtilen üçüncü tarafların kişisel verilerini çeşitli amaçlarla işleyebilir.<br>
</p>

<p>Şirket, hizmetlerinin kullanıldığı süre boyunca ve ilişkinin sona ermesinin ardından da aşağıda yer verilen ilkelere uymak suretiyle, veri sahibinin bilgilerini işleme hakkına sahiptir.</p>

<p><strong>2.2.1. Şirket’in sunduğu ürün ve hizmetlerden ilgili kişileri faydalandırmak için gerekli çalışmaların ilgili birimler tarafından yapılması ve iş süreçlerinin yürütülmesi</strong></p>

<ol>
<li>Ürün ve/veya hizmetlerin satış süreçlerinin planlanması ve icra edilmesi,</li>
<li>Satış sonrası destek hizmetleri aktivitelerinin planlanması ve/veya icra edilmesi,</li>
<li>Müşteri ilişkileri yönetimi süreçlerinin planlanması ve icra edilmesi,</li>
<li>Sözleşme süreçlerinin ve/veya hukuki taleplerin takibi,</li>
<li>Müşteri talep ve/veya şikayetlerinin takibi.</li>
</ol>

<p><strong>2.2.2. Şirket insan kaynakları politikaları ve süreçlerinin planlanması ve icra edilmesi</strong></p>

<ol>
<li>Yetenek- kariyer gelişimi faaliyetlerinin planlanması ve icrası,</li>
<li>Şirket çalışanları için iş akdi ve/veya mevzuattan kaynaklı yükümlülüklerin yerine getirilmesi,</li>
<li>Çalışanlar için yan haklar ve menfaatlerin planlanması ve icra edilmesi,</li>
<li>Şirket içi oryantasyon aktivitelerinin planlanması ve icra edilmesi,</li>
<li>Personel çıkış işlemlerinin planlanması ve icra edilmesi,</li>
<li>Ücret yönetimi</li>
<li>İnsan kaynakları süreçlerinin planlanması,</li>
<li>Personel temin süreçlerinin yönetilmesi,</li>
<li>Şirket için atama-terfi ve işten ayrılma süreçlerinin planlanması ve icra edilmesi,</li>
<li>Çalışanların performans değerlendirme süreçlerinin planlanması ve icra edilmesi,</li>
<li>Çalışanların iş faaliyetlerinin takibi ve/veya denetimi,</li>
<li>Şirket içi eğitim faaliyetlerinin planlanması ve/veya icra edilmesi,</li>
<li>Çalışan memnuniyetinin ve/veya bağlılığı süreçlerinin planlanması ve icra edilmesi,</li>
<li>Çalışanların iş ve/veya üretim süreçlerinin iyileştirilmesine yönelik önerilerin alınması ve değerlendirilmesi süreçlerinin planlanması ve icra edilmesi,</li>
<li>Stajyer ve/veya öğrenci temin, yerleştirilmesi ve operasyon süreçlerinin planlanması ve/veya icra edilmesi.</li>
</ol>

<p><strong>2.2.3. Şirket tarafından yürütülen ticari faaliyetlerin gerçekleştirilmesi için ilgili iş birimleri tarafından gerekli çalışmaların yapılması ve buna bağlı iş süreçlerinin yürütülmesi:</strong></p>

<ol>
<li>Etkinlik yönetimi,</li>
<li>İş faaliyetlerinin planlanması ve icra edilmesi,</li>
<li>Kurumsal iletişim faaliyetlerinin planlanması ve icra edilmesi,</li>
<li>Tedarik zinciri yönetimi süreçlerinin planlanması ve icra edilmesi,</li>
<li>Üretim ve/veya operasyon süreçlerinin planlanması ve icra edilmesi,</li>
<li>Bilgi güvenliği süreçlerinin planlanması, denetimi ve icra edilmesi,</li>
<li>Bilgi teknolojileri altyapısının oluşturulması ve yönetilmesi,</li>
<li>İş ortaklarının bilgiye erişim yetkilerinin planlanması ve icra edilmesi,</li>
<li>Finans ve/veya muhasebe işlerinin takibi,</li>
<li>Kurumsal sürdürülebilirlik faaliyetlerin planlanması ve icra edilmesi,</li>
<li>Kurumsal yönetim faaliyetlerin planlanması ve icra edilmesi,</li>
<li>İş sürekliliğinin sağlanması faaliyetlerinin planlanması ve/veya icra edilmesi,</li>
<li>Lojistik faaliyetlerinin planlanması ve icra edilmesi.</li>
</ol>

<p><strong>2.2.4. Şirket tarafından sunulan ürün ve hizmetlerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için gerekli olan aktivitelerin planlanması ve icra edilmesi:</strong></p>

<ol>
<li>Pazarlama faaliyetlerine konu edilecek kişilerin, tüketici davranışı kriterleri doğrultusunda tespiti ve/veya değerlendirilmesi,</li>
<li>Kişiye özel pazarlama ve/veya tanıtım aktivitelerinin tasarlanması ve/veya icra edilmesi,</li>
<li>Dijital ve/veya diğer mecralarda reklam ve/veya tanıtım ve/veya pazarlama aktivitelerinin tasarlanması ve/veya icra edilmesi,</li>
<li>Dijital ve/veya diğer mecralarda müşteri kazanım ve/veya mevcut müşterilerde değer yaratımı üzerine geliştirilecek aktivitelerin tasarlanması ve/veya icra edilmesi,</li>
<li>Pazarlama amacıyla veri analitiği çalışmalarının planlanması ve/veya icra edilmesi,</li>
<li>Ürün ve/veya hizmetlerin pazarlama süreçlerinin planlanması ve icra edilmesi,</li>
<li>Şirketin sunduğu ürün ve/veya hizmetlere bağlılık oluşturulması ve/veya arttırılması süreçlerinin planlanması ve/veya icra edilmesi.</li>
</ol>

<p><strong>2.2.5. Şirket’in ticari ve/veya iş stratejilerinin planlanması ve icra edilmesi:</strong><br>
</p>

<p>İş ortakları ile olan ilişkilerin yönetilmesi.</p>

<p><strong>2.2.6. Şirket’in ve Şirket ile iş ilişkisi içerisinde olan ilgili kişilerin hukuki, teknik ve ticari iş güvenliğinin temini:</strong></p>

<ol>
<li>Hukuk işlerinin takibi,</li>
<li>Şirket faaliyetlerinin şirket prosedürleri ve/veya ilgili mevzuata uygun olarak yürütülmesinin temini için gerekli operasyonel faaliyetlerinin planlanması ve icra edilmesi,</li>
<li>Yetkili kuruluşlara mevzuattan kaynaklı bilgi verilmesi,</li>
<li>Ziyaretçi kayıtlarının oluşturulması ve takibi,</li>
<li>Acil durum yönetimi süreçlerinin planlanması ve icra edilmesi,</li>
<li>Şirketler ve ortaklık hukuku işlemlerinin gerçekleştirilmesi,</li>
<li>Şirket denetim faaliyetlerinin planlanması ve icra edilmesi,</li>
<li>İş sağlığı ve/veya güvenliği süreçlerinin planlanması ve/veya icra edilmesi,</li>
<li>Kredi süreçleri risk yönetiminin gerçekleştirilmesi,</li>
<li>Şirket yerleşkeleri ve/veya tesislerinin güvenliğinin temini,</li>
<li>Şirket operasyonlarının güvenliğinin temini,</li>
<li>Şirketin finansal risk süreçlerinin planlanması ve/veya icra edilmesi,</li>
<li>Şirket demirbaşlarının ve/veya kaynaklarının güvenliğinin temini.</li>
</ol>

<h3>2.3. Kişisel Veri Kategorileri</h3>

<p>Şirket tarafından yürütülen veri işleme faaliyetleri kapsamında kısmen veya tamamen otomatik şekilde veya veri kayıt sisteminin bir parçası olarak otomatik olmayan şekilde işlenen, ait olduğu gerçek kişi belirlenen ve/veya belirlenebilir olan kişisel veri kategorileri ve açıklamaları aşağıda yer almaktadır:</p>

<p></p>

<table border="0" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td>
<p><strong>Veri Kategorisi</strong></p>
</td>
<td>
<p align="center"><strong>Açıklama</strong></p>
</td>
</tr>
<tr>
<td>
<p>Kimlik bilgisi</p>
</td>
<td style="width:470px;">
<p>Ehliyet, nüfus cüzdanı, ikametgâh, pasaport, avukatlık kimliği, evlilik cüzdanı gibi belgelerde yer alan T.C. kimlik numarası, uyruk bilgisi, anne baba adı, doğum yeri ve tarihi, cinsiyet, SGK numarası, imza bilgili, taşıt plakası vb. tüm bilgiler.</p>
</td>
</tr>
<tr>
<td>
<p>İletişim bilgisi</p>
</td>
<td style="width:470px;">
<p>Gerçek kişiye ait olduğu açık olan; Kişiyle iletişim kurmak için kullanılan bilgiler (örn. e-mail adresi, telefon numarası, cep telefonu numarası, adres gibi).</p>
</td>
</tr>
<tr>
<td>
<p>Lokasyon bilgisi</p>
</td>
<td style="width:470px;">
<p>Veri sahibinin konumunu tespit etmeye yarayan bilgiler (örn. araç kullanımı sırasında edinilen konum bilgileri).</p>
</td>
</tr>
<tr>
<td>
<p>Müşteri bilgisi</p>
</td>
<td style="width:470px;">
<p>Ticari faaliyetlerimiz ve bu faaliyetler kapsamında ilgili birimlerin operasyonları sonucunda, gerçek kişi müşterilerden elde edilen ve üretilen bilgiler (örn. müşteri no., meslek bilgisi, vb.).</p>
</td>
</tr>
<tr>
<td>
<p>Müşteri işlem bilgisi</p>
</td>
<td style="width:470px;">
<p>Veri kayıt sistemi içerisinde yer alan müşterimize ait, ürün ve hizmetlerimizin satın alınmasına yönelik kayıtlar ile satın alma için gereken talimatlar kapsamında elde edilen bilgiler ile ürün ve hizmetlerimizi satın alan ve/veya kullanan kişisel veri sahibinin beğenisi ve ihtiyaçları doğrultusunda kullanım ve satın alma alışkanlıklarının kişiselleştirilerek pazarlamasının yapılmasına yönelik işlenen kişisel veriler ve bu işlem neticesinde meydana getirilen rapor ve değerlendirmeler.</p>
</td>
</tr>
<tr>
<td>
<p>Fiziksel mekân güvenlik bilgisi</p>
</td>
<td style="width:470px;">
<p>Veri kayıt sistemi içerisinde tutulmak üzere, ticari faaliyetlerimizi yürütürken her açıdan güvenliğimizi sağlamak için işlenen kamera kayıtları, parmak izi kayıtları, güvenlik noktasında alınan kayıtlar, fiziksel mekana girişte, fiziksel mekanın içerisinde kalış sırasında alınan kayıtlar vb. kişisel veriler.</p>
</td>
</tr>
<tr>
<td>
<p>İşlem güvenliği bilgisi</p>
</td>
<td style="width:470px;">
<p>Şirket’in ticari faaliyetlerini yürütürken teknik, idari, hukuki ve ticari güvenliği sağlamak için işlenen kişisel veriler.</p>
</td>
</tr>
<tr>
<td>
<p>Finansal bilgi</p>
</td>
<td style="width:470px;">
<p>Şirket’in kişisel veri sahibi ile kurmuş olduğu hukuki ilişkinin tipine göre yaratılan her türlü finansal sonucu gösteren bilgi, belge ve kayıtlara ilişkin işlenen kişisel veriler. (Örn. IBAN numarası, kredi kartı bilgili, finansal profil, gelir bilgisi vb.)</p>
</td>
</tr>
<tr>
<td>
<p>Çalışan adayı bilgisi</p>
</td>
<td style="width:470px;">
<p>Şirket’in çalışanı olmak için başvuruda bulunmuş veya ticari teamül ve dürüstlük kuralları gereği insan kaynakları ihtiyaçları doğrultusunda çalışan adayı olarak değerlendirilmiş veya Firma ile çalışma ilişkisi içerisinde olan bireylerle ilgili işlenen kişisel veriler.</p>
</td>
</tr>
<tr>
<td>
<p>Hukuki işlem ve uyum bilgisi</p>
</td>
<td style="width:470px;">
<p>Şirket’in hukuki alacak ve haklarının tespiti, takibi ve borçlarının ifası ile kanuni yükümlülükleri ve şirketin politikalarına uyum kapsamında işlenen kişisel veriler.</p>
</td>
</tr>
<tr>
<td>
<p>Denetim ve teftiş bilgisi</p>
</td>
<td style="width:470px;">
<p>Şirket’in kanuni yükümlülükleri ve şirket politikalarına uyumu kapsamında işlenen kişisel veriler.</p>
</td>
</tr>
<tr>
<td>
<p>Özel nitelikli veri</p>
</td>
<td style="width:470px;">
<p>Kanun’un 6. maddesinde “özel nitelikli kişisel veri” olarak belirtilen “ırkı, etnik köken, siyasi düşünce, felsefi inancı, din, mezhep veya diğer inanç, kılık ve kıyafet, dernek, vakıf ya da sendika üyelik bilgisi, sağlık ve cinsel hayat ile ilgili veriler, ceza mahkûmiyeti ve güvenlik tedbirleriyle ilgili verileri ile biyometrik ve genetik” verilerdir.</p>
</td>
</tr>
<tr>
<td>
<p>Pazarlama bilgisi</p>
</td>
<td style="width:470px;">
<p>Şirket’in sunduğu ürün ve hizmetlerin kişisel veri sahibinin kullanım alışkanlıkları, beğenisi ve ihtiyaçları doğrultusunda özelleştirilerek pazarlamasının yapılmasına yönelik işlenen kişisel veriler ve bu işleme sonuçları neticesinde yaratılan rapor ve değerlendirmeler.</p>
</td>
</tr>
<tr>
<td>
<p>Talep/şikayet yönetimi bilgisi</p>
</td>
<td style="width:470px;">
<p>Şirket müşterisi olan ya da olmayan gerçek kişiler tarafından Şirket’e ait iletişim kanallarına yönelmiş olan her türlü talep veya şikayetin alınması ve değerlendirilmesine ilişkin kişisel veriler.</p>
</td>
</tr>
<tr>
<td>
<p>İtibar ve Olay yönetim bilgisi</p>
</td>
<td style="width:470px;">
<p>Şirket’in ticari itibarını korumak ve kamuoyunun doğru bilgilendirilmesini sağlamak maksadı ile Şirket çalışanlarını, hissedarlarını etkileme potansiyeli olan olaylarla ilgili sosyal medya vb. mecralardan toplanan kişisel veriler, değerlendirmeler ile Şirket’in ticari hak ve menfaatleri ile müşterilerinin hak ve menfaatlerini korumak maksatlı gelişen olaylara karşı gerekli hukuki, teknik ve idari tedbirlerin alınmasına yönelik olarak işlenen kişisel veriler.</p>
</td>
</tr>
<tr>
<td>
<p>Risk yönetim bilgisi</p>
</td>
<td style="width:470px;">
<p>Ticari, teknik ve idari risklerin yönetilebilmesi için bu alanlarda genel kabul görmüş hukuki, ticari teamül ve dürüstlük kuralına uygun olarak kullanılan yöntemler vasıtasıyla işlenen kişisel veriler</p>
</td>
</tr>
</tbody>
</table>

<h2>3. Kişisel Verilerin İşlenmesine İlişkin İlke ve Şartlar</h2>

<p>Kanun’un 5. maddesi uyarınca kişisel veriler ancak Kanun ve diğer ilgili yasal mevzuatta öngörülen usul ve esaslara uygun olarak işlenebilir. Okulsepeti olarak gerek Kanun gerekse ilgili diğer yasal mevzuat kapsamında belirtilen usul ve ilkelere uygun olarak kişisel veriler işlenmektedir.</p>

<p>Şirket, Kanun’un 4. maddesine uygun olarak kişisel verilerin işlenmesi konusunda; hukuka ve dürüstlük kurallarına uygun, doğru ve gerektiğinde güncel, belirli, açık ve meşru amaçlar güderek, amaç ile bağlantılı, sınırlı ve ölçülü bir biçimde kişisel veri işleme faaliyetinde bulunmaktadır. Şirket, kanunlarda öngörülen veya kişisel veri işleme amacının gerektirdiği süre kadar kişisel verileri muhafaza eder.</p>

<h3>3.1. Kişisel Verilerin İşlenmesine İlişkin İlkeler</h3>

<p>Şirket, Kanun’un 10. maddesine uygun olarak veri sahiplerini aydınlatmaktır ve rıza alınması gereken durumlarda veri sahiplerinden rızalarını talep ederek bu kişisel verileri aşağıda belirtilen ilkeleri esas alarak işler.</p>

<p><strong>3.1.1. Verilerin hukuka ve dürüstlük kuralına uygun işlenmesi</strong></p>

<p>Şirket; kişisel verilerin işlenmesi faaliyetini Türkiye Cumhuriyeti Anayasası ile Kanun ve ilgili diğer yasal mevzuat başta olmak üzere hukuksal düzenlemelere ve güven ilişkisi esas olmak üzere dürüstlük kuralına uygun olarak yürütmektedir. Dürüstlük kuralına uygun olma ilkesi uyarınca Şirket veri işlemedeki hedeflerine ulaşmaya çalışırken, ilgili kişilerin çıkarlarını ve makul beklentilerini dikkate almaktadır.</p>

<p><strong>3.1.2. Kişisel verilerin doğru ve gerektiğinde güncel olmasının sağlanması</strong></p>

<p>Kişisel verilerin doğru ve güncel bir şekilde tutulması, Şirket açısından ilgili kişinin temel hak ve özgürlüklerinin korunması için gereklidir. Kişisel verilerin doğru ve gerektiğinde güncel olmasının sağlanması noktasında Şirket’in aktif özen yükümlülüğü bulunmaktadır. Bu sebeple Şirket tarafından veri sahibi olan ilgili kişinin bilgilerinin doğru ve güncel olarak tutulması için bütün iletişim kanalları açıktır.</p>

<p><strong>3.1.3. Verilerin belirli, açık ve meşru amaçlarla işlenmesi</strong></p>

<p>Şirket, meşru ve hukuka uygun olan kişisel veri işleme amacını açık ve kesin olarak belirlemektedir. Yürütmekte olduğu ticari faaliyet ile bağlantılı ve bunlar için gerekli olan kadar kişisel veriyi işlemektedir.</p>

<p><strong>3.1.4. Verilerin işlendikleri amaçla bağlantılı, sınırlı ve ölçülü olması</strong></p>

<p>Şirket; kişisel verileri, iştigal konusu ile ilgili ve işinin yürütülmesi için gerekli olan amaçlar dahilinde işlemektedir. Bu sebeple, kişisel verileri belirlenen amaçların gerçekleştirilebilmesine elverişli bir biçimde işlemekte ve amacın gerçekleştirilmesiyle ilgili olmayan veya ihtiyaç duyulmayan kişisel verilerin işlenmesinden kaçınmaktadır.</p>

<p><strong>3.1.5. Verilerin ilgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza edilmesi</strong></p>

<p>Şirket, kişisel verileri ancak ilgili mevzuatta belirtildiği veya işlendikleri amaç için gerekli olan süre kadar muhafaza etmektedir. Bu kapsamda; öncelikle ilgili mevzuatta kişisel verilerin saklanması için bir süre öngörülüp öngörülmediğini tespit etmekte, bir süre belirlenmişse bu süreye uygun davranmakta, bir süre belirlenmemişse kişisel verileri işlendikleri amaç için gerekli olan süre kadar saklamaktadır. Kişisel veri işleme amacının ortadan kalkmasından sonra ya da mevzuatta öngörülen sürenin dolması ile birlikte kişisel veriler Şirket tarafından silinmekte, yok edilmekte veya anonimleştirilmektedir.</p>

<p><strong>3.2. Kişisel Verilerin İşlenmesine İlişkin Şartlar</strong></p>

<p>Kanun’un 5. maddesinde yer alan kişisel veri işleme şartlarından en az birinin varlığı halinde kişisel verileriniz Şirket tarafından işlenmektedir.</p>

<p><strong>3.2.1. Kişisel veri sahibinin açık rızasının olması</strong></p>

<p>Kişisel verilerin işlenme şartlarından biri sahibinin açık rızasıdır. Kişisel veri sahibinin açık rızası belirli bir konuya ilişkin, bilgilendirilmeye dayalı olarak ve özgür iradeyle açıklanmalıdır.</p>

<p>Kişisel verilerin, kişisel veri sahibinin açık rıza vermesine bağlı olarak işlenmesi için, müşteri, potansiyel müşteri ve ziyaretçilerden ilgili yöntemler ile açık rızaları alınmaktadır.</p>

<p><strong>3.2.2. Kişisel veri işleme faaliyetlerinin kanunlarda açıkça ön görülmesi</strong></p>

<p>Veri sahibinin kişisel verileri, kanunda açıkça öngörülmesi halinde veri sahibinin açık rızası olmadan da hukuka uygun olarak işlenebilmektedir.</p>

<p><strong>3.2.3. Fiili imkansızlık sebebiyle kişinin açık rızasının alınamaması</strong></p>

<p>Fiili imkansızlık nedeniyle rızasını açıklayamayacak durumda olan veya rızasına geçerlilik tanınmayacak olan kişinin kendisinin veya başka bir kişinin hayatı ya da beden bütünlüğünü korumak için kişisel verisinin işlenmesinin zorunlu olması halinde veri sahibinin kişisel verileri işlenebilmektedir.</p>

<p><strong>3.2.4. Kişisel verinin, bir sözleşmenin kurulması veya ifasıyla doğrudan ilgisi olması</strong></p>

<p>Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması halinde kişisel verilerin işlenmesi mümkündür.</p>

<p><strong>3.2.5. Şirket’in hukuki yükümlülüğünü yerine getirmesi</strong></p>

<p>Şirket’in veri sorumlusu olarak hukuki yükümlülüklerini yerine getirmesi için işlenmenin zorunlu olması durumunda veri sahibinin kişisel verileri işlenebilmektedir.</p>

<p><strong>3.2.6. Veri sahibinin kişisel verilerinin alenileştirilmesi</strong></p>

<p>Veri sahibinin, kişisel verisini kendisi tarafından alenileştirilmiş olması halinde ilgili kişisel veriler işlenebilecektir.</p>

<p><strong>3.2.7. Bir hakkın tesisi veya korunması için veri işlemenin zorunlu olması</strong></p>

<p>Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması halinde veri sahibinin kişisel verileri işlenebilecektir.</p>

<p><strong>3.2.8. Şirket’in meşru menfaati için veri işlemenin zorunlu olması</strong></p>

<p>Kişisel veri sahibinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, Firma’nın meşru menfaatleri için veri işlemesinin zorunlu olması halinde veri sahibinin kişisel verileri işlenebilecektir.</p>

<h2>3.3. Özel Nitelikli Kişisel Verilerin İşlenmesi</h2>

<p><strong>3.3.1. Özel nitelikli kişisel verilerin İşlenme Şartları</strong></p>

<p>Hukuka aykırı olarak işlendiğinde kişilerin mağduriyetine veya ayrımcılığa sebep olma riski nedeniyle Kanun kapsamında “özel nitelikli” olarak belirlenen kişisel veriler, işbu hassasiyet nedeniyle bu Politika’ da ayrıca belirtilmiştir.</p>

<p></p>

<p>Kanun’un 6. maddesi 1. fıkrasında tanımı yapılan özel nitelikli kişisel verilerin yine Kanun’un 6. maddesinin 2. fıkrasında belirtildiği üzere veri sahibinin açık rızası olmaksızın işlenmesi yasaktır. Kanun’un 6. maddesinin 3. fıkrası bu kuralın istisnalarını düzenlemektedir.</p>

<p>Şirket tarafından, Kanun ile “özel nitelikli” olarak belirlenen kişisel verilerin işlenmesinde, Kanun’da öngörülen düzenlemelere hassasiyetle uygun davranılmaktadır. Şirket tarafından; özel nitelikli kişisel veriler, KVK Kurulu tarafından belirlenecek olan yeterli önlemlerin alınması kaydıyla aşağıdaki durumlarda işlenmektedir:</p>

<ul>
<li>Kişisel veri sahibinin açık rızası var ise veya</li>
<li>Kişisel veri sahibinin açık rızası yok ise;</li>
<li>Kişisel veri sahibinin sağlığı ve cinsel hayatı dışındaki özel nitelikli kişisel veriler, kanunlarda öngörülen hallerde,</li>
<li>Kişisel veri sahibinin sağlığına ve cinsel hayatına ilişkin özel nitelikli kişisel verileri ise ancak kamu sağlığının korunması, koruyucu hekimlik, tıbbi teşhis, tedavi ve bakım hizmetlerinin yürütülmesi, sağlık hizmetleri ile finansmanının planlanması ve yönetimi amacıyla, sır saklama yükümlülüğü altında bulunan kişiler veya yetkili kurum ve kuruluşlar tarafından işlenmektedir.</li>
</ul>

<p><strong>3.3.2. Özel nitelikli kişisel verilerin Korunması</strong></p>

<p>Özel nitelikli kişisel verilerin işlenmesi süreçlerinde yer alan çalışanlara yönelik; Kanun ve buna bağlı yönetmelikler ile özel nitelikli kişisel veri güvenliği konularında düzenli olarak eğitimler verilmesi, gizlilik sözleşmelerinin yapılması, verilere erişim yetkisine sahip kullanıcıların, yetki kapsamlarının ve sürelerinin net olarak tanımlanması, periyodik olarak yetki kontrollerinin gerçekleştirilmesi, görev değişikliği olan ya da işten ayrılan çalışanların bu alandaki yetkilerinin derhal kaldırılması ve bu kapsamda, veri sorumlusu tarafından kendisine tahsis edilen envanterin iade alınması yönünde gerekli önlemler alınmaktadır.</p>

<p></p>

<p>Özel nitelikli kişisel verilerin işlendiği, muhafaza edildiği ve/veya erişildiği ortamlar, elektronik ortam ise; verilerin kriptografik yöntemler kullanılarak muhafaza edilmesi, kriptografîk anahtarların güvenli ve farklı ortamlarda tutulması, veriler üzerinde gerçekleştirilen tüm hareketlerin işlem kayıtlarının güvenli olarak loglanması, verilerin bulunduğu ortamlara ait güvenlik güncellemelerinin sürekli takip edilmesi, gerekli güvenlik testlerinin düzenli olarak yapılması/yaptırılması, test sonuçlarının kayıt altına alınması, verilere bir yazılım aracılığı ile erişiliyorsa bu yazılıma ait kullanıcı yetkilendirmelerinin yapılması, bu yazılımların güvenlik testlerinin düzenli olarak yapılması/yaptırılması, test sonuçlarının kayıt altına alınması, verilere uzaktan erişim gerekiyorsa en az iki kademeli kimlik doğrulama sisteminin sağlanması yönünde gerekli önlemler alınmaktadır.</p>

<p></p>

<p>Özel nitelikli kişisel verilerin işlendiği, muhafaza edildiği ve/veya erişildiği ortamlar, fiziksel ortam ise; özel nitelikli kişisel verilerin bulunduğu ortamın niteliğine göre yeterli güvenlik önlemlerinin (elektrik kaçağı, yangın, su baskını, hırsızlık vb. durumlara karşı) alındığından emin olunması, bu ortamların fiziksel güvenliğinin sağlanarak yetkisiz giriş çıkışların engellenmesi yönünde gerekli önlemler alınmaktadır.</p>

<h2>4. Kişisel Verilerin Aktarılması</h2>

<p>Şirket’in veri sahibine gerektiği gibi hizmet edebilmesi amaçlarına uygun olarak veri işleme kapsamında, veri sahibiyle ve/veya veri sahibinin işaret ettiği üçüncü taraflarla ilgili verilerin aktarımı/paylaşımı gereklidir.</p>

<p></p>

<p>Kişisel veriler Şirket tarafından sunulan ürün ve hizmetlerden faydalanılması için gerekli çalışmaların iş birimleri tarafından yapılması, Şirket tarafından sunulan ürün ve hizmetlerin müşterilerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre özelleştirilerek önerilmesi,</p>

<p>Şirket ve Şirket’le iş ilişkisi içerisinde olan kişilerin hukuki ve ticari güvenliğinin temini (Şirket tarafından yürütülen iletişime yönelik idari operasyonlar, Şirket’e ait lokasyonların fiziksel güvenliğini ve denetimini sağlamak, iş ortağı/müşteri/tedarikçi (yetkili veya çalışanları) değerlendirme süreçleri, itibar araştırma süreçleri, hukuki uyum süreci, denetim, mali işler vb.),</p>

<p>Şirket’in ticari ve iş stratejilerinin belirlenmesi ve uygulanması ile Şirket’in insan kaynakları politikalarının yürütülmesinin temini amaçlarıyla iş ortaklarına, tedarikçilere, Şirket yetkililerine, hissedarlara, iştiraklere, bağlı ortaklıklara, kanunen yetkili kamu kurumları ve özel kişilere, Kanun’un 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde aktarılabilecektir.</p>

<p>Şirket hukuka uygun olan kişisel veri işleme amaçları doğrultusunda gerekli güvenlik önlemlerini alarak veri sahibinin kişisel verilerini ve özel nitelikli kişisel verilerini yurt içi veya yurt dışındaki üçüncü kişilere (üçüncü kişi şirketlere, grup şirketlerine, üçüncü gerçek kişilere) aktarabilmektedir. Şirket bu doğrultuda Kanun’un 8. maddesinde öngörülen düzenlemelere uygun hareket etmektedir.</p>

<p>Şirket, bu Politika maddesinde belirtilen aktarma işlemi için istisnaları, Kanun’un 8. maddesi 2. fıkrasında belirtildiği üzere uygulanmaktadır. Kişisel verilerin aktarılmasına ilişkin diğer kanunlarda yer alan hükümler saklıdır.</p>

<h3>4.1. Kişisel Verilerin Yurtiçinde Aktarımı</h3>

<p>Şirket’in, kişisel veri sahibine, daha iyi hizmet verebilmesi, taleplerini daha doğru karşılayabilmesi, hizmet ve iletişimini geliştirebilmesi, müşteri memnuniyeti uygulamaları ve bilgilendirmeleri yapabilmesi ve teknik problemleri ortadan kaldırabilmesi vb. amaçlarına uygun olarak, veri işleme faaliyeti kapsamında, veri sahibiyle ve/veya veri sahibinin işaret ettiği üçüncü taraflarla ilgili verilerin üçüncü kişilere aktarımı/paylaşımı gerekli olabilmektedir.</p>

<p></p>

<p>Şirket, bu doğrultuda Kanun’un 8. maddesinde öngörülen düzenlemelere ve bahse konu madde kapsamında işbu Politika’ da yer alan düzenlemelere uygun hareket etmektedir. Şöyle ki;</p>

<p>kişisel veriler Şirket tarafından sunulan ürün ve hizmetlerden faydalanılması için gerekli çalışmaların iş birimleri tarafından yapılması, Şirket tarafından sunulan ürün ve hizmetlerin müşterilerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre özelleştirilerek önerilmesi,</p>

<p>Şirket ve Şirket ile iş ilişkisi içerisinde olan kişilerin hukuki ve ticari güvenliğinin temini (Şirket tarafından yürütülen iletişime yönelik idari operasyonlar, Şirket’e ait lokasyonların fiziksel güvenliğini ve denetimini sağlamak, iş ortağı/müşteri/tedarikçi (yetkili veya çalışanları) değerlendirme süreçleri, itibar araştırma süreçleri, hukuki uyum süreci, denetim, mali işler vb.),</p>

<p>Şirket’in ticari ve iş stratejilerinin belirlenmesi ve uygulanması ile kurumun insan kaynakları politikalarının yürütülmesinin temini amaçlarıyla iş ortaklarına, tedarikçilere, Şirket yetkililerine, hissedarlara, iştiraklere, bağlı ortaklıklara, kanunen yetkili kamu kurumları ve özel kişilere, Kanun’un 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde aktarılabilecektir.</p>

<p>Kanun’un 5. ve 6. maddesinde yer alan ve bu Politikanın 3. başlığı altında açıklanmış olan veri işleme şartlarından en az birinin varlığı halinde ve veri işleme şartlarına ilişkin temel ilkelere uymak şartıyla kişisel verileriniz Şirket tarafından aktarılabilmektedir.</p>

<h3>4.1.2. Özel Nitelikli Kişisel verilerin yurtiçinde aktarımı</h3>

<p>Şirket gerekli özeni göstermek ve gerekli güvenlik tedbirlerini almak sureti ile KVK Kurulu tarafından öngörülen yeterli önlemleri alarak; meşru ve hukuka uygun amaçları doğrultusunda kişisel veri sahibinin özel nitelikli verilerini, bu Politika’nın 3.3 başlığı altında düzenlenen şartları dikkate alarak üçüncü kişilere aktarabilmektedir.</p>

<h3>4.2. Kişisel Verilerin Yurtdışına Aktarımı</h3>

<p>Şirket bu Politika’nın 3. başlığı altında açıklanmış olan veri işleme şartlarından en az birinin varlığı halinde ve gerekli güvenlik önlemlerini alarak kişisel veri sahibinin kişisel verilerini ve özel nitelikli kişisel verilerini yurt dışındaki üçüncü kişilere ve/veya yabancı ülkelerde bulunan depolama mecralarına aktarılabilmektedir.</p>

<p>Firma tarafından kişisel veriler; KVK Kurulu tarafından yeterli korumaya sahip olduğu ilan edilen yabancı ülkelere (“Yeterli Korumaya Sahip Yabancı Ülke”) veya yeterli korumanın bulunmaması durumunda Türkiye’deki ve ilgili yabancı ülkedeki veri sorumlularının yeterli bir korumayı yazılı olarak taahhüt ettiği ve KVK Kurulu’nun izninin bulunduğu yabancı ülkelere (“Yeterli Korumayı Taahhüt Eden Veri Sorumlusunun Bulunduğu Yabancı Ülke”) aktarılmaktadır. Firma bu doğrultuda Kanun’un 9. maddesinde öngörülen düzenlemelere uygun hareket etmektedir.</p>

<h3>4.2.1. Özel nitelikli kişisel verilerin yurtdışına aktarımı</h3>

<p>Şirket gerekli özeni göstererek, gerekli güvenlik tedbirlerini alarak ve KVK Kurulu tarafından öngörülen yeterli önlemleri alarak; meşru ve hukuka uygun kişisel veri işleme amaçları doğrultusunda kişisel veri sahibinin özel nitelikli verilerini bu Politika’nın 3.3 başlığı altında düzenlenen şartları dikkate alarak yeterli korumaya sahip ilan edilen veya yabancı ülkede bulunan veri sorumlusu tarafından yeterli koruma taahhüt edilen ülkelere ve/veya yabancı ülkelerde bulunan depolama mecralarına aktarabilmektedir.</p>

<p></p>

<p>Özel nitelikli kişisel veriler, e-posta yoluyla aktarılması gerekiyorsa şifreli olarak kurumsal e-posta adresiyle veya Kayıtlı Elektronik Posta (KEP) hesabı kullanılarak aktarılması, taşınabilir bellek, CD, DVD gibi ortamlar yoluyla aktarılması gerekiyorsa kriptografik yöntemlerle şifrelenmesi ve kriptografik anahtarın farklı ortamda tutulması, farklı fiziksel ortamlardaki sunucular arasında aktarma gerçekleştiriliyorsa, sunucular arasında VPN kurularak veya SFTP yöntemiyle veri aktarımının gerçekleştirilmesi, verilerin kâğıt ortamı yoluyla aktarımı gerekiyorsa evrakın çalınması, kaybolması ya da yetkisiz kişiler tarafından görülmesi gibi risklere karşı gerekli önlemlerin alınması ve evrakın “gizlilik dereceli belgeler” formatında gönderilmesi yönünde gerekli önlem ve tedbirler alınmaktadır.</p>

<h3>4.3. Kişisel Verilerin Aktarıldığı Üçüncü Kişiler ve Aktarılma Amaçları</h3>

<p>Kanun’un genel ilkeleri ile 8. ve 9. maddelerinde yer alan veri işleme şartları dahilinde Şirket, aşağıdaki tabloda kategorizasyonu yapılmış taraflara veri aktarımı gerçekleştirebilmektedir:</p>

<table border="1" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td style="width:200px;height:62px;">
<p align="center"><strong>Veri Aktarımı Yapılabilecek Kişiler</strong></p>
</td>
<td style="width:200px;height:62px;">
<p align="center"><strong>Tanım</strong></p>
</td>
<td style="width:200px;height:62px;">
<p align="center"><strong>Amaç</strong></p>
</td>
</tr>
<tr>
<td style="width:200px;height:31px; padding: 5px">
<p>İş Ortağı</p>
</td>
<td style="width:200px;height:31px; padding: 5px">
<p>Şirket’in ticari faaliyetlerini yürütürken, ürün ve hizmetlerinin satışı, tanıtımı ve pazarlaması, satış sonrası desteği, müşteri bağlılığı programlarının yürütülmesi gibi amaçlarla iş ortaklığı kurduğu taraflar</p>
</td>
<td style="width:200px;height:31px; padding: 5px">
<p>İş ortaklığının kurulma amaçlarının yerine getirilmesini temin etmek amacıyla sınırlı olarak kişisel verilerin paylaşımı</p>
</td>
</tr>
<tr>
<td style="width:200px;height:31px; padding: 5px">
<p>Hissedarlar</p>
</td>
<td style="width:200px;height:31px; padding: 5px">
<p>İlgili mevzuat hükümlerine göre Şirket’in ticari faaliyetlerine ilişkin stratejilerinin ve denetim faaliyetlerinin tasarlanması konusunda yetkili olan hissedarlar</p>
</td>
<td style="width:200px;height:31px; padding: 5px">
<p>Şirket’in ticari faaliyetlerine ilişkin stratejilerin tasarlanması ve denetim amaçlarıyla sınırlı olarak kişisel verilerin paylaşımı</p>
</td>
</tr>
<tr>
<td style="width:200px;height:33px; padding: 5px">
<p>Şirket Yetkilileri</p>
</td>
<td style="width:200px;height:33px; padding: 5px">
<p>Yönetim kurulu üyeleri ve diğer yetkilendirilen kişiler</p>
</td>
<td style="width:200px;height:33px; padding: 5px">
<p>Şirket’in ticari faaliyetlerine ilişkin stratejilerin tasarlanması, en üst düzeyde yönetiminin sağlanması ve denetim amaçlarıyla sınırlı olarak kişisel verilerin paylaşımı</p>
</td>
</tr>
<tr>
<td style="width:200px;height:62px; padding: 5px">
<p>Hukuken Yetkili Kamu Kurum ve Kuruluşları</p>
</td>
<td style="width:200px;height:62px; padding: 5px">
<p>Hukuken Şirket’ten bilgi ve belge almaya yetkili kamu kurum ve kuruluşları</p>
</td>
<td style="width:200px;height:62px; padding: 5px">
<p>İlgili kamu kurum ve kuruluşlarının bilgi talep etme amacıyla sınırlı olarak kişisel veri paylaşımı</p>
</td>
</tr>
<tr>
<td style="width:200px;height:63px; padding: 5px">
<p>Hukuken Yetkili Özel Hukuk Kişileri</p>
</td>
<td style="width:200px;height:63px; padding: 5px">
<p>Hukuken Şirket’ten bilgi ve belge almaya yetkili özel hukuk kişileri</p>
</td>
<td style="width:200px;height:63px; padding: 5px">
<p>İlgili özel hukuk kişilerinin hukuki yetkisi dahilinde talep ettiği amaçla sınırlı olarak verilerin paylaşımı</p>
</td>
</tr>
<tr>
<td style="width:200px;height:31px; padding: 5px">
<p>Şirket Tedarikçileri</p>
</td>
<td style="width:200px;height:31px; padding: 5px">
<p>Okulsepeti ticari faaliyetlerini yürütürken Şirketimizin emir ve talimatlarına uygun olarak sözleşme temelli olarak Şirketimize hizmet sunan tarafları tanımlamaktadır.</p>

<p></p>
</td>
<td style="width:200px;height:31px; padding: 5px">
<p>Okulsepeti’nin tedarikçiden dış kaynaklı olarak temin ettiği ve Okulsepeti’nin ticari faaliyetlerini yerine getirmek için gerekli hizmetlerin Okulsepeti tarafından sunulmasını sağlamak amacıyla sınırlı olarak</p>

<p></p>
</td>
</tr>
<tr>
<td style="width:200px;height:33px; padding: 5px">
<p>Şirket İştirakleri</p>
</td>
<td style="width:200px;height:33px; padding: 5px">
<p>Şirket’in hissedarı olduğu şirketler</p>

<p></p>
</td>
<td style="width:200px;height:33px; padding: 5px">
<p>Şirket’in iştiraklerinin de katılımını gerektiren ticari faaliyetlerin yürütülmesini temin etmekle sınırlı olarak</p>

<p></p>
</td>
</tr>
<tr>
<td style="width:200px;height:63px; padding: 5px">
<p>Veri Aktarım Şartlarına Uygun Diğer Üçüncü Kişiler</p>
</td>
<td style="width:200px;height:63px; padding: 5px">
<p>Kanun’a uygun olarak veri aktarım şartlarına uygun olabilecek diğer üçüncü kişiler</p>
</td>
<td style="width:200px;height:63px; padding: 5px">
<p>Şirket’in ticari faaliyetleri ve yönetimini sağlamak amacıyla sınırlı olarak</p>
</td>
</tr>
</tbody>
</table>

<h2>5. Kişisel Verilere İlişkin Haklar ve Yükümlülükler</h2>

<h3>5.1. Kişisel Veri Sahiplerinin Şirket Tarafından Aydınlatılması Yükümlülüğü:</h3>

<p>Kanun’un 10. maddesi uyarınca; Şirket, kişisel verilerin elde edilmesi sırasında kişisel veri sahiplerini aydınlatmakla yükümlüdür. Bu kapsamda Şirket, kişisel verilerin toplanması esnasında veri sahiplerine kişisel verilerin Şirket tarafından işleneceğini, kişisel verilerinin hangi amaçlarla işleneceğini, işlenen kişisel verilerin kimlere ve hangi amaçla aktarılabileceğini, kişisel veri toplama yöntemi ve hukuki sebepleri Kanun’un 11. maddesi uyarınca veri sahibinin haklarının neler olduğunu bildirmekte ve Kanun uyarınca gerekli olduğu takdirde açık rıza almaktadır.</p>

<h3>5.2. Kişisel Veri Sahibinin Hakları ve Başvuru Yöntemi:</h3>

<p>Kişisel veri sahibi, Kanun’un 11. maddesi uyarınca Şirket’e başvurarak aşağıdaki taleplerde bulunabilir:</p>

<p></p>

<ol>
<li>Kişisel verilerinin işlenip işlenmediğini öğrenme,</li>
<li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
<li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
<li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
<li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li>Kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkması halinde bu sonuca itiraz etme,</li>
<li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme.</li>
</ol>

<p style="margin-left:18pt;"></p>

<p>Kişisel veri sahiplerinin Kanun’un 13. maddesinin 1. fıkrası gereğince yukarıda belirtilen haklarını kullanmakla ilgili taleplerini “yazılı” olarak, Şirket’in <a href="http://www.okulsepeti.com.tr" target="_blank"  rel="noreferrer">www.okulsepeti.com.tr</a> com adresinde bulunan Okulsepeti Pazarlama Anonim Şirketi Veri Sahibi Başvuru Formu’nu doldurarak ıslak imzalı veya güvenli elektronik imzalı olarak veya KVK Kurulunun belirlediği diğer yöntemlerle Kuruma iletmeleri gerekmektedir. İletişim adresleri aşağıdaki şekildedir;</p>

<p>Adres: Okulsepeti Pazarlama Anonim Şirketiİdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul</p>

<p></p>

<p>Kişisel veri sahipleri adına üçüncü kişiler tarafından talepte bulunulması mümkün olmayıp, üçüncü bir kişinin talepte bulunması için konuya ilişkin olarak kişisel veri sahibi tarafından başvuruda bulunacak üçüncü kişi adına düzenlenen özel vekâletname ile yetki verilmiş olması gerekmektedir.</p>

<p>Kişisel verilerin doğrudan veri sahibinden elde edilmemesi halinde; Şirket tarafından (1) kişisel verilerin elde edilmesinden itibaren makul bir süre içerisinde, (2) kişisel verilerin veri sahipleri kişi ile iletişim amacıyla kullanılacak olması durumunda, ilk iletişim kurulması esnasında, (3) kişisel verilerin aktarılacak olması halinde, en geç kişisel verilerin ilk kez aktarımının yapılacağı esnada veri sahiplerinin aydınlatılmasına ilişkin faaliyetler yürütülmektedir.</p>

<h3>5.3. Kişisel Veri Sahibinin Haklarını İleri Süremeyeceği Haller:</h3>

<p>Kişisel veri sahipleri, Kanun’un 28. maddesi gereğince aşağıdaki haller Kanun kapsamı dışında tutulduğundan, bu konularda bu Politika’nın 5.2 başlığı altında sayılan haklarını ileri süremezler:</p>

<ol>
<li>Kişisel verilerin, üçüncü kişilere verilmemek ve veri güvenliğine ilişkin yükümlülüklere uyulmak kaydıyla gerçek kişiler tarafından tamamen kendisiyle veya aynı konutta yaşayan aile fertleriyle ilgili faaliyetler kapsamında islenmesi,</li>
<li>Kişisel verilerin resmi istatistik ile anonim hâle getirilmek suretiyle araştırma, planlama ve istatistik gibi amaçlarla işlenmesi,</li>
<li>Kişisel verilerin millî savunmayı, millî güvenliği, kamu güvenliğini, kamu düzenini, ekonomik güvenliği, özel hayatın gizliliğini veya kişilik haklarını ihlal etmemek ya da suç teşkil etmemek kaydıyla, sanat, tarih, edebiyat veya bilimsel amaçlarla ya da ifade özgürlüğü kapsamında işlenmesi,</li>
<li>Kişisel verilerin millî savunmayı, millî güvenliği, kamu güvenliğini, kamu düzenini veya ekonomik güvenliği sağlamaya yönelik olarak kanunla görev ve yetki verilmiş kamu kurum ve kuruluşları tarafından yürütülen önleyici, koruyucu ve istihbari faaliyetler kapsamında işlenmesi,</li>
<li>Kişisel verilerin soruşturma, kovuşturma, yargılama veya infaz işlemlerine ilişkin olarak yargı makamları veya infaz mercileri tarafından işlenmesi.</li>
</ol>

<p>Kanun’un 28. maddesinin 2. fıkrası gereğince; aşağıda sıralanan hallerde kişisel veri sahipleri zararın giderilmesini talep etme hakkı hariç, bu Politika’nın 5.2 başlığı altında sayılan diğer haklarını ileri süremezler:</p>

<ol>
<li>Kişisel veri işlemenin suç işlenmesinin önlenmesi veya suç soruşturması için gerekli olması,</li>
<li>Kişisel veri sahibinin kendisi tarafından alenileştirilmiş kişisel verilerin işlenmesi,</li>
<li>Kişisel veri işlemenin kanunun verdiği yetkiye dayanılarak görevli ve yetkili kamu kurum ve kuruluşları ile kamu kurumu niteliğindeki meslek kuruluşlarınca, denetleme veya düzenleme görevlerinin yürütülmesi ile disiplin soruşturma veya kovuşturması için gerekli olması,</li>
<li>Kişisel veri işlemenin bütçe, vergi ve mali konulara ilişkin olarak devletin ekonomik ve mali çıkarlarının korunması için gerekli olması.</li>
</ol>

<h3>5.4. Şirket Tarafından Kişisel Veri Sahiplerinin Başvurularına Cevap Verilmesi</h3>

<p>Kanun’un 13. maddesi uyarınca; kişisel veri sahibinin yukarıda yer alan usule uygun olarak ilettiği başvurusunda yer alan talepler, Şirket tarafından, talebin niteliğine göre en kısa sürede ve en geç otuz gün içinde ücretsiz olarak sonuçlandıracaktır. Yapılacak işlemin ayrıca bir maliyet gerektirmesi halinde, Şirket tarafından başvuru sahibinden KVK Kurulunca belirlenen tarifedeki ücret alınabilecektir. Başvurunun Şirket’in hatasından kaynaklanması halinde alınan ücret ilgiliye iade edilecektir.</p>

<p></p>

<p>Şirket, başvuruda bulunan kişinin kişisel veri sahibi olup olmadığını tespit etmek, başvuruda yer verilen talepleri netleştirmek adına ilgili kişiden bilgi talep edebilir. Politika’nın 5.2 başlığı altında belirtilen usule uygun olarak ve/veya kanunen geçerli tebligat ile iletilmeyen taleplerin Şirket’e ulaşmaması halinde Şirket’in sorumluluğundan bahsedilemez.</p>

<p></p>

<p>Şirket, Kanun’un 28. maddesinde bahsedilen durumlar ve aşağıda yer alan hallerde başvuruda bulunan kişinin başvurusunu, gerekçesini açıklayarak reddedebilir:</p>

<p></p>

<ol>
<li>Kişisel veri sahibinin talebinin diğer kişilerin hak ve özgürlüklerini engelleme ihtimali olması,</li>
<li>Orantısız çaba gerektiren taleplerde bulunulmuş olması,</li>
<li>Talep edilen bilginin kamuya açık bir bilgi olması.</li>
</ol>

<h3>5.5. Kişisel Veri Sahibinin KVK Kurulu’na Şikayette Bulunma Hakkı</h3>

<p>Kişisel veri sahibi, Kanun’un 14. maddesinde belirtildiği şekilde kurula şikayette bulunabilir.</p>

<p>Kişisel veri sahibi, Kanun’un 13. maddesi ve de bu Politika’nın 5.2 bölümünde düzenlenen başvuru hakkını kullanmadan, KVK Kurulu’na şikayet yoluna başvuramaz.</p>

<h2>6. Kişisel Verilerin Güvenli Bir Şekilde Saklanması İle Hukuka Aykırı Olarak İşlenmesi Ve Erişilmesinin Önlenmesi İçin Alınan Teknik Ve İdari Tedbirler</h2>

<p>Şirket, Kanun’un 12. maddesine uygun olarak, güvenlik düzeyini sağlamaya yönelik gerekli her türlü teknik ve idari tedbirleri almakta, bu kapsamda gerekli denetimleri yapmak veya üçüncü kişi firmalar ile yapılan sözleşmeler çerçevesinde yaptırmaktadır.</p>

<h3>6.1. Kişisel Verilerin İşlenmesinde Gizlilik</h3>

<p>Şirket tarafından hukuka uygun olarak işlenen kişisel veriler, veri güvenliğine tabidir. Şirket, özel nitelikli kişisel veriler ve web sitelerimiz ve/veya diğer uygulamalarımız üzerinden toplanan kişisel verilerinizin gizliliğini ve güvenliğini sağlamak üzere tüm gerekli teknik ve organizasyonel önlemleri almaktadır.</p>

<p></p>

<p>Şirket’in herhangi bir çalışanının bu verilere yetkisiz şekilde erişmesi, bu verileri işlemesi veya özel veya ticari amaçlarla kullanması, bu verileri yetkisiz kişilerle paylaşması veya başka bir yöntemle bu verileri erişilebilir hale getirmeleri yasaktır. Şirket’in çalışanları kişisel verilere ancak söz konusu görevlerinin türü ve kapsamı çerçevesinde uygun şekilde erişebilir. Bunun için rol ve sorumluluklar detaylandırılmakta ve ayrıştırılmaktadır. Şirket’in meşru görevi çerçevesinde yetkilendirilmemiş olan herhangi bir çalışanının bu verileri işlemesi yetkisiz işlem anlamına gelmektedir.</p>

<p></p>

<p>Yöneticiler, istihdam ilişkisinin başlangıç aşamasında çalışanlarını veri gizliliğini koruma yükümlülüğü hususunda bilgilendirmelidir. Söz konusu yükümlülük istihdamın sona ermesinden sonra da devam edecektir.</p>

<h3>6.2. Kişisel Verilerin İşlenmesinde Güvenlik</h3>

<p>Kişisel veriler, yetkisiz erişime, yasa dışı veri işleme veya ifşaya ve verilerin kazara kaybına, değiştirilmesine veya imhasına karşı Şirket tarafından korunmaktadır. Kişisel verilerinizin halka açık olmayan ve sadece yetkili Şirket çalışanları (çalışanlarımızla yapılan Gizlilik Sözleşmesi kapsamında), aracılarımız ve yüklenicilerimiz tarafından erişilebilen güvenli çalışma ortamlarında saklanmaktadır.</p>

<p></p>

<p>Kişisel verilere erişmeden önce kişisel verileri saklanan veri sahibinin, web sitesi veya uygulama üzerinden kimlik bilgilerinin doğrulanması yapılmaktadır. İşbu hüküm, veriler ister elektronik ortamda ister kağıt üzerinde işlensin, geçerli olacaktır. Yeni bilgi teknolojisi sistemleri gibi yeni veri işleme yöntemleri ortaya çıkıncaya kadar, kişisel verileri korumaya yönelik olarak aşağıda tanımlanan teknik ve idari tedbirler hayata geçirilmektedir.</p>

<h3>6.3. Teknik Tedbirler</h3>

<p>Şirket bünyesinde kişisel veri işleme faaliyetleri ile güvenli ortamda saklanması teknik sistemlerle yürütülmekte, teknik çözüm uygulamaları yapılmaktadır. Teknolojideki gelişmelere uygun teknik önlemler alınmakta, alınan önlemler periyodik olarak güncellenmekte ve yenilenmektedir.</p>

<p></p>

<p>Alınan teknik önlemler periyodik olarak iç denetim mekanizması gereği ilgilisine raporlanmakta ve risk teşkil eden hususlar yeniden değerlendirilerek gerekli teknolojik çözüm üretilmekte ve teknik konularda bilgili personel istihdam edilmektedir.</p>

<p></p>

<p>Virüs koruma sistemleri ve güvenlik duvarlarını içeren yazılımlar ve donanımlar kullanılmaktadır. Örneğin Okulsepeti e-ticaret siteleri gibi online servisler ile kişisel verilerin toplandığı tüm web sayfalarında Secure Sockets Layer (SSL) şifrelemesi kullanılmaktadır. Bu servislerden faydalanmak için, Safari, Firefox, Chrome veya Internet Explorer gibi SSL-destekli bir tarayıcı kullanılması gerekmektedir. Bu sayede, internet üzerinden iletilen kişisel verilerinizin gizliliği korunabilmektedir.</p>

<p></p>

<p>Şirket, kartlı ödeme sistemlerinde veri güvenliğini sağlamak amacıyla oluşturulmuş PCI DSS (Payment Card Industry Data Security Standard) regülasyonlarına uyar ve kartlı ödeme sistemlerinde veri iletimini ve işleyişini güvenli olarak sağlar. Kredi kartı numarası Şirket’in online kredi kartı uygulaması tarafından şifrelenerek bankaya iletilmekte ve üçüncü taraflarla asla paylaşılmamaktadır. Kredi kartı bilgileri Şirket tarafından saklanmamaktadır.</p>

<p></p>

<p>Kişisel verilerin güvenli bir biçimde saklanmasını sağlamak için hukuka uygun bir biçimde yedekleme programları kullanılmaktadır. Ayrıca, Şirket bünyesinde kullanılan veri sınıflandırma sistemi, veri sızıntısı önleme (DLP) sistemi ile entegre edilmiştir. Böylece Şirket bünyesinde kişisel veri içeren tüm elektronik dokümanlar sınıflandırılmak zorunda olup, kurum dışına çıkartılması ise DLP sistemi ile kontrol altında tutulmaktadır.</p>

<h3>6.4. İdari Tedbirler</h3>

<p>Çalışanlar, kişisel verilerin korunması hukuku ve kişisel verilerin hukuka uygun olarak işlenmesi, mevzuata aykırı olarak başkasına açıklanamayacağı ve işleme amacı dışında kullanamayacağı konusunda bilgilendirilmekte ve eğitilmektedir. Bu doğrultuda, Şirket ile çalışanları arasındaki sözleşme ve belgelere, Şirket talimatları ve kanunla getirilen istisnalar dışında, kişisel verileri işlememe, ifşa etmeme ve kullanmama yükümlülüğü getiren kayıtlar ile taahhütler eklenmektedir. Çalışanların kişisel verileri işlememe, ifşa etmeme ve kullanmama yükümlülüğüne uyumlarının denetimini ve uygulamanın sürekliliğini sağlamak için gerekli idari tedbirler alınmaktadır.</p>

<p></p>

<p>Şirket tarafından kişisel verilerin hukuka uygun olarak aktarıldığı kişiler ve kişisel verilerin saklanması konusunda üçüncü kişilerden teknik hizmet alınması halinde bu kişiler ile akdedilen sözleşmelere; kişisel verilerin hukuka aykırı olarak işlenmesinin önlenmesi, verilere hukuka aykırı olarak erişilmesinin önlenmesi ve verilerin hukuka uygun muhafazasının sağlanması konusunda gerekli tedbirlerin alınması ve kendi kuruluşlarında bu tedbirlere uyulmasını sağlayacağına ilişkin hükümler eklenmektedir.</p>

<h3></h3>

<h3>6.5. Denetim Faaliyetlerinin Yürütülmesi</h3>

<p>Şirket, Kanun’un 12. maddesine uygun olarak, kendi ve iş ortakları bünyesinde gerekli denetimleri yapmakta veya 3. kişi firmalar ile yapılan sözleşmeler çerçevesinde yaptırmaktadır. Bu denetim sonuçları şirketin iç işleyişi kapsamında konu ile ilgili bölüme raporlanmakta ve alınan tüm tedbirlerin iyileştirilmesi için gerekli faaliyetler yürütülmektedir.</p>

<h3>6.6. Kişisel Verilerin Kanuni Olmayan Şekilde İfşası Durumunda Alınacak Tedbirler</h3>

<p>Şirket, Kanun ve ilgili mevzuata uygun olarak işlenen kişisel verilerin, kanuni olmayan yollarla başkaları tarafından elde edilmesi halinde, Kanun’un 12. maddesinin 5. fıkrası uyarınca, belirtilenleri yapmakla yükümlü olup; gerekli tespit ve bildirimin yapılmasını sağlamak amacı ile gerekli sistem oluşturulmaktadır. KVK Kurulu’na yapılan bildirimin akabinde, KVK Kurulu, KVK Kanunu’nun 12. maddesinin 5. fıkrasında belirtildiği şekilde bu durumu ilan edebilir.</p>

<h2>7. Kişisel Verilerin Silinmesi, Yok Edilmesi, Anonim Hale Getirilmesi</h2>

<p>Türk Ceza Kanunu’nun 138. maddesinde ve Kanun’un 7. maddesinde düzenlendiği üzere ilgili kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması halinde Şirket’in kararına istinaden veya kişisel veri sahibinin talebi üzerine kişisel veriler silinir, yok edilir veya anonim hale getirilir. Bu kapsamda Şirket ilgili yükümlülüğünü yerine getirmek üzere Şirket içerisinde gerekli teknik ve idari tedbirleri alarak; bu konuda gerekli işleyiş mekanizmaları geliştirmiş olup; bu yükümlülüklerine uygun davranmak üzere ilgili iş birimlerini eğitmekte, görevlendirme ve farkındalıklarını sağlamaktadır.</p>

<h3>7.1. Kişisel Verilerin Hukuka Uygun Olarak İmha Edilmesine İlişkin Esaslar</h3>

<p>Kişisel verilerin silinmesi, yok edilmesi ve anonim hale getirilmesiyle ilgili yapılan bütün işlemler kayıt altına alınır ve söz konusu kayıtlar, diğer hukuki yükümlülükler hariç olmak üzere en az üç yıl süreyle saklanır.</p>

<p></p>

<p>Şirket, kişisel verilerin saklanmasında ve imhasında aşağıdaki ilkelere uymaktadır;</p>

<ol>
<li>Hukuka ve dürüstlük kurallarına uygun olma,</li>
<li>Doğru ve gerektiğinde güncel olma,</li>
<li>Belirli, açık ve meşru amaçlar için işlenme,</li>
<li>İşlendikleri amaçla bağlantılı, sınırlı ve ölçülü olma,</li>
<li>İlgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza edilme.</li>
</ol>

<p></p>

<p>Şirket kişisel verileri aşağıdaki sebeplerle imha eder;</p>

<ol>
<li>Kişisel verilerin saklanmasına ilişkin yasalarla belirlenmiş sürelerin sona ermesi,</li>
<li>Şirket tarafından belirlenen imha süresinin sona ermesi,</li>
<li>Şirket tarafından belirlenen periyodik imha süresinin sona ermesi,</li>
<li>Kişisel verileri işlemeye esas teşkil eden ilgili mevzuat hükümlerinin değiştirilmesi veya ilgası,</li>
<li>İlgili sözleşmenin hiç kurulmamış olması, sözleşmenin geçerli olmaması, sözleşmenin kendiliğinden sona ermesi, sözleşmenin feshi veya sözleşmeden dönülmesi,</li>
<li>Kişisel verilerin işlenmesini gerektiren amacın ortadan kalkması,</li>
<li>Kişisel verileri işlemenin hukuka veya dürüstlük kuralına aykırı olması,</li>
<li>Kişisel verileri işlemenin sadece açık rıza şartına istinaden gerçekleştiği hallerde, ilgili kişinin rızasını geri alması,</li>
<li>İlgili kişinin, hakları çerçevesinde kişisel verileri işleme faaliyetine ilişkin yaptığı başvurunun Şirket tarafından kabul edilmesi,</li>
<li>Şirket’in, ilgili kişi tarafından kişisel verilerinin silinmesi veya yok edilmesi talebi ile kendisine yapılan başvuruyu reddetmesi, verdiği cevabın yetersiz bulunması veya kanunda öngörülen süre içinde cevap vermemesi hallerinde; KVK Kuruluna şikayette bulunulması ve bu talebin KVK Kurulu tarafından uygun bulunması,</li>
<li>Kişisel verilerin saklanmasını gerektiren azami sürenin geçmiş olmasına rağmen, kişisel verileri daha uzun süre saklamayı haklı kılacak herhangi bir şartın mevcut olmaması,</li>
<li>Kanun’un 5. ve 6. maddelerindeki kişisel verilerin işlenmesini gerektiren şartların ortadan kalkması.</li>
</ol>

<h3>7.2. Kişisel Verilerin Silinmesi, Yok Edilmesi Teknikleri</h3>

<p>Kişisel verilerin silinmesi ya da yok edilmesi, kişisel verilerin ilgili kullanıcılar için hiçbir şekilde erişilemez ve tekrar kullanılamaz hale getirilmesi işlemidir.Şirket, aşağıda yer verilen teknikleri kullanmak sureti ile kişisel verileri silmekte veya yok etmektedir.</p>

<p></p>

<p>Kişisel verilerin silinmesi işlemi, diğer verilere de sistem içerisinde erişilememe ve bu verileri kullanamama sonucunu doğuracak ise Şirket aşağıdaki kuralları uygular;</p>

<ol>
<li>Kişisel verilerin ilgili kişiyle ilişkilendirilemeyecek duruma getirilerek arşivlenmesi,</li>
<li>Başka herhangi bir kurum, kuruluş ve/veya kişinin erişimine kapalı olması,</li>
<li>Kişisel verilere yalnızca yetkili kişiler tarafından erişilmesini sağlayacak şekilde gerekli her türlü teknik ve idari tedbirlerin alınması,</li>
<li>Gerçek kişiler tarafından direkt olarak silme talebinin iletilmesi durumunda ise ilgili kişiye ait kişisel verilerin Şirket sistemlerinden silinmesi,</li>
<li>Herhangi bir veri kayıt sisteminin parçasını teşkil eden ve otomatik olmayan yollarla işlenen kişisel verilerin silinmesi,</li>
<li>Gerekli olmayan kişisel verilerin karartılması,</li>
<li>Tarama yoluyla veya sayısallaştırılmadan elektronik ortama aktarılan kağıt halindeki gerekli olmayan kişisel verilerin maskelenmesi yoluyla gerçekleştirilir.</li>
</ol>

<p></p>

<p>Yukarıda belirtilen silme koşulları aşağıdaki yöntemlerle sağlanır;</p>

<h3>7.2.1. Fiziksel olarak yok etme</h3>

<p>Kişisel veriler herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla da işlenebilmektedir. Bu tür veriler silinirken/yok edilirken kişisel verinin sonradan kullanılamayacak biçimde fiziksel olarak yok edilmesi sistemi uygulanmaktadır.</p>

<h3>7.2.2. Yazılımdan güvenli olarak silme</h3>

<p>Tamamen veya kısmen otomatik olan yollarla işlenen ve dijital ortamlarda muhafaza edilen veriler silinirken/yok edilirken; bir daha kurtarılamayacak biçimde verinin ilgili yazılımdan silinmesine ilişkin yöntemler kullanılır.</p>

<h3>7.2.3. Uzman tarafından güvenli olarak silme</h3>

<p>Şirket, bazı durumlarda kendisi adına kişisel verileri silmesi için bir uzman ile anlaşabilir. Bu durumda, kişisel veriler bu konuda uzman olan kişi tarafından bir daha kurtarılamayacak biçimde güvenli olarak silinir/yok edilir.</p>

<p><strong>7.3. Kişisel Verilerin Anonim Hale Getirilmesi Teknikleri</strong></p>

<p>Kişisel verilerin anonim hale getirilmesi, kişisel verilerin başka verilerle eşleştirilse dahi hiçbir surette kimliği belirli veya belirlenebilir bir gerçek kişiyle ilişkilendirilemeyecek hale getirilmesidir. Şirket, hukuka uygun olarak işlenen kişisel verilerin işlenmesi şartlarının ortadan kalkması halinde kişisel verileri anonimleştirebilmektedir. Bu şekilde anonimleştirilen kişisel veriler Kanun’un 28. maddesine uygun olarak araştırma, planlama ve istatistik gibi amaçlarla işlenebilmektedir. Bu tür işlemeler Kanun kapsamı dışında olup, kişisel veri sahibinin açık rızası aranmayacaktır. Anonim hale getirilerek işlenen kişisel veriler Kanun kapsamı dışında olacağından bu Politika’nın 5.2 başlığı altında düzenlenen haklar bu veriler için geçerli olmayacaktır.</p>

<p></p>

<p>Şirket, kişisel verilerin anonimleştirmesi için aşağıda yer verilen teknikleri kullanmaktadır.</p>

<p><strong>7.3.1. Maskeleme</strong></p>

<p>Veri maskeleme, kişisel verinin temel belirleyici bilgisinin veri seti içerisinden çıkartılarak kişisel verinin anonim hale getirilmesi yöntemidir. Örneğin, kişisel veri sahibinin tanımlanmasını sağlayan adı, soyadı, T.C. Kimlik No vb. bilginin çıkartılması.</p>

<p><strong>7.3.2. Toplulaştırma</strong></p>

<p>Veri toplulaştırma yöntemi ile birçok veri toplulaştırılmakta ve kişisel veriler herhangi bir kişiyle ilişkilendirilemeyecek hale getirilmektedir. Örneğin, yaşları belirtilmeksizin X yaşında Y kadar müşteri olduğunun belirtilmesi.</p>

<p><strong>7.3.3. Veri türetme</strong></p>

<p>Veri türetme yöntemi ile kişisel verinin içeriğinden daha genel bir içerik oluşturulmakta ve kişisel verinin herhangi bir kişiyle ilişkilendirilemeyecek hale getirilmesi sağlanmaktadır. Örneğin doğum tarihi yerine yaşın belirtilmesi</p>

<p><strong>7.3.4. Veri karma</strong></p>

<p>Veri karma yöntemi ile kişisel veri seti içindeki değerler karıştırılarak değerler ile kişiler arasındaki bağın kopartılması sağlanmaktadır.</p>

<p><strong>7.4. Kişisel Verilerin Saklanma ve İmha Süreleri İle Periyodik İmha Süreleri</strong></p>

<p>Şirket, kişisel verileri silme, yok etme veya anonim hale getirme yükümlülüğünün ortaya çıktığı tarihi takip eden ilk periyodik imha işleminde, kişisel verileri siler, yok eder veya anonim hale getirir. Periyodik imhanın gerçekleştirileceği zaman aralığı altı aydır. Kişisel verilere ilişkin olarak saklama süreleri ise Kanun’a ve iş süreçlerine uygun olarak belirlenmiştir. KVK Kurulu, telafisi güç veya imkansız zararların doğması ve açıkça hukuka aykırılık olması halinde, bu maddede belirlenen süreleri kısaltabilmektedir.</p>

<p>Veri sahibi gerçek kişi, Kanun’un 13. maddesine istinaden Şirket’e başvurarak kendisine ait kişisel verilerin silinmesini veya yok edilmesini talep ettiğinde;</p>

<ol>
<li>Kişisel verileri işleme şartlarının tamamı ortadan kalkmışsa; Şirket talebe konu kişisel verileri siler, yok eder veya anonim hale getirir. Şirket, veri sahibi gerçek kişinin talebini en geç otuz gün içinde sonuçlandırır ve veri sahibi gerçek kişiye bilgi verir.</li>
<li>Kişisel verileri işleme şartlarının tamamı ortadan kalkmış ve talebe konu olan kişisel veriler üçüncü kişilere aktarılmışsa Şirket bu durumu üçüncü kişiye bildirir; üçüncü kişi nezdinde gerekli işlemlerin yapılmasını temin eder.</li>
<li>Kişisel verileri işleme şartlarının tamamı ortadan kalkmamışsa, bu talep Şirket tarafından Kanun’un 13. maddesinin 3. fıkrası uyarınca gerekçesi açıklanarak reddedilebilir ve ret cevabı ilgili kişiye en geç otuz gün içinde yazılı olarak ya da elektronik ortamda bildirilir.</li>
</ol>

<p><strong>7.4.1. Kişisel verilerin resen silinmesi, yok edilmesi veya anonim hale getirilmesi süreleri</strong></p>

<p>Şirket, kişisel verileri silme, yok etme veya anonim hale getirme yükümlülüğü kapsamında aşağıdaki süreleri dikkate alır:</p>

<ol>
<li>Yükümlülüğün ortaya çıktığı tarihi takip eden ilk periyodik imha işleminde</li>
<li>Periyodik imha süresi her halde 180 günden uzun olamaz.</li>
</ol>

<p><strong>7.4.2. İlgili kişinin talep etmesi durumunda kişisel verileri silme ve yok etme süreleri</strong></p>

<p>İlgili kişi, Şirket’e başvurarak kendisine ait kişisel verilerin silinmesini veya yok edilmesini talep ettiğinde;</p>

<ol>
<li>Kişisel verileri işleme şartlarının tamamı ortadan kalkmışsa; Şirket talebe konu kişisel verileri silebilir, yok edebilir veya anonim hale getirebilir. İlgili kişilerin silme veya yok etme talepleri Şirket tarafından en geç otuz gün içerisinde sonuçlandırılır.</li>
<li>Kişisel verileri işleme şartlarının tamamı ortadan kalkmamışsa, bu talep Şirket tarafından gerekçesi açıklanarak reddedilebilir ve ret cevabı ilgili kişiye en geç otuz gün içinde yazılı olarak ya da elektronik ortamda bildirilir.</li>
</ol>

<p><strong>7.5. Kişisel Verileri İşleme, Saklama ve İmha Süreçlerinin Şirket İçi Yönetimi</strong></p>

<p>Şirket, Kanun ve ilgili yasal mevzuat hükümlerine uyum süreci ve uyum sürecinin tamamlanması akabinde gerçekleştirilecek kişisel veriler ile ilgili her türlü işlemde, işbu Politika ve bu Politika’ ya bağlı süreçlerin yönetimini aşağıdaki şekilde gerçekleştirmektedir;</p>

<p>Şirket sistemlerinden kişisel verilerinin silinmesini isteyen bir müşteri; Kurumsal İnternet Sayfası, Mobil Uygulama, Çağrı Merkezi üzerinden veya Mağazalara bizzat başvurarak kişisel verilerinin silinmesini talep edebilir. Tüm kanallardan alınan talep, çağrı sistemine kaydedilir ve doğrulama işlemi için çağrı merkezi tarafından müşteri geri aranır. Müşterinin Okulsepeti ve E-Ticaret sistemlerinden hangisindeki verilerini sildireceği netleştirildikten sonra ilgili sistemlerdeki silme süreçleri çalıştırılarak müşteri verisi silinir.</p>

<p><strong>8. Kayıt Ortamları</strong></p>

<p>Şirket, Kanun’da ve diğer kanunlarda öngörülen usul ve esaslara uygun olarak, tamamen veya kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla işlediği kişisel verileri Şirket veri ambarına kaydetmekte ve depolamaktadır.</p>

<p><strong>8.1. Mağaza, Genel Müdürlük Binası vb. Girişinde ve/veya İçerisinde Yapılan Kayıt ve Takibi</strong></p>

<p>Şirket tarafından sunulan hizmetin kalitesini artırmak, güvenilirliğini sağlamak, şirketin, müşterilerin, şirket çalışanlarının ve diğer kişilerin güvenliğini sağlamak ve müşterilerin aldıkları hizmete ilişkin menfaatlerini korumak gibi amaçlarla, mağazalarda, binalarda ve tesislerde güvenlik kamerasıyla izleme suretiyle kişisel veri işleme faaliyetinde bulunulmaktadır. Şirketimiz tarafından yürütülen kamera ile izleme faaliyeti, Özel Güvenlik Hizmetlerine Dair Kanun ve ilgili mevzuata uygun olarak sürdürülmektedir. Kişinin mahremiyetini güvenlik amaçlarını aşan şekilde müdahale sonucu doğurabilecek alanlar izlemeye tabi tutulmamaktadır.</p>

<p></p>

<p>Şirket tarafından kişisel veri sahibi Kanun’un 10. maddesine uygun olarak, gerek internet sitesinde Gizlilik ve Veri Güvenliği Politikası’nın yayınlanması gerekse izlemenin yapıldığı alanların girişlerine izleme yapılacağına ilişkin bildirim yazısı asılmak suretiyle aydınlatılmakta ve elde edilen kişisel veriler bu Politika’da belirtilen idari ve teknik tedbirlerle korunmaktadır.</p>

<p><strong>8.2. İnternet Sitesi Ziyaretçileri</strong></p>

<p>İnternet erişimlerine ilişkin log kayıtları 5651 Sayılı Kanun ve bu Kanun’a göre düzenlenmiş olan mevzuatın amir hükümlerine göre kayıt altına alınmakta; bu kayıtlar ancak yetkili kamu kurum ve kuruluşları tarafından talep edilmesi veya Kurum içinde gerçekleştirilecek denetim süreçlerinde ilgili hukuki yükümlülüğün yerine getirilmesi amacıyla işlenmektedir.</p>

<p></p>

<p>Şirket sahibi olduğu internet sitelerinde; bu siteleri ziyaret eden kişilerin sitelerdeki ziyaretlerini ziyaret amaçlarıyla uygun bir şekilde gerçekleştirmelerini temin etmek; kendilerine özelleştirilmiş içerikler gösterebilmek ve çevrimiçi reklamcılık faaliyetlerinde bulunabilmek maksadıyla teknik vasıtalarla (Ör. Kurabiyeler-cookie gibi) site içerisindeki internet hareketlerini kaydetmektedir.</p>

<p></p>

<p>Bu faaliyetlere ilişkin kişisel verilerin korunması ve işlenmesine ilişkin detaylı açıklamalar ilgili internet sitelerinin “Okulsepeti Pazarlama A.Ş. İnternet Sitesi Gizlilik ve Çerez Politikası” metinleri içerisinde yer almaktadır.</p>

<h2>Bizimle İletişime Geçin</h2>

<p>Kişisel Verilerin Korunması Politikası ile ilgili tüm soru ve görüşlerinizi iletmek için bize ulaşın!</p>

<p><a href="mailto:bilgi@okulsepeti.com.tr">bilgi@okulsepeti.com.tr</a></p>
      </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'Müşteri Aydınlatma Metni',
        modalConfig: {
          title: 'Müşteri Aydınlatma Metni',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: okul?.okul_musteri_aydinlatma_metni || `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
<title></title>
<p align="center"><strong><u>MÜŞTERİ AYDINLATMA METNİ</u></strong></p>

<p align="left"><br>
<strong>1. Veri Sorumlusu Kimliği:</strong><br>
İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul adresinde bulunan ve İstanbul Ticaret Sicili Müdürlüğü nezdinde 949196 sicil numarası ile kayıtlı olan Okul Sepeti Pazarlama A.Ş.(“<strong>Şirket</strong>”)’dir.</p>

<p align="left"><br>
<strong>2. Veri Kategorizasyonu:</strong></p>

<table border="1" cellpadding="0" cellspacing="10">
<tbody>
<tr>
<td bgcolor="#F3F3F3" width="168">
<p style="padding: 5px"><strong>Kimlik Bilgisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53">
<ul type="disc">
<li style="list-style:disc;"></li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="382">
<p style="padding: 5px">Ad, soyadı, T.C. kimlik numarası gibi(Bireysel Müşteriler) Firma unvanı gibi(Kurumsal Müşteriler)<br>
Öğrencinin adı soyadı, cinsiyeti gibi</p>
</td>
</tr>
<tr>
<td width="168">
<p style="padding: 5px"><strong>İletişim Bilgisi</strong></p>
</td>
<td width="53">
<ul type="disc">
<li style="list-style:disc;"></li>
</ul>
</td>
<td width="382">
<p style="padding: 5px">Telefon numarası, e-mail adresi gibi (Bireysel ve Kurumsal Müşteriler)</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="168">
<p style="padding: 5px"><strong>Lokasyon Bilgisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53">
<ul type="disc">
<li style="list-style:disc;"></li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="382">
<p style="padding: 5px">Ev adresi, iş adresi gibi</p>
</td>
</tr>
<tr>
<td width="168">
<p style="padding: 5px"><strong>Finans Bilgisi</strong></p>
</td>
<td width="53">
<ul>
<li style="list-style:disc;"></li>
</ul>

<p></p>
</td>
<td width="382">
<p style="padding: 5px">Vergi kimlik numarası, vergi dairesi (Kurumsal Müşteriler)</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="168">
<p style="padding: 5px"><strong>Fiziksel Mekân Güvenliği Bilgisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53">
<ul>
<li style="list-style:disc;"></li>
</ul>

<p></p>
</td>
<td bgcolor="#F3F3F3" width="382">
<p style="padding: 5px">Kamera kayıtları ile kaydedilen görüntüler gibi</p>
</td>
</tr>
<tr>
<td width="168">
<p style="padding: 5px"><strong>İşitsel Kayıtlar</strong></p>
</td>
<td width="53"></td>
<td width="382">
<p style="padding: 5px">Çağrı merkezi tarafından alınan ses kayıtları gibi</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="168">
<p style="padding: 5px"><strong>Hukuki İşlem Verisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53"></td>
<td bgcolor="#F3F3F3" width="382">
<p style="padding: 5px">Yetkili kamu kuruluşları ile yapılan adli yazışmalarda bulunan bilgiler gibi</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p><strong>3. Kişisel Verilerin Hangi Amaçlarla İşlendiği</strong></p>

<table border="1" cellpadding="0" cellspacing="14">
<tbody>
<tr>
<td align="left" valign="middle" width="189">
<p style="padding: 5px"><strong>Veri Kategorisi</strong></p>
</td>
<td align="left" valign="middle" width="272">
<p style="padding: 5px"><strong>Veri İşleme Amacı</strong></p>
</td>
<td align="left" valign="middle" width="221">
<p style="padding: 5px"><strong>Veri İşlemenin Hukuki Sebebi</strong></p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="189">
<p style="padding: 5px">Kimlik Bilgileri, İletişim Bilgileri, Lokasyon Bilgileri, Hukuki İşlem Verisi, Finans Bilgileri</p>
</td>
<td bgcolor="#F3F3F3" width="272">
<p></p>

<ul type="disc" style="paddinpadding-right: 5px">
<li style="list-style:disc;">okulsepeti.com site üyeliği tanımlama</li>
<li style="list-style:disc;">İletişim faaliyetlerinin yürütülmesi</li>
<li style="list-style:disc;">İş faaliyetlerinin yürütülmesi / denetimi</li>
<li style="list-style:disc;">Faaliyetlerin mevzuata uygun yürütülmesi</li>
<li style="list-style:disc;">Finans ve muhasebe işlerinin yürütülmesi</li>
<li style="list-style:disc;">Yetkili kişi, kurum ve kuruluşlara bilgi verilmesi</li>
<li style="list-style:disc;">Ürün satış faaliyetlerinin kaydının tutulması</li>
<li style="list-style:disc;">Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi</li>
<li style="list-style:disc;">Ürünlerin alıcıya tesliminin sağlanması</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="221">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>

<p></p>
</td>
</tr>
<tr>
<td width="189">
<p style="padding: 5px">Kimlik Bilgileri, Hukuki İşlem Verisi, İletişim Bilgileri, Lokasyon Bilgileri</p>
</td>
<td width="272">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Yetkili kişi, kurum ve kuruluşlara bilgi verilmesi</li>
</ul>
</td>
<td width="221">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="189">
<p style="padding: 5px">Fiziksel mekân güvenliği</p>
</td>
<td bgcolor="#F3F3F3" width="272">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Fiziksel mekân güvenliğinin temini</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="221">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td width="189">
<p style="padding: 5px">Finansal Bilgiler</p>
</td>
<td width="272">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Finans ve muhasebe işlerinin yürütülmesi</li>
</ul>
</td>
<td width="221">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="189">
<p style="padding: 5px">İşitsel Kayıtlar</p>
</td>
<td bgcolor="#F3F3F3" width="272">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Çağrı merkezi ile</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="221">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p></p>

<p><strong>4. Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği</strong></p>

<table border="1" cellpadding="0" cellspacing="14">
<tbody>
<tr>
<td width="146">
<p style="padding: 5px"><strong>Alıcı Grubu</strong></p>
</td>
<td width="250">
<p style="padding: 5px"><strong>Aktarım Amacı</strong></p>
</td>
<td width="231">
<p style="padding: 5px"><strong>Aktarımın Hukuki Sebebi</strong></p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="146">
<p style="padding: 5px">Yetkili kamu kurum ve kuruluşları</p>
</td>
<td bgcolor="#F3F3F3" width="250">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Kamera kayıtlarının istendiğinde Emniyet Müdürlüğü ve Adli makamlarla paylaşılması</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="231">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td width="146">
<p style="padding: 5px">Kargo firması ve kurye</p>
</td>
<td width="250">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Ürünlerin müşteriye teslimi</li>
</ul>
</td>
<td width="231">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="146">
<p style="padding: 5px">Tedarikçi (Okul-Öğrencinin okumakta olduğu okulun atadığı yetkili kiş)</p>
</td>
<td bgcolor="#F3F3F3" width="250">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Okulun, öğrencinin satın aldığı ürün verilerinin takibini yapabilmesi</li>
</ul>

<ul style="padding-right: 5px">
<li style="list-style:disc;">İş faaliyetlerinin yürütülmesi / denetimi</li>
</ul>

<p></p>
</td>
<td bgcolor="#F3F3F3" width="231">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td width="146">
<p style="padding: 5px">Tedarikçi (Yazılım firması)</p>
</td>
<td width="250">
<ul style="padding-right: 5px">
<li style="list-style:disc;">Sistemin çalışabilmesi amacıyla veri girişinin sağlanması</li>
</ul>

<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Teknik zorunluluklar ve sistemsel problemlerin çözümünün sağlanabilmesi</li>
</ul>
</td>
<td width="231">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="146">
<p style="padding: 5px">Tedarikçi (Bankalar, mali müşavirler)</p>
</td>
<td bgcolor="#F3F3F3" width="250">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Fatura düzenlemede Finansbank e-finans sistemi ile paylaşım</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="231">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td width="146">
<p style="padding: 5px">Tedarikçi (mali müşavir)</p>
</td>
<td width="250">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Finansal ve mali tabloların YMM şirketi tarafından onaylanması</li>
</ul>
</td>
<td width="231">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="146">
<p style="padding: 5px">Tedarikçi<br>
(Avukatlar)</p>
</td>
<td bgcolor="#F3F3F3" width="250">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Uyuşmazlıkların çözümü için</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="231">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td width="146">
<p style="padding: 5px">Tedarikçi (E-posta hizmeti tedarikçisi)</p>
</td>
<td width="250">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Şirket içi ve Şirket dışı e-posta kanalıyla yapılan iletişimin sağlanabilmesi amacıyla mali belgelerin ve müşteri bilgilerinin iletilmesi</li>
</ul>
</td>
<td width="231">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="146">
<p style="padding: 5px">Tedarikçi (İletişim şirketi)</p>
</td>
<td bgcolor="#F3F3F3" width="250">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Sipariş ve teslimatlarla ilgili bilgilendirme mesajlarının müşteriye sms ile gönderilmesi</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="231">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p></p>

<p><strong>5. Kişisel Verilerinizin Toplanma Yöntemleri</strong><br>
Yukarıda belirtilen kişisel verileriniz Şirket’e ilettiğiniz yönteme bağlı olarak fiziki veya elektronik ortamda toplanmakta ve yukarıda belirtilen amaçlar dâhilinde işlenmekte ve aktarılmaktadır.</p>

<p></p>

<p><br>
<strong>6. İlgili Kişiler’in Kişisel Verileri Üzerindeki Haklarının Neler Olduğunu ve Bu Hakları Nasıl Kullanabilecekleri</strong></p>

<p>KVKK m.11 uyarınca ilgili kişi sıfatıyla tarafımıza başvurarak;</p>

<ul type="disc">
<li style="list-style:disc;">Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
<li style="list-style:disc;">Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
<li style="list-style:disc;">Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
<li style="list-style:disc;">Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
<li style="list-style:disc;">Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li style="list-style:disc;">KVKK ve ilgili diğer mevzuata uygun olarak işlenmiş olmasına rağmen; amaç, süre ve meşrutiyet prensipleri dahilinde değerlendirilmek üzere kişisel verilerinizin işlenmesini gerektiren sebeplerin ortadan kalkması halinde, kişisel verilerinizin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li style="list-style:disc;">İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
<li style="list-style:disc;">Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini talep etme</li>
</ul>

<p>haklarına sahipsiniz.</p>

<p><br>
Yukarıda sıralanan haklarınıza yönelik başvurularınızı <strong><u><a href="https://kvkk.okulsepeti.com.tr/icerik/kvkk-basvuru-formu/" target="_blank"  rel="noreferrer">başvuru formu</a></u></strong> linkinde yer alan “ Veri Sorumlusuna Başvuru Form ”nu yazan talimatlara uygun olarak doldurarak, kullanabilirsiniz.<br>
Başvurular, ilgili veri sahibinin kimliğini tespit edecek belgelerle birlikte, aşağıdaki yöntemlerden biri ile gerçekleştirilecektir:<br>
Formun doldurularak ıslak imzalı kopyasının elden veya posta yoluyla İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul adresine iletilmesi,<br>
Formun 5070 sayılı Elektronik İmza Kanunu kapsamında düzenlenen güvenli elektronik imza ile imzalanarak okulsepetipazarlama@hs03.kep.tr adresine kayıtlı elektronik posta ile gönderilmesi,<br>
Şirket, Kanun’da öngörülmüş sınırlar çerçevesinde söz konusu hakları kullanmak isteyen veri sahiplerine, yine Kanun’da öngörülen şekilde azami otuz (30) gün içerisinde cevap vermektedir.<br>
Başvurunuzun ayrıca bir maliyeti gerektirmesi hâlinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilecektir.</p>

<p></p>
        </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'Aday Müşteri Aydınlatma Metni',
        modalConfig: {
          title: 'Aday Müşteri Aydınlatma Metni',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: okul?.okul_musteri_onay_aydinlatma_metni || `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
<title></title>
<p align="center"><strong><u>ADAY MÜŞTERİ AYDINLATMA METNİ</u></strong></p>

<p><strong>1. Veri Sorumlusu Kimliği:</strong><br>
İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul adresinde bulunan ve İstanbul Ticaret Sicili Müdürlüğü nezdinde 949196 sicil numarası ile kayıtlı olan Okul Sepeti Pazarlama A.Ş.(“Şirket”)’dir.</p>

<p></p>

<p><br>
<strong>2. Veri Kategorizasyonu:</strong></p>

<table border="1" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td bgcolor="#F3F3F3" width="166"><br>
<p style="padding: 5px"><strong>Kimlik Bilgisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53">
<ul type="disc">
<li style="list-style:disc;"></li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="376">
<p style="padding: 5px">Ad, soyadı gibi</p>
</td>
</tr>
<tr>
<td width="166">
<p style="padding: 5px"><strong>İletişim Bilgisi</strong></p>
</td>
<td width="53">
<ul type="disc">
<li style="list-style:disc;"></li>
</ul>
</td>
<td width="376">
<p style="padding: 5px">Ev/işyeri/cep telefon numaraları, e-posta adresi gibi</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="166">
<p style="padding: 5px"><strong>Fiziksel Mekân Güvenliği Bilgisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53"></td>
<td bgcolor="#F3F3F3" width="376">
<p style="padding: 5px">Kamera kayıtları ile kaydedilen görüntüler gibi</p>
</td>
</tr>
<tr>
<td width="166">
<p style="padding: 5px"><strong>İşitsel Kayıtlar</strong></p>
</td>
<td width="53">
<ul>
<li style="list-style:disc;"></li>
</ul>
</td>
<td width="376">
<p style="padding: 5px">Çağrı merkezi tarafından alınan ses kayıtları gibi</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="166">
<p style="padding: 5px"><strong>Hukuki İşlem Verisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53">
<ul>
<li style="list-style:disc;"></li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="376">
<p style="padding: 5px">Yetkili kamu kuruluşları ile yapılan adli yazışmalarda bulunan bilgiler gibi</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p></p>

<p><strong>3. Kişisel Verilerin Hangi Amaçlarla İşlendiği:</strong></p>

<table border="1" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td width="181"><br>
<strong>Veri Kategorisi</strong></td>
<td width="237">
<p align="center" style="padding: 5px"><strong>Veri İşleme Amacı</strong></p>
</td>
<td width="178">
<p align="center" style="padding: 5px"><strong>Veri İşlemenin Hukuki Sebebi</strong></p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="181">
<p style="padding: 5px">Kimlik Bilgileri, İletişim Bilgileri</p>
</td>
<td bgcolor="#F3F3F3" width="237">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">okulsepeti.com site üyeliği kaydı oluşturma</li>
<li style="list-style:disc;">aday müşteri portföyü oluşturma</li>
<li style="list-style:disc;">İletişim faaliyetlerinin yürütülmesi</li>
<li style="list-style:disc;">Sunulan ürün ve hizmetlerden müşterileri faydalandırmak için gerekli çalışmaların yapılması</li>
<li style="list-style:disc;">Müşteri kayıtları oluşturulması ve yönetilmesi</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="178">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td width="181">
<p style="padding: 5px">Kimlik Bilgileri, Hukuki İşlem Verisi, İletişim Bilgileri,</p>
</td>
<td width="237">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Yetkili kişi, kurum ve kuruluşlara bilgi verilmesi</li>
</ul>
</td>
<td width="178">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="181">
<p style="padding: 5px">Fiziksel Mekân Güvenliği</p>
</td>
<td bgcolor="#F3F3F3" width="237">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Fiziksel mekân güvenliğinin temini</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="178">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td width="181">
<p>İşitsel Kayıtlar</p>
</td>
<td width="237">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Çağrı merkezi aracılığı ile alınan kayıtlar</li>
</ul>
</td>
<td width="178">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p></p>

<p><strong>4. Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği:</strong></p>

<table border="1" cellpadding="0" cellspacing="14">
<tbody>
<tr>
<td width="212"><br>
<p style="padding: 5px"><strong>Alıcı Grubu</strong></p>
</td>
<td width="223">
<p align="center" style="padding: 5px"><strong>Aktarım Amacı</strong></p>
</td>
<td width="285">
<p align="center" style="padding: 5px"><strong>Aktarımın Hukuki Sebebi</strong></p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="212">
<p style="padding: 5px">Yetkili Kamu Kurum Ve Kuruluşları</p>
</td>
<td bgcolor="#F3F3F3" width="223">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Gerektiğinde kamera kayıtlarının Emniyet Müdürlüğü ve adli mercilerle paylaşılması</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="285">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td width="212">
<p style="padding: 5px">Şirket ortakları, Satış Departmanı Çalışanları ve diğer yetkili çalışanları</p>
</td>
<td width="223">
<ul>
<li style="list-style:disc;">Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi</li>
</ul>

<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Aday müşteri portföyü oluşturma</li>
<li style="list-style:disc;">Sunulan ürün ve hizmetlerden müşterileri faydalandırmak için gerekli çalışmaların yapılması</li>
<li style="list-style:disc;">Müşteri kayıtları oluşturulması ve yönetilmesi</li>
<li style="list-style:disc;">Aday müşteri şikayetlerinin çözülmesi ve veri erişim ve düzeltme taleplerinin işleme alınması</li>
</ul>
</td>
<td width="285">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="212">
<p style="padding: 5px">OKUL (Öğrencinin okumakta olduğu okul)</p>
</td>
<td bgcolor="#F3F3F3" width="223">
<ul style="padding-right: 5px">
<li style="list-style:disc;">Okulun, öğrencinin satın aldığı ürün verilerinin takibini yapabilmesi</li>
<li style="list-style:disc;">İş faaliyetlerinin yürütülmesi/ denetimi</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="285">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td width="212">
<p style="padding: 5px">Tedarikçi<br>
(Avukatlar)</p>
</td>
<td width="223">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Uyuşmazlıkların çözümü için</li>
</ul>
</td>
<td width="285">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="212">
<p style="padding: 5px">Tedarikçi (E-posta hizmeti tedarikçisi)</p>
</td>
<td bgcolor="#F3F3F3" width="223">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Şirket içi ve Şirket dışı e-posta kanalıyla yapılan iletişimin sağlanabilmesi amacıyla aday müşteri bilgilerinin iletilmesi</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="285">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td width="212">
<p style="padding: 5px">Yurtdışı Tedarikçi (yazılım sistemi tedarikçisi) depolama, arşivleme, bilişim teknolojileri desteği (sunucu, hosting, program, bulut bilişim)</p>
</td>
<td width="223">
<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Sistemin çalışabilmesi amacıyla veri girişinin sağlanması</li>
<li style="list-style:disc;">Teknik zorunluluklar ve sistemsel problemlerin çözümünün sağlanabilmesi</li>
<li style="list-style:disc;">Depolama ve arşivleme işlemlerinin yapılabilmesi</li>
</ul>
</td>
<td width="285">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="212">
<p style="padding: 5px">Tedarikçi (Çağrı merkezi hizmet sunucuları)</p>
</td>
<td bgcolor="#F3F3F3" width="223">
<ul style="padding-right: 5px">
<li style="list-style:disc;">Müşteri ilişkileri yönetimi süreçlerinin yürütülmesi</li>
</ul>

<ul type="disc" style="padding-right: 5px">
<li style="list-style:disc;">Müşteri ve şirket güvenliğinin temini</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="285">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası İçin Zorunlu Olması</p>
</td>
</tr>
</tbody>
</table>

<p><strong>5. Kişisel Verilerinizin Toplanma Yöntemleri</strong><br>
Yukarıda belirtilen kişisel verileriniz Şirket’e ilettiğiniz yönteme bağlı olarak fiziki veya elektronik ortamda toplanmakta ve yukarıda belirtilen amaçlar dâhilinde işlenmekte ve aktarılmaktadır.</p>

<p></p>

<p></p>

<p><strong>6. İlgili Kişiler ’in Kişisel Verileri Üzerindeki Haklarının Neler Olduğunu ve Bu Hakları Nasıl Kullanabilecekleri:</strong></p>

<p>KVKK m.11 uyarınca ilgili kişi sıfatıyla tarafımıza başvurarak;</p>

<ul type="disc">
<li style="list-style:disc;">Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
<li style="list-style:disc;">Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
<li style="list-style:disc;">Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
<li style="list-style:disc;">Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
<li style="list-style:disc;">Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li style="list-style:disc;">KVKK ve ilgili diğer mevzuata uygun olarak işlenmiş olmasına rağmen; amaç, süre ve meşrutiyet prensipleri dahilinde değerlendirilmek üzere kişisel verilerinizin işlenmesini gerektiren sebeplerin ortadan kalkması halinde, kişisel verilerinizin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li style="list-style:disc;">İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
<li style="list-style:disc;">Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini talep etme</li>
</ul>

<p>haklarına sahipsiniz.</p>

<p><br>
Yukarıda sıralanan haklarınıza yönelik başvurularınızı <strong><u><a href="https://kvkk.okulsepeti.com.tr/icerik/kvkk-basvuru-formu/" target="_blank"  rel="noreferrer">başvuru formu</a></u></strong> linkinde yer alan “ Veri Sorumlusuna Başvuru Form ”nu yazan talimatlara uygun olarak doldurarak, kullanabilirsiniz.<br>
Başvurular, ilgili veri sahibinin kimliğini tespit edecek belgelerle birlikte, aşağıdaki yöntemlerden biri ile gerçekleştirilecektir:<br>
Formun doldurularak ıslak imzalı kopyasının elden veya posta yoluyla İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul adresine iletilmesi,<br>
Formun 5070 sayılı Elektronik İmza Kanunu kapsamında düzenlenen güvenli elektronik imza ile imzalanarak okulsepetipazarlama@hs03.kep.tr adresine kayıtlı elektronik posta ile gönderilmesi,<br>
Şirket, Kanun’da öngörülmüş sınırlar çerçevesinde söz konusu hakları kullanmak isteyen veri sahiplerine, yine Kanun’da öngörülen şekilde azami otuz (30) gün içerisinde cevap vermektedir.<br>
Başvurunuzun ayrıca bir maliyeti gerektirmesi hâlinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilecektir.</p>

<p></p>
      </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'Tedarikçi Aydınlatma Metni',
        modalConfig: {
          title: 'Tedarikçi Aydınlatma Metni',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: okul?.okul_tedarikci_aydinlatma_metni || `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
<title></title>
<style type="text/css">div.a {
font-size: 22px; color:#3CF; font-weight: bold;}
</style>
<p align="center"><strong><u>TEDARİKÇİ AYDINLATMA METNİ</u></strong><u> </u></p>

<p><strong>1. Veri Sorumlusu Kimliği:</strong><br>
İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul adresinde bulunan ve İstanbul Ticaret Sicili Müdürlüğü nezdinde 949196 sicil numarası ile kayıtlı olan Okul Sepeti Pazarlama A.Ş.(“<strong>Şirket</strong>”)’dir.</p>

<p><br>
<strong>2. Veri Kategorizasyonu:</strong></p>

<table border="1" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td bgcolor="#F3F3F3" width="166"><br>
<p style="padding: 5px"><strong>Kimlik Bilgisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53">
<ul type="disc">
<li style="list-style:disc;"></li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="376">
<p style="padding: 5px">Ad, soyadı gibi</p>
</td>
</tr>
<tr>
<td width="166">
<p style="padding: 5px"><strong>İletişim Bilgisi</strong></p>
</td>
<td width="53">
<ul type="disc">
<li style="list-style:disc;"></li>
</ul>
</td>
<td width="376">
<p style="padding: 5px">Ev/işyeri/cep telefon numaraları, e-posta adresi gibi</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="166">
<p style="padding: 5px"><strong>Fiziksel Mekân Güvenliği Bilgisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53"></td>
<td bgcolor="#F3F3F3" width="376">
<p style="padding: 5px">Kamera kayıtları ile kaydedilen görüntüler gibi</p>
</td>
</tr>
<tr>
<td width="166">
<p style="padding: 5px"><strong>İşitsel Kayıtlar</strong></p>
</td>
<td width="53">
<ul>
<li style="list-style:disc;"></li>
</ul>
</td>
<td width="376">
<p style="padding: 5px">Çağrı merkezi tarafından alınan ses kayıtları gibi</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="166">
<p style="padding: 5px"><strong>Hukuki İşlem Verisi</strong></p>
</td>
<td bgcolor="#F3F3F3" width="53">
<ul>
<li style="list-style:disc;"></li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="376">
<p style="padding: 5px">Yetkili kamu kuruluşları ile yapılan adli yazışmalarda bulunan bilgiler gibi</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p><strong>3. KişiselVerilerin Hangi Amaçlarla İşlendiği:</strong></p>

<table border="1" cellpadding="0" cellspacing="8">
<tbody>
<tr>
<td width="181"><br>
<p style="padding: 5px"><strong>Veri Kategorisi</strong></p>
</td>
<td width="237">
<p style="padding: 5px"><strong>Veri İşleme Amacı</strong></p>
</td>
<td width="178">
<p style="padding: 5px"><strong>Veri İşlemenin Hukuki Sebebi</strong></p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="181">
<p style="padding: 5px">Kimlik Bilgileri, İletişim Bilgileri, Hukuki İşlem Verisi, Finans Bilgileri, Lokasyon Bilgileri</p>
</td>
<td bgcolor="#F3F3F3" width="237">
<ul type="disc" style="padding-right: 5px">
<li>Aday okullar ile iletişime geçilmesi</li>
<li>Teklif ve sözleşme hazırlanması</li>
<li>İlgili öğretmenlerin iletişim bilgilerinin alınması</li>
<li>Okul tedarikçi ile yapılan Sözleşme gereği site yöneticisi kimliği verilmesi</li>
<li>Ürün seçimi esnasında tüzel kişi ve/veya gerçek kişi tedarikçi ile iletişime geçilmesi</li>
<li>Ürün tedarikinin sağlanması</li>
<li>Şirket ticari ilişkilerinin kurulması</li>
<li>Satış sözleşmelerinin imzalanması</li>
<li>Şirketin ticari faaliyetlerini gerçekleştirmesi için yapılan tüm sözleşmeler</li>
<li>Satış sözleşmelerinin tedarikçi şirket yetkilisi tarafından imzalanması</li>
<li>Finans ve muhasebe işlerinin yürütülmesi</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="178">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td width="181">
<p style="padding: 5px">Kimlik Bilgileri, İletişim Bilgileri</p>
</td>
<td width="237">
<ul type="disc" style="padding-right: 5px">
<li>Satın alınan ürünlerin Şirket’e tedarikçi firma tarafından tesliminin sağlanması için, yetkili tedarikçi firma çalışanıyla Şirket tarafından iletişime geçilmesi</li>
<li>Satın alınan ürünlerin Şirket’e teslimini yapan kargo, kurye şirket çalışanlarının bilgilerinin alınması</li>
</ul>
</td>
<td width="178">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="181">
<p style="padding: 5px">Sağlık Bilgisi</p>
</td>
<td bgcolor="#F3F3F3" width="237">
<ul type="disc" style="padding-right: 5px">
<li>Şirketin ticari faaliyetlerini gerçekleştirmesi için okullarla yapılan anlaşmaların imzalanması sırasında okul yetkilisi tarafından imzalandığının ispatı için imza sirkülerinin ekinde bulunan kimlik fotokopisinin eski T.C. kimlik olması halinde</li>
<li>Ticari faaliyetlerini gerçekleştirmesi için yapılan satış sözleşmelerin tedarikçi şirket yetkilisi tarafından imzalandığının ispatı için imza sirkülerinin ekinde bulunan kimlik fotokopisinin eski T.C. kimlik olması halinde</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="178">
<p style="padding: 5px">KVKK m.5 f.1 Açık rızanıza istinaden</p>
</td>
</tr>
<tr>
<td width="181">
<p style="padding: 5px">Din Bilgisi</p>
</td>
<td width="237">
<ul>
<li>Şirketin ticari faaliyetlerini gerçekleştirmesi için okullarla yapılan anlaşmaların imzalanması sırasında okul yetkilisi tarafından imzalandığının ispatı için imza sirkülerinin ekinde bulunan kimlik fotokopisinin eski T.C. kimlik olması halinde</li>
</ul>

<ul type="disc" style="padding-right: 5px">
<li>Satış gibi Şirketin ticari faaliyetlerini gerçekleştirmesi için yapılan sözleşmelerin tedarikçi şirket yetkilisi tarafından imzalandığının ispatı için imza sirkülerinin ekinde bulunan kimlik fotokopisinin eski T.C. kimlik olması halinde</li>
</ul>
</td>
<td width="178">
<p style="padding: 5px">KVKK m.5 f.1 Açık rızanıza istinaden</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="181">
<p style="padding: 5px">Kimlik Bilgileri, Hukuki İşlem Verisi, İletişim Bilgileri, Lokasyon Bilgileri</p>
</td>
<td bgcolor="#F3F3F3" width="237">
<ul type="disc" style="padding-right: 5px">
<li>Yetkili kişi, kurum ve kuruluşlara bilgi verilmesi</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="178">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td width="181">
<p style="padding: 5px">Finansal Bilgiler</p>
</td>
<td width="237">
<ul type="disc" style="padding-right: 5px">
<li>Finans ve muhasebe işlerinin yürütülmesi</li>
</ul>
</td>
<td width="178">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="181">
<p style="padding: 5px">İşitsel Kayıtlar</p>
</td>
<td bgcolor="#F3F3F3" width="237">
<ul type="disc" style="padding-right: 5px">
<li>Çağrı merkezi aracılığı ile alınan kayıtlar</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="178">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p><strong>4. Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği:</strong></p>

<table border="1" cellpadding="0" cellspacing="8">
<tbody>
<tr>
<td width="115"><br>
<p style="padding: 5px"><strong>Alıcı Grubu</strong></p>
</td>
<td width="342">
<p style="padding: 5px"><strong>Aktarım Amacı</strong></p>
</td>
<td width="138">
<p style="padding: 5px"><strong>Aktarımın Hukuki Sebebi</strong></p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="115">
<p style="padding: 5px">Şirket ortakları ve diğer yetkili çalışanlar</p>
</td>
<td bgcolor="#F3F3F3" width="342">
<ul type="disc" style="padding-right: 5px">
<li>Ürün tedarik sürecinin kayıt altına alınması ve takibi</li>
<li>Ürün sipariş süreçlerinin yönetilmesi ve tamamlanması</li>
<li>Tedarikçi şikayetlerinin çözülmesi ve veri erişim ve düzeltme taleplerinin işleme alınması</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="138">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td width="115">
<p style="padding: 5px">Tedarikçi (Bankalar, mali müşavirler)</p>
</td>
<td width="342">
<ul style="padding-right: 5px">
<li>Tedarikçiye banka üzerinden ödeme yapabilmek için banka ile paylaşım</li>
</ul>
</td>
<td width="138">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası ile İlgili Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="115">
<p style="padding: 5px">Tedarikçi (mali müşavir)</p>
</td>
<td bgcolor="#F3F3F3" width="342">
<ul type="disc" style="padding-right: 5px">
<li>Finansal ve mali tabloların YMM şirketi tarafından onaylanması</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="138">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td width="115">
<p style="padding: 5px">Tedarikçi<br>
(Avukatlar)</p>
</td>
<td width="342">
<ul type="disc" style="padding-right: 5px">
<li>Uyuşmazlıkların çözümü için</li>
</ul>
</td>
<td width="138">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; Hukuki Yükümlülüğün Yerine Getirilmesi İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="115">
<p style="padding: 5px">Tedarikçi (E-posta hizmeti tedarikçisi)</p>
</td>
<td bgcolor="#F3F3F3" width="342">
<ul type="disc" style="padding-right: 5px">
<li>Şirket içi ve Şirket dışı e-posta kanalıyla yapılan iletişimin sağlanabilmesi amacıyla mali belgelerin ve tedarikçi bilgilerinin iletilmesi</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="138">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td width="115">
<p style="padding: 5px">Yurtdışı Tedarikçi (yazılım sistemi tedarikçisi) depolama, arşivleme, bilişim teknolojileri desteği (sunucu, hosting, program, bulut bilişim)</p>
</td>
<td width="342">
<ul type="disc" style="padding-right: 5px">
<li>Sistemin çalışabilmesi amacıyla veri girişinin sağlanması</li>
<li>Teknik zorunluluklar ve sistemsel problemlerin çözümünün sağlanabilmesi</li>
<li>Depolama ve arşivleme işlemlerinin yapılabilmesi</li>
</ul>
</td>
<td width="138">
<p style="padding: 5px">KVKK m.5 f.2 f bendi;<br>
Veri Sorumlusunun Meşru Menfaati</p>
</td>
</tr>
<tr>
<td bgcolor="#F3F3F3" width="115">
<p style="padding: 5px">Tedarikçi (Çağrı merkezi hizmet sunucuları)</p>
</td>
<td bgcolor="#F3F3F3" width="342">
<ul style="padding-right: 5px">
<li>Tedarikçi firma ile ilişki yönetimi süreçlerinin yürütülmesi</li>
</ul>
</td>
<td bgcolor="#F3F3F3" width="138">
<p style="padding: 5px">KVKK m.5 f.2 c bendi; Sözleşmenin Kurulması ve İfası İçin Zorunlu Olması</p>
</td>
</tr>
<tr>
<td width="115">
<p style="padding: 5px">Yetkili kamu kurum ve kuruluşları</p>
</td>
<td width="342">
<ul type="disc" style="padding-right: 5px">
<li>Vergi dairesi ile kanuni zorunluluktan ötürü paylaşım</li>
</ul>
</td>
<td width="138">
<p style="padding: 5px">KVKK m.5 f.2 ç bendi; hukuki yükümlülüğün yerine getirilmesi için zorunlu olması</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p><strong>5. Kişisel Verilerinizin Toplanma Yöntemleri</strong><br>
Yukarıda belirtilen kişisel verileriniz Şirket’e ilettiğiniz yönteme bağlı olarak fiziki veya elektronik ortamda toplanmakta ve yukarıda belirtilen amaçlar dâhilinde işlenmekte ve aktarılmaktadır.</p>

<p></p>

<p><br>
<strong>6. İlgili Kişiler’in Kişisel Verileri Üzerindeki Haklarının Neler Olduğunu ve Bu Hakları Nasıl Kullanabilecekleri</strong></p>

<p>KVKK m.11 uyarınca ilgili kişi sıfatıyla tarafımıza başvurarak;</p>

<ul type="disc">
<li style="list-style:disc;">Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
<li style="list-style:disc;">Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
<li style="list-style:disc;">Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
<li style="list-style:disc;">Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
<li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li style="list-style:disc;">KVKK ve ilgili diğer mevzuata uygun olarak işlenmiş olmasına rağmen; amaç, süre ve meşrutiyet prensipleri dahilinde değerlendirilmek üzere kişisel verilerinizin işlenmesini gerektiren sebeplerin ortadan kalkması halinde, kişisel verilerinizin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li style="list-style:disc;">İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
<li style="list-style:disc;">Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini talep etme</li>
</ul>

<p>haklarına sahipsiniz.</p>

<p><br>
Yukarıda sıralanan haklarınıza yönelik başvurularınızı <strong><u><a href="https://kvkk.okulsepeti.com.tr/icerik/kvkk-basvuru-formu/" target="_blank"  rel="noreferrer">başvuru formu</a></u></strong> linkinde yer alan “ Veri Sorumlusuna Başvuru Form ”nu yazan talimatlara uygun olarak doldurarak, kullanabilirsiniz.<br>
Başvurular, ilgili veri sahibinin kimliğini tespit edecek belgelerle birlikte, aşağıdaki yöntemlerden biri ile gerçekleştirilecektir:<br>
Formun doldurularak ıslak imzalı kopyasının elden veya posta yoluyla İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul adresine iletilmesi,<br>
Formun 5070 sayılı Elektronik İmza Kanunu kapsamında düzenlenen güvenli elektronik imza ile imzalanarak okulsepetipazarlama@hs03.kep.tr adresine kayıtlı elektronik posta ile gönderilmesi,<br>
Şirket, Kanun’da öngörülmüş sınırlar çerçevesinde söz konusu hakları kullanmak isteyen veri sahiplerine, yine Kanun’da öngörülen şekilde azami otuz (30) gün içerisinde cevap vermektedir.<br>
Başvurunuzun ayrıca bir maliyeti gerektirmesi hâlinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilecektir.</p>

<p></p>
      </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'Çağrı Merkezi Ses Kaydı Aydınlatma Metni',
        modalConfig: {
          title: 'Çağrı Merkezi Ses Kaydı Aydınlatma Metni',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: okul?.okul_cagri_merkezi_ses_kaydi_aydinlatma_metni || `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p></p>

<p align="center"><strong><u>OKUL SEPETİ PAZARLAMA A.Ş.</u></strong></p>

<p align="center"><strong><u>Çağrı Merkezi Ses Kaydı Aydınlatma Metni</u></strong></p>

<p></p>

<p>Veri Sorumlusu olan Okul Sepeti Pazarlama A.Ş.’ni (“<strong>Okul Sepeti</strong>”) arayanların paylaşmış olduğu ad, soyad, telefon numarası ve ses kaydı kişisel verileri;</p>

<ul>
<li>arayan kişiye doğru hitap edebilmek,</li>
<li>aramanın teyidi,</li>
<li>ileride doğabilecek olan uyuşmazlıklarda delil olarak kullanılabilmesi,</li>
<li>hizmet kalitesi takibi,</li>
<li>ürün ve hizmetlerimiz ile ilgili size bilgi verebilmek,</li>
</ul>

<p>amacıyla sınırlı olarak işlenmektedir. Bu kişisel veriler, 6698 Sayılı Kişisel Verilerin Korunması Kanunun 5. maddesinde belirtilen “ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri işlemenin zorunlu olması” hukuki sebebine bağlı olarak telefon yoluyla otomatik olarak işlenmekte olup sadece hukuki uyuşmazlıklarda talep durumunda ilgili yargı mercileriyle paylaşılacaktır. Kanun’un ilgili kişinin haklarını düzenleyen 11. maddesi kapsamındaki taleplerinizi, “Veri Sorumlusuna Başvuru Usul ve Esasları” Tebliğine göre Okul Sepeti’ne iletebilirsiniz.” Detaylı bilgiye <a href="https://okulsepeti.com.tr/kendi-okul-adiniz/icerik/kvkk-basvuru-formu/" target="_blank"  rel="noreferrer">https://okulsepeti.com.tr/kendi-okul-adiniz/icerik/kvkk-basvuru-formu/</a> adresimizden ulaşabilirsiniz.</p>

<p></p>

<p></p>
      </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'Gizlilik ve Çerez Politikası',
        modalConfig: {
          title: 'Gizlilik ve Çerez Politikası',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: okul?.okul_gizlilik_ve_cerez_politikasi || `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <style type="text/css">div.a {
font-size: 22px; font-weight: bold;
}

div.b {
font-size: 19px; font-weight: bold;
}

div.c {
font-size: 17px; font-weight: bold;
}

div.d {
font-size: 17px; font-weight:normal;
}
</style>
<div class="a">GİZLİLİK VE ÇEREZ POLİTİKASI</div>


<br><br>


<div class="d">Okulsepeti Pazarlama Anonim Şirketi <strong>(“Şirket”)</strong> tarafından işletilen işlettiği www.panelkirtasiye.com internet sitesini ziyaret edenlerin (“Veri Sahibi”) gizliliğini korumak Şirketimizin önde gelen ilkelerindendir. İnternet Sitesi Gizlilik ve Çerez Politikası (“Politika”) ile; (1) Veri Sahiplerinin kişisel verilerinin işlenmesi , (2) Çerez Politikası ve (3) İnternet Sitesi Gizlilik Politikası’nın yürürlüğü hakkında açıklamalar yapılmaktadır.


</div>


<br><br><br>




<div class="b">1. Veri Sahiplerinin Kişisel Verilerinin İşlenmesi</div>


<br><br>


<div class="d">İnternet sitemizi ziyaret etmeniz sırasında elde edilen kişisel veriler, veri sorumlusu olarak Şirket tarafından 6698 sayılı Kişisel Verilerin Korunması Kanunu <strong>(“Kanun”)</strong> uyarınca aşağıda açıklanan kapsamda işlenebilecektir. Kişisel verilerinizin işlenmesine ilişkin detaylı bilgilere, www.okulsepeti.com.tr internet adresinden ulaşabilirsiniz.


</div>

<br><br><br>



<div class="b">1.1 Kişisel Verilerinizin İşlenme Amacı</div>

<br><br>



<div class="d">İnternet Sitemizi ziyaret etmeniz dolayısıyla elde edilen kişisel verileriniz aşağıda sıralanan amaçlarla Şirket tarafından Kanun’un 5. ve 6. maddelerine uygun olarak işlenebilecektir:<br>

<ul>
<li style="list-style:disc;">Şirket tarafından yürütülen ticari faaliyetlerin gerçekleştirilmesi için ilgili iş birimlerimiz tarafından gerekli çalışmaların yapılması ve buna bağlı iş süreçlerinin yürütülmesi,</li>
<li style="list-style:disc;">Şirket tarafından sunulan ürün ve hizmetlerden ilgili kişileri faydalandırmak için gerekli çalışmaların iş birimlerimiz tarafından yapılması ve ilgili iş süreçlerinin yürütülmesi,</li>
<li style="list-style:disc;">Şirket tarafından sunulan ürün ve hizmetlerin ilgili kişilerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için gerekli olan aktivitelerin planlanması ve icrası.</li>
</ul>
</div>


<br><br><br>




<div class="b">1.2 Kişisel Verilerinizin Aktarıldığı Taraflar Ve Aktarım Amacı</div>



<br><br>



<div class="d">İnternet sitemizi ziyaret etmeniz dolayısıyla elde edilen kişisel verileriniz, kişisel verilerinizin işlenme amaçları doğrultusunda, iş ortaklarımıza, tedarikçilerimize kanunen yetkili kamu kurumlarına ve özel kişilere Kanun’un 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları dahilinde aktarılabilecektir<br>
</div>

<br><br><br>





<div class="b">1.3 Kişisel Verilerinizin Toplanma Yöntemi Ve Hukuki Sebebi</div>



<br><br>



<div class="d">Kimliğinizi belirli ya da belirlenebilir kılan her türlü bilgi “kişisel veri”dir. İnternet sitemizi ziyaretiniz kapsamında kişisel verileriniz Kanun’da yer alan veri işleme şartlarına uygun olarak İnternet Sitemizi ziyaret etmeniz dolayısıyla teknik iletişim dosyaları olan çerezler (cookies) vasıtasıyla toplanmaktadır.<br>
</div>

<br><br><br>





<div class="b">1.4 Veri Sahiplerinin Hakları</div>

<br><br>





<div class="d">Kişisel veri sahibi olarak Kanun’un 11. maddesi uyarınca aşağıdaki haklara sahip olduğunuzu bildiririz:<br>

<ul>
<li style="list-style:disc;">Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
<li style="list-style:disc;">Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
<li style="list-style:disc;">Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
<li style="list-style:disc;">Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
<li style="list-style:disc;">Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li style="list-style:disc;">Kanun’a ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
<li style="list-style:disc;">İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
<li style="list-style:disc;">Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini talep etme</li>
</ul>
<br>
Yukarıda sıralanan haklarınıza yönelik başvurularınızı <b><u><a href="#">Başvuru Formu</a></u></b> linkinde yer alan “Veri Sahibi Başvuru Formu”nu doldurarak şirketimize iletebilirsiniz. Talebinizin niteliğine göre en kısa sürede ve en geç otuz gün içinde başvurularınız ücretsiz olarak sonuçlandırılacaktır; ancak işlemin ayrıca bir maliyet gerektirmesi halinde Kişisel Verileri Koruma Kurulu tarafından belirlenecek tarifeye göre tarafınızdan ücret talep edilebilecektir.</div>

<br><br><br>



<div class="a">2-ÇEREZ POLİTİKASI</div>

<br><br>

<div class="d">Bu Çerez Politikası, çerezlerin ne olduğunu ve bunları nasıl kullandığımızı açıklar. Çerezlerin ne olduğunu, bunları nasıl kullandığımızı, kullandığımız çerez türlerini, yani çerezleri kullanarak topladığımız bilgileri ve bu bilgilerin nasıl kullanıldığını ve çerez tercihlerinin nasıl kontrol edileceğini anlamak için bu politikayı okumalısınız. Kişisel verilerinizi nasıl kullandığımız ve sakladığımız hakkında daha fazla bilgi için, 3. başlık altında açıklanan Gizlilik Politikamızı inceleyebilirsiniz. İstediğiniz zaman web sitemizdeki Çerez Bildirimi'ndeki onayınızı değiştirebilir veya geri çekebilirsiniz.<br>
<br>
İzniniz aşağıdaki alanlara uygulanır:<br>
</div>

<br><br>

<table border="1" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td valign="top">
<p>1. https://www.okulsepeti.com.tr sitenizin domain adresi</p>
</td>
</tr>
<tr>
<td valign="top">
<p>2. google.com</p>
</td>
</tr>
</tbody>
</table>




<br><br><br>


<div class="b">2.1 Çerez Nedir</div>



<br><br>





<div class="d">Çerezler, küçük bilgileri saklamak için kullanılan küçük metin dosyalarıdır. Web sitesi tarayıcınıza yüklendiğinde, çerezler cihazınızda saklanır. Bu çerezler, web sitesinin düzgün çalışmasını sağlamamıza, web sitesini daha güvenli hale getirmemize, daha iyi bir kullanıcı deneyimi sunmamıza ve web sitesinin nasıl performans gösterdiğini ve neyin işe yaradığını ve iyileştirilmesi gereken yerleri analiz etmemizi sağlar.<br>
İnternet sitemizden en verimli şekilde faydalanabilmeniz ve kullanıcı deneyiminizi geliştirebilmek için Çerez kullanıyoruz. Çerez kullanılmasını tercih etmezseniz tarayıcınızın ayarlarından Çerezleri silebilir ya da engelleyebilirsiniz. Ancak bunun internet sitemizi kullanımınızı etkileyebileceğini hatırlatmak isteriz. Tarayıcınızdan Çerez ayarlarınızı değiştirmediğiniz sürece bu sitede çerez kullanımını kabul ettiğinizi varsayacağız.</div>


<br><br><br>




<div class="b">2.2 Çerezleri Nasıl Kullanıyoruz</div>



<br><br>



<div class="d">Web sitelerimizde kullanılan üçüncü taraf çerezleri, temel olarak web sitesinin nasıl performans gösterdiğini, web sitemizle nasıl etkileşimde bulunduğunuzu, hizmetlerimizi güvende tutmak, sizinle alakalı reklamlar sunmak ve hepsinde size daha iyi ve daha iyi bir hizmet sunmak için kullanılır. kullanıcı deneyimi ve web sitemizle gelecekteki etkileşimlerinizi hızlandırmaya yardımcı olur.<br>
<br>
Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcılar aracılığıyla cihazınıza veya ağ sunucusuna depolanan küçük metin dosyalarıdır. İnternet Sitemizde çerez kullanılmasının başlıca amaçları aşağıda sıralanmaktadır:<br>
– İnternet sitesinin işlevselliğini ve performansını arttırmak yoluyla sizlere sunulan hizmetleri geliştirmek,<br>
– İnternet Sitesini iyileştirmek ve İnternet Sitesi üzerinden yeni özellikler sunmak ve sunulan özellikleri sizlerin tercihlerine göre kişiselleştirmek;<br>
– İnternet Sitesinin, sizin ve Şirketimizin hukuki ve ticari güvenliğinin teminini sağlamak.</div>



<br><br><br>



<div class="b">2.3 Ne tür çerezler kullanıyoruz</div>


<br><br>






<div class="d">Çevrimiçi hizmetlerin çoğu gibi, web sitemiz çerezler için bir dizi amaç için birinci ve üçüncü taraf çerezleri kullanır. Birinci taraf çerezleri çoğunlukla web sitesinin doğru şekilde çalışması için gereklidir ve kişisel olarak tanımlanabilir verilerinizin hiçbirini toplamazlar. Temel: Sitemizin tüm işlevselliğini tecrübe edebilmeniz için bazı çerezler zorunludur. Kullanıcı oturumlarını sürdürmemize ve güvenlik tehditlerini önlememize izin veriyorlar. Kişisel bilgiler toplamaz veya saklamazlar. Örneğin, bu çerezler hesabınıza giriş yapmanızı ve sepetinize ürün eklemenizi ve güvenli bir şekilde ödeme yapmanızı sağlar.<br>
<br>
İstatistikler: Bu çerezler, web sitesine gelen ziyaretçi sayısı, benzersiz ziyaretçi sayısı, web sitesinin hangi sayfalarının ziyaret edildiği, ziyaretin kaynağı vb. Gibi bilgileri depolar. Bu veriler, web sitesinin ne kadar iyi performans gösterdiğini ve analiz etmemize yardımcı olur. iyileştirilmesi gereken yer. Pazarlama: Web sitemiz reklam veriyor. Bu çerezler, size gösterdiğimiz reklamları sizin için anlamlı olacak şekilde kişiselleştirmek için kullanılır. Bu çerezler ayrıca bu reklam kampanyalarının verimliliğini takip etmemize yardımcı olur.<br>
<br>
Bu çerezlerde depolanan bilgiler, üçüncü taraf reklam sağlayıcıları tarafından size tarayıcıdaki diğer web sitelerinde reklam göstermek için de kullanılabilir.<br>
<br>
İşlevsel: Bunlar, web sitemizdeki bazı önemli olmayan işlevlere yardımcı olan çerezlerdir. Bu işlevler arasında videolar gibi içerik yerleştirme veya web sitesindeki içerikleri sosyal medya platformlarında paylaşma yer alır.<br>
<br>
Tercihler: Bu çerezler ayarlarınızı kaydetmemize ve dil tercihleri gibi tarama tercihlerinizi belirlememize yardımcı olur, böylece web sitesine gelecekteki ziyaretlerinizde daha iyi ve verimli bir deneyime sahip olursunuz.<br>
<br>
Kullanılan Çerezler ve ne amaçla kullanıldıkları:<br>
</div>

<br><br><br>





<table border="1" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td valign="top" width="%50">
<p><strong>Çerez</strong></p>
</td>
<td valign="top" width="%50">
<p><strong>Açıklama</strong></p>
</td>
<td valign="top" width="%50">

</td>
</tr>
<tr>
<td valign="top">

</td>
<td valign="top" width="345">

</td>
<td valign="top">

</td>
</tr>
<tr>
<td valign="top">

</td>
<td valign="top" width="345">

</td>
<td valign="top">

</td>
</tr>
<tr>
<td valign="top" width="231">

</td>
<td valign="top" width="345">

</td>
<td valign="top" width="231">

</td>
</tr>
<tr>
<td valign="top" width="231">

</td>
<td valign="top" width="345">

</td>
<td valign="top" width="231">

</td>
</tr>
</tbody>
</table>




<br><br><br>




<div class="b">2.4 Çerez Tercihlerini Nasıl Kontrol Edebilirim</div>



<br><br>





<div class="d">Buna ek olarak, farklı tarayıcılar web siteleri tarafından kullanılan çerezleri engellemek ve silmek için farklı yöntemler sunar. Çerezleri engellemek / silmek için tarayıcınızın ayarlarını değiştirebilirsiniz. Tanımlama bilgilerinin nasıl yönetileceği ve silineceği hakkında daha fazla bilgi edinmek için wikipedia.org, www.allaboutcookies.org adresini ziyaret edin.</div>


<br><br><br>






<div class="b">2.5 İnternet Sitemizde Kullanılan Çerez Türleri</div>




<br><br>




<table border="1" cellpadding="0" width="100%">
<tbody>
<tr>
<td width="9%">
<p style="padding: 5px">Oturum Çerezleri<br>
<em>(Session Cookies)</em></p>
</td>
<td width="91%">
<p style="padding: 5px">Oturum çerezleri ziyaretçilerimizin İnternet Sitesini ziyaretleri süresince kullanılan, tarayıcı kapatıldıktan sonra silinen geçici çerezlerdir.<br>
Bu tür çerezlerin kullanılmasının temel amacı ziyaretiniz süresince İnternet Sitesinin düzgün bir biçimde çalışmasının teminini sağlamaktır.<br>
Örneğin; birden fazla sayfadan oluşan çevrimiçi formları doldurmanızın sağlanmaktadır.</p>
</td>
</tr>
<tr>
<td>
<p style="padding: 5px">Kalıcı Çerezler<br>
<em>(Persistent Cookies)</em></p>
</td>
<td>
<p style="padding: 5px">Kalıcı çerezler İnternet Sitesinin işlevselliğini artırmak, ziyaretçilerimize daha hızlı ve iyi bir hizmet sunmak amacıyla kullanılan çerez türleridir.<br>
Bu tür çerezler tercihlerinizi hatırlamak için kullanılır ve tarayıcılar vasıtasıyla cihazınızda depolanır.<br>
Kalıcı çerezlerin bazı türleri; İnternet Sitesini kullanım amacınız gibi hususlar göz önünde bulundurarak sizlere özel öneriler sunulması için kullanılabilmektedir.<br>
Kalıcı çerezler sayesinde İnternet Sitemizi aynı cihazla tekrardan ziyaret etmeniz durumunda, cihazınızda İnternet Sitemiz tarafından oluşturulmuş bir çerez olup olmadığı kontrol edilir ve var ise, sizin siteyi daha önce ziyaret ettiğiniz anlaşılır ve size iletilecek içerik bu doğrultuda belirlenir ve böylelikle sizlere daha iyi bir hizmet sunulur.</p>
</td>
</tr>
</tbody>
</table>



<br><br><br>





<div class="b">2.6. İnternet Sitemizde Kullanılan Çerezler</div>



<br><br>





<table border="1" cellpadding="0">
<tbody>
<tr>
<td>
<p style="padding: 5px">Teknik Çerezler<br>
(<em>Technical Cookies</em>)</p>
</td>
<td>
<p style="padding: 5px">Teknik çerezler ile internet sitesinin çalışmasının sağlanmakta, internet sitesinin çalışmayan sayfaları ve alanları tespit edilmektedir.</p>
</td>
</tr>
<tr>
<td>
<p style="padding: 5px">Otantikasyon Çerezleri<br>
(<em>Authentication Cookies</em>)</p>
</td>
<td>
<p style="padding: 5px">Ziyaretçiler, şifrelerini kullanarak internet sitesine giriş yapmaları durumunda, bu tür çerezler ile, ziyaretçinin internet sitesinde ziyaret ettiği her bir sayfada site kullanıcısı olduğu belirlenerek, kullanıcının her sayfada şifresini yeniden girmesi önlenir.</p>
</td>
</tr>
<tr>
<td>
<p style="padding: 5px">Flash Çerezleri<br>
(<em>Flash Cookies)</em></p>
</td>
<td>
<p style="padding: 5px">İnternet sitesinde yer alan görüntü veya ses içeriklerini etkinleştirmek için kullanılan çerez türleridir.</p>
</td>
</tr>
<tr>
<td>
<p style="padding: 5px">Kişiselleştirme Çerezleri<br>
(<em>Customization Cookies)</em></p>
</td>
<td>
<p style="padding: 5px">Kullanıcıların tercihlerini farklı internet sitesinin farklı sayfalarını ziyarette de hatırlamak için kullanılan çerezlerdir. Örneğin, seçmiş olduğunuz dil tercihinizin hatırlanması.</p>
</td>
</tr>
<tr>
<td>
<p style="padding: 5px">Analitik Çerezler<br>
(<em>Analytical Cookies)</em></p>
</td>
<td>
<p style="padding: 5px">Analitik çerezler ile internet sitesini ziyaret edenlerin sayıları, internet sitesinde görüntülenen sayfaların tespiti, internet sitesi ziyaret saatleri, internet sitesi sayfaları kaydırma hareketleri gibi analitik sonuçların üretimini sağlayan çerezlerdir.</p>
</td>
</tr>
</tbody>
</table>



<br><br><br>





<div class="b">2.7. Çerezlerin Kullanımı Veri Sahipleri Tarafından Engellenebilir Mi?</div>




<br><br>




<div class="d">Tarayıcınızın ayarlarını değiştirerek çerezlere ilişkin tercihlerinizi kişiselleştirme imkanına sahipsiniz.</div>

<br><br><br>

<table border="1">
    <tbody>
      <tr>
        <td>
            <p style="padding: 5px">Adobe Analytics</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="http://www.adobe.com/uk/privacy/opt-out.html" target="_blank"  rel="noreferrer">
                    <strong>http://www.adobe.com/...</strong>
                </a>
            </p>
        </td>
      </tr>
      <tr>
        <td>
            <p style="padding: 5px">AOL</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser" target="_blank" rel="noreferrer">
                    <strong>https://help.aol.com/...</strong>
                </a>
            </p>
        </td>
      </tr>
      <tr>
        <td>
            <p style="padding:5px">Google Adwords</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="https://support.google.com/ads/answer/2662922?hl=en" target="_blank"  rel="noreferrer">
                    <strong>https://support.google.c...</strong>
                </a>
            </p>
        </td>
      </tr>
      <tr>
        <td>
            <p style="padding: 5px">Google Analytics</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="https://tools.google.com/dlpage/gaoptout" target="_blank"  rel="noreferrer">
                    <strong>https://tools.google.c...</strong>
                </a>
            </p>
        </td>
      </tr>
      <tr>
        <td>
            <p style="padding: 5px">Google Chrome</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="http://www.google.com/support/chrome/bin/answer.py?hl=en&amp;answer=95647">
                    <strong>http://www.google.com/su...</strong>
                </a>
            </p>
        </td>
      </tr>
      <tr>
        <td>
            <p style="padding: 5px">Internet Explorer</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank"  rel="noreferrer">
                    <strong>https://support.microsof...</strong>
                </a>
            </p>
        </td>
      </tr>
      <tr>
        <td>
            <p style="padding: 5px">Mozilla Firefox</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="http://support.mozilla.com/en-US/kb/Cookies" target="_blank" rel="noreferrer">
                    <strong>http://support.mozill...</strong>
                </a>
            </p>
        </td>
      </tr>
      <tr>
        <td>
            <p style="padding: 5px">Opera</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="http://www.opera.com/browser/tutorials/security/privacy/" target="_blank" rel="noreferrer">
                    <strong>http://www.opera.com/...</strong>
                </a>
            </p>
        </td>
      </tr>
      <tr>
        <td>
            <p style="padding: 5px">Safari</p>
        </td>
        <td>
            <p style="padding: 5px">
                <a href="https://support.apple.com/kb/ph19214?locale=tr_TR" target="_blank" rel="noreferrer">
                    <strong>https://support.apple.com/...</strong>
                </a>
            </p>
        </td>
      </tr>
  </tbody>
</table>



<br><br><br>





<div class="a">3- İNTERNET SİTESİ GİZLİLİK POLİTİKASI</div>

<br><br>


<div class="d">Şirket, internet sitesini ziyaret eden sizlerin paylaşmış olduğu bilgilerin gizliliğini sağlamayı ilke olarak kabul etmiştir. Bu nedenle işbu “Gizlilik Politikası” sizlerin hangi bilgilerinin, hangi yollarla ve hukuka uygun hangi amaç çerçevesinde Şirket tarafından işlendiğini, bu bilgilerin hukuka uygun olarak ve vermiş olduğunuz izin kapsamında hangi üçüncü kişiler ile paylaşıldığını ve Şirket tarafından ne şekilde korunduğunu açıklayarak sizi bilgilendirmek amacı ile oluşturulmuştur. Şirket tarafından sizlere her türlü kanaldan sunulan tüm hizmetler kısaca “Hizmet” olarak anılacaktır.</div>


<br><br><br>






<div class="b">3.1 Gizlilik Politikasının Kapsamı</div>



<br><br>



<div class="d">Sunulan hizmetin bir parçası olarak Şirket, hizmet alan sizlere ilişkin bilgileri işbu Gizlilik Politikası kapsamında elde edebilir ve aktarabilir. Bu tür bilgi aktarımları, üçüncü kişiler tarafından belirlenen şartlara ve üçüncü kişiler ile mevcut sözleşmelere ve yürürlükteki mevcut yasal mevzuata uygun olarak yapılır. Bu Gizlilik Politikası, bilgi aktarımı yapılan üçüncü kişilerin gizlilik uygulamalarını yansıtmamaktadır ve onların gizlilik politikalarından veya uygulamalarından Şirket sorumlu değildir. İşbu Gizlilik Politikası Şirket’in kendi kontrolü dışındaki uygulamalar, üçüncü taraflara ait internet siteleri ve platformlar tarafından toplanılan bilgiler, üçüncü taraflarca Şirket internet sitesindeki bağlantılar üzerinden toplanan bilgiler veya Şirket’in sponsor olduğu ve/veya katıldığı üçüncü taraf internet siteleri üzerindeki başlıklar, kampanyalar ve diğer reklam veya tanıtımları kapsamamaktadır. Üçüncü tarafların kendi internet siteleri yoluyla topladığı, sakladığı ve kullandığı kişisel verilere yönelik yapılan işlemlerden Şirket sorumlu değildir.</div>




<br><br><br>




<div class="b">3.2 Toplanan Veriler</div>



<br><br>





<div class="d">Şirket tarafından, verilen Hizmetler kapsamında birtakım kişisel verileriniz işlenmektedir. Bu kişisel veriler şunları içerebilir: ad-soyad, T.C. Kimlik Numarası, uyruk bilgisi, anne adı, baba adı, doğum yeri, doğum tarihi, cinsiyet, vergi numarası, SGK numarası, imza bilgisi, fotoğraf, taşıt plakası, telefon numarası, adres, e-posta adresi, faks numarası, IP adresi, sosyal medya hesapları, konum bilgileri, ürün veya hizmet satın almanızla ilgili bilgiler, ödeme bilgileri, sitemizde görüntülediğiniz sayfalar, sitemizi mobil cihazınız ile ziyaret etmeniz halinde mobil cihazınızı tanıtan veriler ve tarafımıza vermeyi açıkça ve yazılı olarak tercih ettiğiniz ve onayladığınız veya üçüncü kişilerden bu açık onayınız ile elde edebileceğimiz diğer her tür bilgiye tarafımızdan erişilebilir ve bu bilgiler işlenebilir. Sitemizden alışveriş yaparak veya ürünler hakkında beni ara bilgi formunu doldurarak veya şirket e-posta adreslerimizden bilgi talebinde bulunduğunuzda size e-bülten, e-posta, telefon ve SMS aracılığıyla ulaşmamızı kabul etmiş sayılmaktasınız. Tüm kredi kartı ve kişisel bilgileriniz internet güvenlik standardı olan SSL Secure sistemi ile 128 Bit şifrelenmiştir. Bu şekilde internet üzerindeki dolaşımları sırasında herhangi bir şekilde bu bilgilerinizin istenilmeyen kişi veya kurumlarda ele geçirilmesi önlenmiştir. Gizlilik politikamız ile ilgili her türlü soru ve öneriniz için sitemizdeki iletişim bölümünden bize e-mail gönderebilirsiniz.</div>

<br><br><br>







<div class="b">3.3 Bilgi Güncelleme ve Değişiklik</div>



<br><br>





<div class="d">İnternet Sitesi Gizlilik Politikasının tümünün veya belirli maddelerinin yenilenmesi durumunda Politika’nın yürürlük tarihi güncellenecektir. Şirket, gizlilik ve veri koruma prensiplerini güncel tutmak ve ilgili mevzuata uygun hale getirmek için işbu Gizlilik Politikası’nın içeriğini dilediği zaman değiştirebilir. Değişen Gizlilik Politikası Şirket internet sitesinde ilan edilecektir. Gizlilik Politikası’nın güncel haline www.panelkirtasiye.com adresinden sürekli olarak ulaşmanız mümkündür. İşbu Gizlilik Politikası’nın değiştirilmesinden sonra Şirket’in hizmet ve/veya uygulamalarını kullanmaya devam etmeniz halinde yapılan değişiklikleri kabul ettiğiniz varsayılır. Şirket’in değişiklik yaptığı Gizlilik Politikası hükümleri internet sitesinde yayınlandığı tarihte yürürlük kazanır.<br>
<br>
<b><a href="https://www.okulsepeti.com/" target="_blank" rel="noreferrer">www.okulsepeti.com.tr</a></b> adresinden iletişim bilgilerinizin ve tercihlerinizin doğru, tam ve güncel olmasına yardımcı olabilirsiniz. Elimizdeki diğer kişisel veriler açısından; yanlış olan bir bilgiyi düzeltmemizi ya da yasa gereği veya meşru ticari amaçlar ile saklamasının gerekmediği bilginin silinmesini talep edebilirsiniz.<br>
<br>
<strong>İletişim bilgileri</strong><br>
Okulsepeti Pazarlama Anonim Şirketi<br>
İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul<br>
Tel: 08503332202</div>
      </div>`,
              }}
            />
          ),
        },
      },
      {
        title: 'KVKK Başvuru Formu',
        modalConfig: {
          title: 'KVKK Başvuru Formu',
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: okul?.okul_kvkk_basvuru_formu || `<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p align="center"><strong>OKUL SEPETİ PAZARLAMA A.Ş.</strong><br>
<strong>KİŞİSEL VERİ BAŞVURU FORMU</strong><br>
<strong>GENEL AÇIKLAMALAR</strong></p>

<p>6698 Sayılı Kişisel Verilerin Korunması Kanunu’nda (“KVK Kanunu”) <strong>ilgili kişi</strong> olarak tanımlanan kişisel veri sahiplerine (“Bundan sonra “<strong>Başvuru Sahibi</strong>” olarak anılacaktır), KVK Kanunu’nun 11’inci maddesinde kişisel verilerinin işlenmesine ilişkin birtakım taleplerde bulunma hakkı tanınmıştır.</p>

<p>KVK Kanunu’nun 13’üncü maddesinin birinci fıkrası uyarınca; Başvuru Sahibi, veri sorumlusu olan Şirketimize bu haklara ilişkin olarak yapılacak başvuruların yazılı olarak veya Kişisel Verilerin Korunması Kurulu (“Kurul”) tarafından belirlenen diğer yöntemlerle tarafımıza iletilmesi gerekmektedir.<a name="_GoBack"></a></p>

<p>Bu çerçevede, “<strong>yazılı</strong>” olarak Şirketimize yapılacak başvurular, işbu formun çıktısı alınarak ilgili veri sahibinin kimliğini tespit edecek belgelerle birlikte, aşağıdaki yöntemlerden biri ile gerçekleştirilecektir;</p>

<ul>
<li>Başvuru Sahibi’nin şahsen başvurusu ile,</li>
<li>Elden teslim</li>
<li>Formun doldurularak ıslak imzalı kopyasının elden veya posta yoluyla İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul adresine iletilmesi,</li>
<li>Formun 5070 sayılı Elektronik İmza Kanunu kapsamında düzenlenen güvenli elektronik imza ile imzalanarak okulsepetipazarlama@hs03.kep.tr adresine kayıtlı elektronik posta ile gönderilmesi,</li>
</ul>

<p></p>


<table border="0" cellpadding="0" cellspacing="10">
<tbody>
<tr>
<td align="left" valign="top">
<p style="padding: 5px"><strong>Başvuru Yöntemi</strong></p>
</td>
<td align="left" valign="top">
<p style="padding: 5px"><strong>Başvurunun Yapılacağı Adres</strong></p>
</td>
<td align="left" valign="top">
<p style="padding: 5px"><strong>Başvuru Gönderiminde Belirtilecek Bilgi</strong></p>
</td>
</tr>
<tr>
<td align="left" bgcolor="#F0F0F0" valign="top">
<p style="padding: 5px">Şahsen Başvuru (Başvuru sahibinin bizzat gelerek kimliğini tevsik edici belge ile başvurması)</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="top">
<p style="padding: 5px">İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="top">
<p style="padding: 5px">Zarfın üzerine “Kişisel Verilerin Korunması<br>
Kanunu Kapsamında Bilgi Talebi” yazılacaktır.</p>
</td>
</tr>
<tr>
<td align="left" valign="top">
<p style="padding: 5px">Posta</p>
</td>
<td align="left" valign="top">
<p style="padding: 5px">İdealtepe Mah. Dik Sok. No:8 Kat:5 D:9 Maltepe/İstanbul</p>
</td>
<td align="left" valign="top">
<p style="padding: 5px">Zarfın üzerine “Kişisel Verilerin Korunması<br>
Kanunu Kapsamında Bilgi Talebi” yazılacaktır.</p>
</td>
</tr>
<tr>
<td align="left" bgcolor="#F0F0F0" valign="top">
<p style="padding: 5px">Elektronik Posta</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="top">
<p class="table-word-wrap" style="padding: 5px;">okulsepetipazarlama@hs03.kep.tr</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="top">
<p style="padding: 5px">Konu bölümüne “Kişisel Verilerin Korunması<br>
Kanunu Kapsamında Bilgi Talebi” yazılacaktır.</p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p>Ayrıca, Kurul’un belirleyeceği diğer yöntemler duyurulduktan sonra bu yöntemler üzerinden de<br>
başvuruların ne şekilde alınacağı Şirketimizce duyurulacaktır.</p>

<p></p>

<div>
<p>Tarafımıza iletilmiş olan başvurularınız KVK Kanunu’nun 13’üncü maddesinin 2’inci fıkrası gereğince, talebin niteliğine göre talebinizin bizlere ulaştığı tarihten itibaren azami 30 (otuz) gün içinde yanıtlandırılacaktır. Yanıtlarımız ilgili KVK Kanunu’nun 13’üncü maddesi hükmü gereğince yazılı veya elektronik ortamdan tarafınıza ulaştırılacaktır.</p>

<p>(Başvurunuz ücretsiz olarak sonuçlandırılacak ancak, işlemin ayrıca bir maliyeti gerektirmesi halinde, Kurulca belirlenen tarifedeki ücret alınabilecektir.)</p>

<p></p>

<p><strong>A. Başvuru Sahibi iletişim bilgileri:</strong></p>

<table border="0" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td align="left" valign="top" width="151">
<p>İsim:</p>
</td>
<td align="left" valign="top" width="425">
<p></p>
</td>
</tr>
<tr>
<td align="left" valign="top" width="151">
<p>Soy isim:</p>
</td>
<td align="left" valign="top" width="425">
<p></p>
</td>
</tr>
<tr>
<td align="left" valign="top" width="151">
<p>TC Kimlik Numarası:</p>
</td>
<td align="left" valign="top" width="425">
<p></p>
</td>
</tr>
<tr>
<td align="left" valign="top" width="151">
<p>Telefon Numarası</p>
</td>
<td align="left" valign="top" width="425">
<p></p>
</td>
</tr>
<tr>
<td align="left" valign="top" width="151">
<p>E-posta</p>
</td>
<td align="left" valign="top" width="425">
<p></p>
</td>
</tr>
<tr>
<td align="left" rowspan="2" valign="top" width="151">
<p>Adres:</p>
</td>
<td align="left" valign="top" width="425">
<p></p>
</td>
</tr>
<tr>
<td align="left" valign="top" width="425">
<p></p>
</td>
</tr>
</tbody>
</table>

<p></p>

<p><strong>B. Başvuru Sahibi’nin şirketimiz ile ilişkisi:</strong> </p>

<table border="1" cellpadding="0" cellspacing="8">
<tbody>
<tr>
<td align="left" valign="top">
<form action="" method="post" name="form1"><input id="Müşteri" name="radio" type="radio" value="Müşteri"> <label for="Müşteri">Müşteri</label></form>
</td>
<td align="left" valign="top">
<form action="" method="post" name="form2"><input id="İş ortağı " name="radio" type="radio" value="İş ortağı "> <label for="İş ortağı ">İş ortağı </label></form>
</td>
<td align="left" valign="top">
<form action="" method="post" name="form3"><input id="Ziyaretçi" name="radio" type="radio" value="Ziyaretçi"> <label for="Ziyaretçi">Ziyaretçi</label></form>
</td>
<td align="left" rowspan="2" valign="top">Diğer……</td>
</tr>
<tr>
<td align="left" valign="top"><input id="Eski Çalışanım " name="radio" type="radio" value="Eski Çalışanım "> <label for="Eski Çalışanım ">Eski Çalışanım </label></td>
<td align="left" valign="top"><input id="İş Başvurusu/ Özgeçmiş paylaşımı yaptım" name="radio" type="radio" value="İş Başvurusu/ Özgeçmiş paylaşımı yaptım"> <label for="İş Başvurusu/ Özgeçmiş paylaşımı yaptım">İş Başvurusu/ Özgeçmiş<br>
paylaşımı yaptım</label></td>
<td align="left" valign="top"><input id="Üçüncü kişi firma çalışanıyım" name="radio" type="radio" value="Üçüncü kişi firma çalışanıyım"> <label for="Üçüncü kişi firma çalışanıyım">Üçüncü kişi<br>
firma çalışanıyım</label></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top">- Şirketimiz içerisinde iletişimde olduğunuz birim:</td>
<td align="left" colspan="2" valign="top"></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top">- Çalıştığım yıllar (Eski çalışanlar için):</td>
<td align="left" colspan="2" valign="top"></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top">- Çalıştığım firma ve pozisyon (Üçüncü kişi firma çalışanları için):</td>
<td align="left" colspan="2" valign="top"></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top">- Konu:</td>
<td align="left" colspan="2" valign="top"></td>
</tr>
</tbody>
</table>
</div>

<p></p>

<p></p>

<p></p>

<div>
<p><strong>C. Lütfen KVK Kanunu kapsamındaki talebinizi detaylı olarak belirtiniz:</strong></p>

<table border="1" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td align="center" valign="middle" width="59">
<p><strong></strong></p>

<p style="padding: 5px"><strong>Talep No</strong></p>
</td>
<td align="left" valign="top" width="325">
<p><strong></strong></p>

<p style="padding: 5px"><strong>Talep Konusu</strong></p>
</td>
<td align="left" valign="top" width="147">
<p><strong></strong></p>

<p style="padding: 5px"><strong>Kanuni Dayanak</strong></p>
</td>
<td align="left" valign="top" width="95">
<p align="center"><strong></strong></p>

<p align="center" style="padding: 5px"><strong>Seçiminiz</strong></p>
</td>
</tr>
<tr>
<td align="center" bgcolor="#F0F0F0" valign="middle" width="59">
<p><strong></strong>1</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="325">
<p style="padding: 5px">Şirketinizin hakkımda kişisel veri işleyip işlemediğini öğrenmek istiyorum</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (a)</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" valign="middle" width="59">
<p>2</p>
</td>
<td align="left" valign="middle" width="325">
<p style="padding: 5px">Eğer Şirketiniz hakkımda Kişisel Veri işliyorsa bu veri işleme faaliyetleri hakkında bilgi talep ediyorum</p>
</td>
<td align="left" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (b)</p>
</td>
<td align="left" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" bgcolor="#F0F0F0" valign="middle" width="59">
<p>3</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="325">
<p style="padding: 5px">Eğer Şirketiniz hakkımda Kişisel Veri işliyorsa bunların işlenme amacını ve bu amaca uygun kullanılıp kullanılmadığını öğrenmek istiyorum</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (c)</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" valign="middle" width="59">
<p>4</p>
</td>
<td align="left" valign="middle" width="325">
<p style="padding: 5px">Eğer Kişisel Verilerim Yurtiçinde veya Yurtdışında üçüncü kişilere aktarılıyorsa ,bu üçüncü kişileri bilmek istiyorum.</p>
</td>
<td align="left" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (ç)</p>
</td>
<td align="left" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" bgcolor="#F0F0F0" valign="middle" width="59">
<p>5</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="325">
<p style="padding: 5px">Kişisel Verilerimin eksik yada yanlış işlendiğini düşünüyorum ve bunların düzeltilmesini istiyorum</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (d)</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" valign="middle" width="59">
<p>6</p>
</td>
<td align="left" valign="middle" width="325">
<p style="padding: 5px">Kişisel Verilerimin kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına<br>
rağmen, işlenmesini gerektiren sebeplerin ortadan kalktığını düşünüyorum ve bu çerçevede kişisel verilerimin silinmesini veya yok edilmesini talep ediyorum</p>
</td>
<td align="left" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (e)</p>
</td>
<td align="left" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" bgcolor="#F0F0F0" valign="middle" width="59">
<p><strong></strong>7</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="325">
<p style="padding: 5px">Eksik veya yanlış işlendiğini düşündüğüm Kişisel Verilerimin aktarıldığı üçüncü kişiler nezdinde de düzeltilmesini istiyorum.</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (f)</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" valign="middle" width="59">
<p>8</p>
</td>
<td align="left" valign="middle" width="325">
<p style="padding: 5px">Kişisel Verilerimin kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına<br>
rağmen, işlenmesini gerektiren sebeplerin ortadan kalktığını düşünüyorum ve bu çerçevede kişisel verilerimin üçüncü kişiler nezdinde de silinmesinin veya yok edilmesinin bildirilmesini talep ediyorum</p>
</td>
<td align="left" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (f)</p>
</td>
<td align="left" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" bgcolor="#F0F0F0" valign="middle" width="59">
<p><strong></strong>9</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="325">
<p style="padding: 5px">Şirketiniz tarafından işlenen Kişisel Verilerimin münhasıran Otomatik Sistemler vasıtasıyla analiz edildiğini ve bu analiz neticesinde Şahsım aleyhine<br>
bir sonuç doğduğunu düşünüyorum. Bu sonuca itiraz ediyorum.</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (g)</p>
</td>
<td align="left" bgcolor="#F0F0F0" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" valign="middle" width="59">
<p align="center"><strong></strong>10</p>
</td>
<td align="left" valign="middle" width="325">
<p style="padding: 5px">Kişisel Verilerimin Kanuna aykırı işlenmesi nedeniyle zarara uğradım. Bu zararın tazminini talep ediyorum.</p>
</td>
<td align="left" valign="middle" width="147">
<p style="padding: 5px">Kişisel Verilerin<br>
Korunması Kanunu Madde 11/1 (h)</p>
</td>
<td align="left" valign="middle" width="95">
<p></p>
</td>
</tr>
<tr>
<td align="center" bgcolor="#F0F0F0" valign="middle" width="59">
<p align="center">11</p>
</td>
<td align="left" bgcolor="#F0F0F0" colspan="3" valign="middle" width="566">
<p style="padding: 5px">Diğer Belirtiniz:</p>
</td>
</tr>
</tbody>
</table>
</div>

<p></p>

<p><strong>D. Lütfen başvurunuza vereceğimiz yanıtın tarafınıza bildirilme yöntemini seçiniz:</strong></p>

<table border="1" cellpadding="0" cellspacing="0">
<tbody>
<tr>
<td bgcolor="#F0F0F0" valign="top" width="416">
<p style="padding: 5px">Adresime gönderilmesini istiyorum.</p>
</td>
<td bgcolor="#F0F0F0" valign="top" width="211">
<ul>
<li><strong>........</strong></li>
</ul>
</td>
</tr>
<tr>
<td valign="top" width="416">
<p style="padding: 5px">E-posta adresime gönderilmesini istiyorum.</p>
</td>
<td valign="top" width="211">
<ul>
<li><strong>........</strong></li>
</ul>
</td>
</tr>
<tr>
<td bgcolor="#F0F0F0" valign="top" width="416">
<p style="padding: 5px">Elden teslim almak istiyorum.</p>
</td>
<td bgcolor="#F0F0F0" valign="top" width="211">
<ul>
<li><strong>........</strong></li>
</ul>
</td>
</tr>
</tbody>
</table>

<p><strong><em></em></strong></p>

<p><u>Not: (E-posta yöntemini seçmeniz hâlinde size daha hızlı yanıt verebileceğiz.)</u></p>

<p><em>(Vekâleten teslim alınması durumunda noter tasdikli vekâletname veya yetki belgesi olması gerekmektedir.)</em></p>

<p>İşbu başvuru formu, Şirketimiz ile olan ilişkinizi tespit ederek, varsa, Şirketimiz tarafından işlenen kişisel verilerinizi eksiksiz olarak belirleyerek, ilgili başvurunuza doğru ve kanuni süresinde cevap verilebilmesi için tanzim edilmiştir. Hukuka aykırı ve haksız bir şekilde veri paylaşımından kaynaklanabilecek hukuki risklerin bertaraf edilmesi ve özellikle kişisel verilerinizin güvenliğinin sağlanması amacıyla, kimlik ve yetki tespiti için Şirketimiz ek evrak ve malumat (Nüfus cüzdanı veya sürücü belgesi sureti vb.) talep etme hakkını saklı tutar. Form kapsamında iletmekte olduğunuz taleplerinize ilişkin bilgilerin doğru ve güncel olmaması ya da yetkisiz bir başvuru yapılması halinde Şirketimiz, söz konusu yanlış bilgi ya da yetkisiz başvuru kaynaklı taleplerden dolayı mesuliyet kabul etmemektedir.</p>

<p>Yukarıda belirttiğim talepler doğrultusunda, Şirketinize yapmış olduğum başvurumun Kanun’un 13. maddesi uyarınca değerlendirilerek tarafıma bilgi verilmesini rica ederim.</p>

<p>İşbu başvuruda tarafınıza sağlamış olduğum belge ve bilgilerimin doğru ve güncel olduğu, şahsıma ait olduğunu beyan ve taahhüt ederim.</p>

<p>İşbu başvuru formunda sağlamış olduğum bilgi ve belgelerin 6698 Sayılı Kişisel Verilerin Korunması Kanunun 13üncü maddesi uyarınca yapmış olduğum başvurunun değerlendirilmesi, cevaplandırılması, başvurumun tarafıma ulaştırılması, kimliğimin ve adresimin tespiti amaçlarıyla sınırlı olarak Şirketiniz tarafından işlenmesine izin veriyorum.</p>

<p>Başvuru Sahibi (Kişisel Veri Sahibi)</p>

<p><strong>Adı Soyadı :</strong></p>

<p><br>
<strong>İmza :</strong></p>

<p><strong>Başvuru Tarihi :</strong> <strong></strong>  </p>

<p></p>
      </div>`,
              }}
            />
          ),
        },
      },
    ],
    [
      {
        title: (
          <div className="call-center-div">
            <CallCenterIcon />
            <div className="call-center-text">
              {' '}
              <span>Çağrı Merkezi</span>
              <span className="number">0850 333 22 02 </span>{' '}
            </div>
          </div>
        ),
      },
      {
        title: <br />,
      },

      {
        title: (
          <div className="footer-email">
            <MailFilled />
            <a href="mailto:bilgi@okulsepeti.com.tr">bilgi@okulsepeti.com.tr</a>
          </div>
        ),
      },
      {
        title: <br />,
      },
      {
        title: (
          <div id="ETBIS">
            <div id="1415473622245400">
              <a href="https://etbis.eticaret.gov.tr/sitedogrulama/1415473622245400" target="_blank" rel="noreferrer">
                <img
                  className="elbis"
                  alt="qr"
                  src="data:image/jpeg;base64, iVBORw0KGgoAAAANSUhEUgAAAIIAAACWCAYAAAASRFBwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAEVnSURBVHhe7Z0HnF5F9f4lQUJIowhIB0E6KCQQkCaCggiCFJHegqAgQoj0DlIUBaWDgHSkI9WI9LTN1uymkATSe+8V5n++d+/z5ux95y2bbIL8fz6fz0PYafe+956ZOefMmblfM4SW4N/+9rcAZs6cGdZbb728/J49eyb5HjfccENeuf333z/NDeHss8/Oy/d8++23k3KffvppaN26dZJ2+eWXJ2keH330UV7d5vDSSy9NWwrhO9/5TpL2ve99L00J4bzzzsurc9xxx6W5yzBy5Mjw9a9/Pcn/3e9+l6YWx7x588LGG2+c1Dn22GPT1BB++tOfNrneCvBFY4JYZrP5ZQjCBx98kJSbMmVKLu2yyy5L0jxWVBCuu+66tKUQtt566yQNgRDOPffcvDpHHnlkmrsMs2bNygnCNddck6aWxqabbprUWSWCwA885ZRTmsUf/vCHuQbLFQQexuOPP56QB6y21l577aRcKUHYaqutcnXuuOOOpJ0HHnggnHrqqUkaD1jtz5gxI2lnRQXh8MMPz7X561//OrnOb37zm1zaFVdckbsnsUePHrl88c9//nNu5DrssMPy8mPkua6zzjpJnZggtGvXLpx00kl51y/GE088May11lr6fU0F4Ze//GV6ifJRWVmpxsoWhMGDB+fSrr766iQN7LrrrkmaF4Ru3brlyopnnHFGmhvCAQcckKR94xvfSFNCuOWWW3Jla2pqkrQVFQTP4cOHJ23SttLuv//+JM3j1VdfbVKvJRgThC233DJNaR4222wztdtUEE477bS0SPl499131VjZgjB06NCw2mqrJWk33XRTkgZ22WWXJM0LAtLr24DHH398mhvCT37ykyTtW9/6Vli6dGmSdvPNN+fKojuAioqKXNqKsrq6OmmzV69euTT9do/XXnutSb2WYEwQNt9887Bo0aI0tTwsWLAgbLLJJmq3sCCgHB1yyCEFOXr06KTcigoC05HabN++fZLmBaGhoSFRCD3vvPPOXB1GAuoUEgQUOsoximTbefnll3PTUYzf/OY3wxtvvJFXb/bs2cl1vCDssMMOuXsSpVTC66+/Pq+dUkTHUH2xlCC8+OKLeffhyW8GZQtC165dVShKXhCICQLzspt/cqQsQIgkCDHuvffeSblC4Mdk6/CjBC8IItNODBtuuGFeWdG3GUNVVVW0XowITXOBjpFt54gjjkhz44Lgp8UYb7vttqRc2YJw0EEH5SrHyDwPYoJAj9ltt90Spc7z+eefD5999llSR4JAj8yWoydQrhBREHVNei116PnM3eQz3WTb5AGqvno0/26wwQZJOyhc2TqMTBplGOVUX3zhhRdy98EImK2vtiHPJls/xnHjxiXXAyij1OVZMZ/TJoqqEBMElFFdM0ZGU7BKBAEsWbIkjwxNq6++ekLVufLKK/PKvffee7lyMUrrhgzd1GG6adOmTZKPHyHbJmam6j/44IPJPXpB+PnPf55XBwp/+MMfcvVFfx9//etf8+o+88wzuXzKZuvH6H0TEgRG11GjRiVtSjDBV0IQYmDI921Ahr8s6uvr88oV4scff5zU4aUqLeZQGjhwYC7/iSeeSFNDMqKQdvrpp6cpcdx66625+jH6NoXXX389WrYYu3TpktYOiV6j9AkTJqSpy/CVEgR0CXoTxNbGm+aJUiQ88sgjSblf/epXuTZ/9KMf5dXxZBqgDk6kVq1aJXW8IDz66KNJPkOq2jzmmGOStBtvvDGnoKLYkVaI+Dt0zfXXXz/XlnjUUUfl1aF9f69ZyvT1RDcTXnnllaQczw3fSxarRBAOPPDAXOUYyxWEhx56KJePLV8M6p2eDK/FsN9+++XV8Z5FeeRWlJdccknaYgidO3eOlsnSK3Yx3HvvvXl19txzzzS3NGKC8Kc//SmvTU/0K1C2IKAoKT3GQYMGJeVKCcKTTz6Zy/e9P4btttsuV1bUfF4IBx98cF4d/9Lkm1hRxtYaSvFnP/tZWiOO2EtDyMpFTBD++Mc/5rXpyTVB2YLwySefhP79+xckDYGYIMyZMyeZWpjvWIxRHQ1vKD7kZfnPf/4zKcfLV5sShLlz5yYvPVvnsccey7Uvjh07NqkDYoLA1JGt47nPPvvk1YkJAiZprL4oZxa48MIL8+7dj1ZPPfVUUgfLSvnPPvtsWjuOmCBMnDgx7z48J02alJQrKgjdunVLCjUHffv2VWM5QcCPgAZP2gknnJCkeSAIquOpB8cNK02CgPm25pprNikPpSwWwjbbbJNX5+9//3uaG4cesKcfZTRyNWcYL6VzYfWA2traXNrtt9+epBWC7nN5XcxOEJsKAgsrWQkqRXzsqi9B8J5FXMSCRhlMPkm9llehnFSYekqTIDCayIu47rrr5uprRBgwYED44osvkrJo2Lo/Hhbl/LSjdQFMMR485XzvZTGIcggzQzX1UdjUJoohaZicSlNP+/zzz6Nt8mxpc4011si16UcErYn4joVJCmizrq4uaVPrHECCgG7Vp0+f3L2UQxxczs/RVBBWlKUE4fvf/36S5iX497//fa5+uYLg25SOwEOVjY22rvrSZfwDliBgcsrFjCUhSBBwWwvefNR99uvXL5f2l7/8JUljCkNQSfM6ggTB/3avIxQTBOIR9NsRQiE2ci0nW1YQ7r777uQGvSCwjCz8+Mc/TtIYrgX/0uRVQ/qV5q0GSfDJJ5+cpoTEvCSNNQsBE0n11ab3I0gQEC55OA899NAkDUgQ8OTRG4EXBK2zIGRKu+uuu5I0BEH36dcFZN106NAhJ7BesSNgBSBkSpM7mDYVw8CyvxAzP5eTjYKQtX+XlwzPwAvCTjvtlLOb6Q2kffvb384N4z4wBQcK5X7xi1/k0uRHuOCCC0Lbtm2TNNbeBbyVpNGzL7744qSsNylxFJGGrqI0CQIK1j333JPcO4qq4AUBbx7wgoBSTZus6StNnYCXJjPYRyixGMR1iJuQcPF3tk0UWT1P1jLA4sWLE1OTNJa2hZdeeilXdgXZKAhpuy0GLwgxMuRKEHDUxMoUY0wQmkNNN4Xgl7YFHli2HU9eFFi4cGFOENAhiiHW5s4775zmrjrYuygsCAxf3m+epV4k/ypNkl5IEORvZ8lW9fEMys8eW5H0PnqlxQSBuionDyNUml8XYBTwvyVLTWGMYJhZpPkVTd2Tb1NrDfx2CQJTg283SwRB96ffjiUSK1su9Q48/DuK0UacwoLAw9YqWozSXnv37p1L+8c//pGkFRIEwq5YYRszZkxSDmBqauWNKSNbhxdAHtOOwrVigoAtrdVHhljVf+utt5K05557LpeG4uV/S5ZaQucFIQykSQGEWD20GVt93GKLLXICElvR9MQDSjtwxx13TOpgqcTKlkt0rizQuWJlRfuNhQVh3333zf3IGPEFAOx4pXnPorRcTwWaFgJDcbaObH7mSfn4vSDI+UOe4JUwHCwAl7jSVpTjx49P2vTK4vIQZ5sQ83csD/0yteADaAqwsCDEHCDcLNo1xBNGb2O+VRoOENLoKR07dsyrrwglFCrKZckLph0fFBMzH70gsIxNHRRNDYt+GGfupm3uTWnlEuWUEYf2vR+CqYU2WSTTb2dE8nWzxHegsqLvOAhFNr8UZZ34+0TZ1PNkZAb4b7J1M2yeIPCABf1wv36Ohp6t4ylBGDJkSDRfDhgfEFtKEGKIRSgtDwuZpOLuu++e5oZw0UUX5eV7/uc//0lLthyOPvropG3vm/D3iU+iHBRVFpEUNSh6N6sUIr9s6pd6Y/Qxi7F8bH3w4Ycf5tIYeYTY1BBDqXCtcsm8L6AMZvN9J4htcPH897//nZZsOUg/wnQWvCDImVYKeYLAMjFeO6gXvdFGG+Xi63GdCtizpHFh1Sk1z8WCVz1jnsW99toraRvfgtYvYoKAixdbnLJ+X4NCtrfddttcWrn0eyXo/bonsZQgYAGore7du+eek+idZVdddVVefinimaRtRk39dtrRNbmnbJ0YTz755KaC8PDDD+f9GLTZYsBvna1TiFqGbo4gxOjD2QU/yvh4hO9+97tJ2g9+8IM0pXwwHanNGP2iU2w09PcZ8wJ6ZVHOtuZQ0w0uaKXheBNkiZTBRkGYNm1agChBaUaOKEkxoIhQB1MK0wqqx3qSpnxiEUFzBAETTPXFc845JynngX4hs81HKGkZmpFFvxOnTxZ4GZUvYnYxHWWvL7LOobK8gGy+34iDZ5M0Hz6PmStIYDFZVV+rrTwr6pGmiCrItMm1Ce0jGpt8vKu6p2JtZtgoCNjnMBaCXkgQ6A3Uwfkyffr0hAwz2fr0CuVjAoLmCAJTj+qLWB1ZlBIEHoZ+J+FrWeCuVb5IXfZUZq8vvvPOO7myLDpl8/19EqNBGsIV2wSrl4Z1ofrsPCMNq4D5njTMadIgQsG1ceMzNZKPdaR70vNgWlObsT2axkZBMMQyEyJpMWgjKNaF4IMtRb+qJ0yePDkqCAoo8WvymGjlgB+pH876haAH7MnIlwXCkS3HaFQM3oeiyJ9SQDhUh94rSL9C+ASmONK4Dy1Uvfnmm7n6IgEmAgKZzUdQBJbTs/nGRkGQ0oDyk2Ykq1ykeUvBY/vtt0/K4S6WcsKNqy1RCzwAzZlyuFZjgoC2Tz6+AaXJfGQ0wXNJvo99pFeSRk9olbqWiRUkDbr9fTn6exIwtbL3joKnFxADI5vKyirAZUuUEdf2DjQiuUjj90gBZd+n7hMdg7Tzzz8/l6YNxsQw8IJJw1mmayqeAeuGDkM+nkXli+gialOrtXQaOin5ecqid5myV7AYvINFLBX5U2r3VIwEvwIUN71ov908FiJfijFBaCnQ46UrMW0KUha9qeedXMOGDUvScKUrLUYfEMtaRjb/t7/9bZq7DDEPKNMNSibIMx/9/ENPK4ZYT4vNvR7Ls36OFAO8hlJ0vDZeKto6RgnXygImN9fxYXrqid4V7odxBaaUcgezMirEAlN8bKXgYzFEnqWm4hUSBIZnbdYUmfNwchQiwyLlGMZiUwN2O/m+pzC/UZeewJ5H8lEg1abqeHpdhd6fzUdJU/1iZAjX1MC0pHR5QHnAvjzEktCIgC9G6bi6uTbTBiMFafg2dJ8SBKwx3ac2wdLe008/naR5X05MEFj00jVFLKZsuRYThBjOOuusJhfLEo8hYCEoJgiK/Cnkm5DZx0tRGqufWfi9kSNGjEhTl6GA5pxH5l7mfICjRumYa4A4QV++GNERgFcWPbVPxCOmLHoogGZ5iCBgYoKyBAElTUulpUgghurHWK5nkVjA7FIp2jSWAfB7Jbhnru2Xtv1ag6KmiCvQfSqyCJ2DNZPstWRG8/8ShPvuuy+Xj2JIO5x/oDSx0DI0PZo6CA/L7aRh1+s+2R6n+xPxFpLHfI4ym83Hw6r2Y9TIxL9K02IgadxL2lZpQWDlChu8HEqZK8RyBcEkNBc04Sl4QeChc22GWfWamCBg6mXvk/hBYhqz11FgCg9O10VHUT52Oe2wVK80sVBgCsM4dVhqnz9/fpLmw9/0Ozz988zmQaZKtR8jPgnqEjGtNG2szbTZVBCYT1UIexW05Do+PR1MnTq1qCCUAsu32bo4VyQIfhjX6Sa4Y315SO+IQbEYOGVioNeTjwmdhQ9VwzQTcHGTxn0KpfYplqI3T2OQReVd4QUOJ2sqCMzNKFJQ5kyhJWORoVV15MVj2MEeJs3PY9wEPgR8E8UEgWGechBPXBa8XF1TxAeheAReutK1i5ghUGnaqcR9Xnvttcl1fPAqay6UQwPXfXjiuSRfAase6AASBHZCqQ6+kWybfmNtjLGFLk+W/WmHDqxOwDtU+/Iz7LHHHkkeYLGQtlk2d+7qpoIQA8N4WjhKH16tFTjf02KnmxSilqF971Vsf0sCW9tfF7LsngVhdNly0G9cyQJBcBtHcpTDialDad6zGAMvzLdRiLxQhn3g94mITA0x5B2mlaZHQRxgWjhKf97RmWeemaShbDH8A/wA2TqFyOgDvOt2Zdj88uF7xg7HZGRiDs2WlakXA4IQi9dUGDpWjNJ40cVQKr5DZKoSvMUk+gAagREkb8sbBQuRoZ34+kJEG1ZZHCSkYetKQksJAtOF2mI3EO0Qe6A0eq/ajzFmPsbAy1Md5ma1LzK8+nYhPgxNYQzDKouyB/idKqvAXaYnFFTfNlTYGKucTG2kodSqvjqBB+Y05XAyKSgnRlzQHFVEO0w9/rqQPRW6jsgajBa/jI2CYGjSsCc6QDH4lUJ5AT0QFN9elsxlgvZB8qOEUuFvss9Lwdv86ABZcCiFbzfLWHSwj6TSuQPNgR/GS7n0UVxVthjZdZ1FqVHd2FQQGNKYT6DszULL0ALKierg8eNvTxSqbJue3bp1S3o1Us+IQDlcyPwNMXdUX5TWDvFCqqyo7WOAkYA0jrZRfYQvW4cta8qPLcczSqkswz/wUxijYRZMj6ojH4gHHUfXxEzPgkhxniH1dcyAp49tEFECBdYYqM9GYeWjF2TbMTOzqSD4QAqtfJUSBA/pCJ4+rAx3ZzYfMrTx8GWp4DzhbxgbZXzsAIqSyor+jGM0ZtK8UkuvydZh5BF46WpfRIhVVr4JzGHlx3QZhmTVkTneHOgIIfQUlu6zYENs9ll6QYgd6BGzdHKeRUNSyMcOICmk+UWSUsA3r7ZEv2EVezabD5kzCQCR+Yciw98wFk2Et1NROPQ6lRW1qgbQ/EnTHA3InzFrVphl/86y3g0XpuYX4P9nmx4gzjLONM6wclBgr9Z0a5f70MEhHty77kkHWTQHshrwLMbqxzqWX32MrfYWFQSGV0gsvMDiCGmlAkPoxZhBkIAQ6rCNjV7Ahb1TRW3iQ5cShjIqxXJVYrG9uBljx4ZZ48cnnGkWwlTT6OFsS587flyYl3L+uHFhQcqFxjk29cz+7LMwP93osqJAodMz9ERX4hkxIhCel81Hx9C7EznhVfk6TJTpQPmMlr4N2L1790ZBSO9nuYB9TBPQL0NLy2WUyIJeKkHAzbqqQA/98Nlnwx3HHht6mJ5xgQ33PdbuFC7r1Clcbby+U8fwe+MfLP3PHTuEvxrvNT7YoUN4uEP78JjxaZuK/tG+XXix3Vrhn1bn3c6dw2B7+IvnzEmv0nz4A8eaQ/kmPNB1suVKBdkamycI3t8usiaR+qtzowfDsGxpdIRsHZQYCQIet1WB/5j1csHOO4djuSfj2a1ahfNMN7lwja+HHmZGXW68+uurh+uNN9tv+cPqrcOfjX813tu6dXiwdavwiPFJq/dMq9XC88aXV/taeMXagh/vvltYsJwjBJZVzNPayq6lZxtjbK2BXq/6Wr9gGVpAh8i2Y2yeIGAVaBVL5FQQrYbpaFsvCChz2Tr+yBhMxpgi1FJYYHP7baeeEg6zayEEZ1hPPtv4K5u6fmPsvlbbcInNwVcar227ZrjReOuaa4bb12wT7jTebby/TZvwtzZrhL8bnzLhedaE5wXjK8bXTIDeMuF53dqu+nG+d7IcENgaCz3H/a1nG2Ns9dGvaOLEopw/1hedKtuOsXmCwHyii4golTE4Z0VJ+httScwzxa7HwQeHg+wax9uLPrldu5UmCD1ttPiXXWdqGrLfXGDdZJ9LqZC6UvEIxTygHnnxCESsaAOlXMQeLP+6jZMJ8QyqjohzhpGCfH2MA/Jjs/UxgWI29ooCy+JKa7urXfcIG8J/Zv8eZzzReKrxTOM5xvONFxp/Z7zCeI3xRuMtxj8a7zDebbzf+DfjY8Ynjc8ZmwiCEUEYbHNwc0FHiO0E1zoLVhSOM56tVlNBLEKJjTJ6tqwTAUbo7Dv617/+lbN08gTBKy2ERZUDnB2qIzK3yezDUlA6DphVhf7WM0/efvtw/p57hAu77hkuNoXpUuOVxmuM1xtvMt5q+bebgN5pvGuPLuFe44M2yj3SpXN4zPiU8VlTCJ/vvHt42fja7ruHN63MqxtvFF6yOdgLwr/tN1a6bXDlIhZKD/1hWsROkMYoIJQbs1gokkoRYXmC4F9aKZenQLCJ6njKJ8ChkUordQRvS2KRCaLODsHeb0mCCR98EF40Res1EwYJwjv2G/tstWVYGvEpFENsqyH0+y9kjpeKYo7tAsNzmy0H8wRB8e+l9jXg0VNZHRbBej/eP0+sB7yMqq90PHqk4Sixiyf1GaZ0Q18lLF36eXhrm63Dq/asmgjCJhuHpc00JVHY/PMTsah4Xng9Ga1JK7WvAZdyFkzzvl3Idrm8cHZDTgCyxH0q8FKVrvmnEBS3R3ygoPOd8TFIEHCAcB7CVw3M229svnkTQWBq6Gfa/xfOS7ki8KfUa7tgbKcT1sKKoKggMCdhinhnhD8BjfUAuXmzZM1dZgwBrUrXgZv+eD2Gv3JD1Dw+t/rwy8BCM5OrzB5/wX7LazY9SBB62t8Djjk6LVU+0Kf0ovEF6HkxgvIcMbEJGSQtpk8wMhAZrnoibWXBKJAtZywsCGj+aPPsMBK8ILAIowWXLFkVk4OEBSWly6T0gsBDUJhVIVC2jymad9mweP5pp4ZjTaCO3GuvcFTXruGE/fYLpxywfzjNRpszjWcbz9l/v3Ce8QLLu8jYY799w6X77huuMF6z7z7heuNN++wTbjXebrzDeJfx3n2+Fx40PmxT5GPf2zs8aXzG+Pzee4eX9t4rvGp808q98q2twrM8I3v5OWVx9dbhbUsbZ5ZVc8Ew/f777yf/z+io56UNwEzDLP6RRmS03oHYypRznrnqid7CEHDvZ8tZ3cKCEFMWWb6NlW0uC22sjeEJ6wEH2qi0oT3wdahr3LzVamFrm3q2Ne5gD2Fn+/s7JnhdjHsZ9zFz8QAj/oNDjYcbjzLiUDrBKPPxl8bzjDIfLzdebbzB6M3Hu4z3GWU+PmXM+hHetLTeu+zSbEURMCpifQG/5Q19ANCziwWmFGLsHcYO9DA2CgLx81kSaEF4u6df9uT/Y/UgW70UU++JAko+G0zUJr4JRfx4TJ06JRxrGvKaVm9de9lb2lS1dadOYdtOHcMOxp1tRPqOsbNxz44dwt6Wv5/xQOPBHdqHQ42Ht28fjjIe275d+IX1pJXlUHrN7rGnXWfGcuo6WFOsufA8MBn1HLWWwHCuoB1iMZQfo3dMxRRHxWuiwxGeR51TTz21URDSMk3gLYgYY98Y8ogdr6fDnZjPfHrWs4jL9Qc2pK9ueZvay9/cuJXxv00QWGuwJxh6brZZmJru4lpeaPtb7ORVLwhe+Y6BLYB6rsUEoa393jyrIfkrg1LfF4ht0RL8WoOnHErMedIhmPOyQtXDFDHyvmkveGN7sZsatzBuZdzGXvB2xh3tBe9i3M3YxV50V2tnH+MBxh/Yiz7E+BN70Ucaj7GXjYv5JOPp9qK7Gc+1l32+8SJ70b+zF32F8Rp70TcYb7GX/Ud70XcY7zLeZ73+IRv+HzU+YfeFZ5Hp4WVrt6pbtzB/fPFOUQ6II+Q3+8PJBC8I/qDvGPxeiZggKMYhuvdRmyU1JwEJAhqpNmViu5IGJQgEcKo+PgFQSBBYl6CcP8wzKwgEca5taR3tZaxvL3NDe5EbGTc1bm7cyh7+Nsbt7KXuaNzVuJu92C72w/Yy7ms8wF7uQcZD7OX+xHikvdxjrL3jjSfbiz3d2M1e7rnGC+zldjfN/1LjlabwXWu8yYbNW1u3Crcb7zTeY1PTA6aHPGx8xpSrt02BHHDDDWFmJOB0eUD4vjyHzREEFqV4ngT/yEKICQJhcHpHCvOLCoIhycRlKehl+bMG/fcFJAi8fKXJJVpIEGLMCgLTRi8bOSrtR1SasiNWOVanrDHWpqxLOcBYn7LBODDlIONg4xDjJ8ahxmHG4RX9wqf9+oXPjCOMI42jjKONY1KOgzatTbR7mtNCwSge3rXfHEHQO0Ifk0vfC4I26/pzK8WoILDgAX2cPVJGGmcasKED+o0hEgT82KofO4sZSVc+85Lqi7Gp4f8aMNUxs3kezREE9mfwXBEI+SG8INAu7w0nlN5BJ9OzyIsKAnY81PoA4P9JI4gEDRO2siGSRqAEwRpJykH+H3hBQKCUH/si2/8EofEZKtC0OYKgdwQFLwh6b7Spcpz+Rl5UEJK/CoCYRIpkqW8YFYLsXqRW0OdsPP/PCkLaaQTFJ9K7s/CCEDts1IPDSPzzhV64JAiQdkFOELRpMhZyXWgTLNOI6mVJEKtWy9CGlR47hr+lBaG6V69w8VFHhRtOPTXcZLzZSITS7abo/tn4F+PdxvuMDxgfPuXk8KiNWk8YnzI+a3ze+NLJJ4VXja8b37KH/6+TTgzvGN8z8+1DYy9jH2M/Y+WJJ4RqY52x3jjwhBPCYOMnxmHG4cbPjCPh0UeHMXY/izMdSae/saFIz4ugVuAFwW+sjZHVSf98IcGryid4lXcH8V2k6U2VxdgHK0ttgl1Roje0pCBMMmXuoE4dQ2dr+0DjwcYfG48wEpxyvJGYxdOMZxl/ZfyNsbvxUuOVxuuMvzfeZvyT8S/Ge40PGh81Pm58xvi88SXjP414Fllr+I/xPeOHxt7Gfsb+xuqU9caZzzyd3u0yxI4BVGAvgqAd1itKfXsK0AnT9KaCEIs4RtlQ/sogSpKWtFsKH77xetjP5kZczKvCs6hFp3eNHxg/MlO0t5mh/YyVxurVvhaq7F4GmwU2t2+f9C6bIiYIrDUABGF5XMwxakcW+kLeJlhtlkRa/EZJ6IMqme9VVmcH4xtQWmznDaeAKT9G4uqk8bYkPn799XD8lluF79s9sNbwc3u5J9uLX2WC0LpV6GvXhZXGkaefFhYXCdKVIOBZ1LNRUC9KoTbWMpTr2aIYksYxyFrQQ4dQfb07NvMqjSmB98r18jbBJlcz+HMWY2RDhcAaOGl+W7w/lkUkQOXLwoxp08KTN98czu+8ezjOXjpTQ3bhSXGLFxkVt3itkbjFW423G+803mN8wPiIkanhaSNxi5oa3jASs6ip4SNj/3XXDcOOPz7MKiMyi4NLeV5YD8Xgz5vQ2db4ELS2wyGegk5M8afIc4CJ6js2CgIeKOiXmfF909s98WSpLD2dNHzfStNxcJ54I7PgxnFyUIel0pUxIngsNQ19pJnBH7/4Ynj7/vvDO6ZZv2t83/ih8SNjL2OfBx8I/Yz9H3ggVBmrjbXGAcYG4yDjEOMnD9wfhhk/NX5m7Y00jjKOMY69774wztqa/s47YWH6GaFSIIJIG4BZBBK0CZaerGfEPhK9D0LcyOcgLvVu/z4kXIwMSiO4iLqMCnkjgkEJOcbO5/GCog2rflt8jDFBwOWpfG6mpXWErxp4oYpH8PCbYGXze+izhM2hdASmmzwdwdCkMIxFMfuPZmn+8p/FjdF/CVbAGeXLrKx9Dc3BKNNVpnz2WfpXYSxdsiRMrqwKcyMvZnlBvCG9PgsN4zh/Ys9IO9abw6JWgzZIeuorbrxwbZb0S9NsoSeNg6Wydf0mWIYl1dcZAETdsG5BWSRU5w18GZg7c2a497DDEvPxKlMcP7h92cJbFrPHjAn/7No1WYF8Ye21w4gnnkhzVgwEk+Ix5Bn5cxakc/EsJQgcLqbnGdsE66kzkgptgkXxTNObKosxEE9IkUL0++o8YuYOc9l/G1674fpwtt3bFWYN4EMgQmlcev5BFu+feUbiS3jWTEJC1V7t0CHMbwEfiD830n83W2s7XhB82VKn4+oYgkKbYLVQlediZt5gORNq3cAfuOnXGkQCUlWH+qDQ6qMO3PSgjq71ZeD+o3+WWA2J+bjWmonVUFOgp7+0y87h75afmI8mDASvTmqBTTu8XNYEeMZo+nqeCivzguD3nrC9QGUF/w5xLdNmbBMse1IZ9SlnimhTQcB81GZKxdChrWqzJFG1ugmR+Ut1YquPnjFB4PBMLWB9GXjlyiuT2EUCU65qtVq4yv5/TGS+Bv8xjfwhy2dE+If9+4pNJS2hKyhkj2eMT0DPU0cNFRIEYj8px0dQZVWgeKo+eh5tev1Cm2BZOiCsjXJ5X4LlBHFdJGY1xM7w8yz1JdjYCWjMibFo21WFWVOmhDsOOCAJYL3MeuW/r7s2zcnHjOHDw0s77ZT4EZ5ru2YYZuZiS4AQde0CI+A0+9ygdpqzwzmb5+MR/Nf3ZdkVguusTQWBYEltoGQVSxsmRcxH5UvjJO5eaSgelCv0JVgEKdsmgayxo+VWJXC3DrUhfmwayFEMi+fNC+M+/DDMLLHBpzlAEDTf8yz0PEUWkhgJeF4E/2TzWRrQ9MB0oXRGGurEOiAbYPkEUPpuCiuLPpxMxKEkyH1JjIFQ6ii8GJkbv0yr4b8BTKmx0088FFDiv15TCrirqcO7yqJsQYgFr/pjbuSM8IoIXrFsnVIkiJUDqwmTEzkdHUGExNmRxklnfrNNFvww1jooi32t+iJKrdqnlxRDjx49kjr+SzH0NLUVG3Lx+5OnTwCWA9rkfohFKDUqagTmeZQLlEXqFLLsZF4amycIHLrNogbkEAcUHOZ4pSEopDGtuAOfc2SXDflMIbGjYkTOMmYIhP6IuNjJKrfddltybb8OzwtRfdH72L2tHgMHdFMHBxoRVrTPYo3a4pS0LPAMksd3HRTwQfi+no2ISaiIIj+f4yUk3x8NyPmIpDH0o3/x7PTxEw8UQDqhvw6UDsC/2Tw6lnw9xuYJgqcilPBfK82fwFZMWaRuNs/TTzeypdE5YiNC7ONefnFM8DuISp1EIvCAVcfvCi8XvDjVF7GydFSeX0kUfbCwP7ey2HoM7mffxnKwURC0GdLP1RIE5nAUwiwRAOr4L8Fyuinw5iMarfK1WkaMA/lKF7kWdfBg6p7oDaQRBMuQTBobYASGSvI9sZVVX70PrVz5MUHwX4LVQ8fMwuamTuwAChQ01RHxmsqf8txzz+WuqU3FjHBq3wsCOgD5/mBQeRYJ3uHk+uy1RP8lWE/duyejQLbcOuus0ygI2gzJIocgQcDTxY/Lkq+DUMd/CVaS7gUh9iVYHpTSPPUtSX6A7knLq0wlPCzSfBxkTBDodaqvo/9LCQLzterI31FKEPzJqyIKmEZLLwh8EJzfyLMRvCBgrpMvMxFIEPxvj9F/CdZTcZCefNciW87YKAiGpBBzhyBB8F8R9dgu/e4j5WLQ1OBfWinEjoyN0UdSxQJiPbVmwqKO0hT54+FjMTg6F/jAXV5KFv4sZs+YO1ijoYf/FndsdRG9RPnFyOcFY4gd0IWvKIuci9mQFPJr4RIEYuW0YdVT3zZkzTubh8IkZZFhXunewyWwU0r5MmcY5rgX6D+JJ6IXqI6+GsPQi4BQh7V2lWUBjHIoiGpTJ7ozQnG0D/n0TuXrqzEopyyukUbvzsKfH4WGTjkEX70e55DaZJFN9ywyWqo+imM2Pxb+HyMBr7Ejeok7IJ9OqfvQ88iwqSD4niZBaEmiT2ShT9p5+lEmFvUUo1+socdn8/3R/wLDsIb+WOBuKXhB8KfOxlDuS10eYgYWEwQ6jlDgeTYVBE43EVaGIMTWGvx3oEW+7iqU+xUTRi7Bb80TY4LAYpfs89jHzEvBf68hNuR66EuwK4MofDFBkB+BKULwu9UcGwVBm1y1Vw5IEAptgmW/ntJF3JrKjzEmCHxUQvW1QRMFCCUQynGFtsvwTDkUN7WJqUga3jmuTx2/fwLFkHx9YQ4wTVAO/UJfl8UHoGuWIlYP4Exp6kLMy1hZUV+CJfZAoxDnE6h+MbK+IOXbE5c/+SiaslTQb3RNufnLFoS0TBPglCGL1SkBhxFpELMli1LDeCmPXjFlEa1ZVodfgdOZC8zLvrwY+xIsSrHydUgHD9DXK0ZZIh4caxcrK0ov4XpK47OE5cJ5AXOMhbfhrMuW8wGxfqeTY2FB0CZY79zxMYv0bnqGp74E24oTTrbcMrfxUtQKGy80WxeqJ2P+qY6kmn/l0WNzp/IZCaiLBo+eQBpDpe5TH9nABa3r8DAox64hnEbAnwfJNKP2Rd8mATZqS8R3ka3jyTlJlMOphgJMGvpRtp0YCQ5CgebaTGVqE6skW9ZPtSjflMPEVz6RSaTRwZ2fobAgMNTgjJFDBnhBwPmTpdzG9F7sWtUXFYDC7iluolD9/fbbL1enW7duSZoXBNpRPtMBdREC5knS0Ix1nxIEBEXXwapRfcELAp/6Vb7ovy6rdjyJBczW8cQFTjleAEJJGpZKtp1C1LXRZdQmC1DZcnRClWW0pBz/Kh9FmjSch2UtOsXgBaEUcVQUAi80VkdkK76g7zhDOWo8NIVxqpjgv1kgQfCKHb0zC//dI/8xUMHb/DFSvxj0JVh0Hc3nMRdzKbJIJZSyRLQ45qPGiwavckPQb4JlyFW6iCBoA6WGSv8lWJFNFlp4YVjLtoNiVWzRyW+aQR+gTeZTucCZo9VW7Aur+rYzlCB4zyK9inL0Dt0n/gzdvyKm0DuYcylb6iR0Vj4pxyFkuk9WFHVPuk+UW3okIF31sfF1fVH+EEL+8fqSxnPItlmIjGKU41+lccCp6vPMSOvRo0ejIBiSC3pb2jtlRL8yhseRNLTTYlier5PQy4vBn12s1ThGIN+GqMM8C3kBY6OM4D2LzaEcZ1gISosFmrJyqnx5QD1kHdFzpSgzbalOzArzkMsep5/gV2GZokCeZ9E7lHRKqqfXcnURhrxiiK3AlaLfohWD/5akAjp4kL4NUb07djA1SmmxKQzlKlunFHlp2t3t9Y6YMw2/v/K96S74KGYtwXvrBqEoBrmYY+Yjv12dICcI2iDpN8HyApUu+h1JEgRcu6qDTQ5YHcQpRBqRuKovBwfTCVveSPPnDTMNkKb9D4APb6p9kTpqE98GaYxMrIiS5qWe3kA+Fo3qiHgG0UfIR4PPAuWTeErKluvh9IKAkOlaRG9xHeIOFFbGeVHKR/Ej31NbAlAAcaWT5r+ci/s7W8dT8QYxQfBtGpsqiywj8ycsdVB2zK7FKQP8MO2nGx46adQV/PDIg8kCp4vyRR+uRfQNaQikEPMs+ocheM+iV8Ji8PdZjKyx+GVyAUEln5cbQ+x5xoggCeW6rf1vL+DvaCoILECkGYmWzKKJp18h4wVxAU99CJsHwU2S5uMc6amk8WPw9NEmyouvT5oPb0e5Ur7od/zSU0lDWZM27k09MaZ3sNawQfpldx+WFgNWga6vnsZLV5raIXYAxxm/A6+poFVSFuuYpsj3nyfAyUU7igWFjJxqX2RRi7rwrLPOStJwGBVTvikj0El8eykLC0KMaKktAf/FdP9StdLoF0mWBytDEDx0loFvM+axQziF2HK5/2qrwFSk/Nj6hdcRtHOMqUinssXIyy6GnI6Q/l3SzUpQZ0sAs0ptdu/ePU1dFhldSgEtBdYS1L4YW3QCOpLGK8qlQE+ljnfdEpbvrwf911aOPvrovHz/2wVMY+XHBAFLQflyMWMCK4AnRm81xJATBG2KjC0aMadhS0PtfvLAxFJ9kZFD9jm6htJjm2B9mzJJWWjy7cErrrgiZ5+jKCld0b+4ihFU0uRkgqRxHUYJ1RGZVjTME2iTzff0+zYxC2kTrV/5+gquJx5O5ePW5TosqGHDk++/2iqitKp+7KutPkiXEYc0FEi8hkoX2ZlGO/4+RUxTxU3kmY8x8oCKgdWvWD2ZZd7mL7UJVoJQiDJ3vG9CbRYy9caMGZPk+yF3ecjQn4XfIEzkdhZ4KH0bEIEQeEnZfKwxITbKNIfSUfwo4ynfRU4Q8FwVYqFQNYEQrGwdImKwAHCC+C+OyAGCtk4elJcNxAQBSadNlmG11oAfQdfCG0o7jDbYxqT53hHzLKrNQvT+ehEPnO5Z9IeEMB1l8/EjZNtkWmG0JJ+RwV8Xso9RoEcrXcog7fjyWfrfjjkN+DdbDitLjq+cIIwcOTIUYiyWzgPvVLYOPYWVPeILfFi7BAFlkdVJ8pkihJggMKzRJtIrq4ApQtfCeqEdFExGBdL8t6digoAlovox4gNRWZGFNK7j6Y+8w+WezcdtrDYV38Fim/KZBvx1offVsNRPGlaUVh9xdWfreKJ8654kCOyLzJbjeaoT5gQh+asFgXDoZjzlDkbLVRrrF4JOavNUiHwh6AGzkibghFJ9hAOwlqA0v/8iBj8PrwixFISY/sVcXQ4YQbVSWMq68QtupXZPCTlBwO5tCWo+psfiyePHe/JRCcqxa0dDHV97UX1s6WwddhspX+SlCnLUMPdKwhmSVR9Boo6fjxXOjoePI/LJ95/PLbXAxPBN23JmQSweXVNEGdU94w3N5qNUKz9Gei5gKomdxYzSTDmmZ42W/ixmpivyY5tgKa+vy9r0WlpZbA5Z5y8Gfe6vENV7PfxuHxFTTIgJggdxCtn6EgR2TrVt23hivPcslhIELe/6UcYfCSD4o/D4BG8W/kyqGBFeUEgQ5FnEElHMohcEsdAmWAX9GFtWEGIPw8ObdTEqjNzDxyOI6AWCHDWFBCF2oqkXBBQn0vyndksJAj0R+IWsu+++O0nzQJFVfiyszO99jNE/T8VuekGQLoPiV0wQcNTF4PanNhUEIoNYbGoOse9VPyYIKGkM+ZD1f+og6ZoasIXVlt8FJBBdo3wRbVttan+FFwRc1conYEX3J0oQ0NzZ2EKbCqMDEgR8KLiWs9eXaezD2SUIKGYstHFtnqfyWc0ljUUf3SdmndpEeVRZkXB06rBhVSOXFwSEi7qMPLGpAUEjn+FfwAdCmyzW8b7It+mzqSA0Z1eS4L8OEhMEbz7qYeMPUBqOnubCB6+KfiHLa84xlhq5NMr4Dakx4O9XmxIuemYxvz8vNAbcwLHyWfotBzGw8Keysa/1sj6h/LzDtAxJBuaOgB/eb7TMUlKNwqH6esBoufQayqE3KF/mI7qANsHy0rJt+13PKJ7ZfISLup64e/EzkI95qPSYxw2TNdump84vJL5QS8YejFyUo6epTUYp0jC3ccL5e/Nk6ZeO4K8HtWOrFNFlsnU9fbymzEe/WZf1De6DkZSPsqTphQWBpV5tsoxR0hYTBF4kQzXlXFxcThAYxhAUyPCVbdsvtTKUZvNZ21d9Ef0C4SKf6UrpfjVPxK2cbdNTekMhQWDIpxxzc7ZNlDqcW/7ePAlAYcrx14MxgY2Re8vW9dQUAiUI6DTKZ+rgPjDh8WKSlvclWC8IpTR8pAnEBIEe4x+S6Odhwdv8oo9Z9JtqREzOLFjSVT6HgApaIFoeIlgxlIodiB3oIeDNi9VZGZQgeF1Gp97QGbXyaiwsCKW2vClmoJAgaGcO8yztQqTRbbxMiENJ+VLsGFqVz0slD+tBK2woO1kw3ahXeUHAVqe+D2gV6V04aMhX0Azkt5NGEAfTkL9fiDKYbTO2CTYGfAMacTjjiDqQ4Zo0v2FV5PdqcUweS1hKICUIbO9XHZmxmI954eyGJIGCQksJQrdu3ZI0EDMffTwCbulsvvcCKnSrkCC0Sv35XhAEXM2+XcioheUAWLxSukYu5k9fXpS/wy86ISDlANeuBMEHA3PeBGl+rcFDL40OIRCNrevHWCzKDEVxlQqCP509doi0F4SYwkSkFKBNFpVIi7lZfcRxLP7Qa/gi2r3C4zCjlK6AWPJ8eVEOJbyRStNvLwUUWgkCC1mCdnnh94hBo6UPdomNcp6xgFgP+SaMX44gIIkMUSiPrMmTDuXgQCDIg1r0QmnDbiYNf4TqaPhjTyEvkHwUUOWLKJhqU+Te5YjhpSudKYE62Owss5PmzS5cy+R7kw/Fy18Pov8IRICTxqgo89ILAt/P5Dr4LbLt8MI50YV8/BVKJ3CFNIRY29fwupIGefaUI0RQoA5pvF8XzFJYEEp5AbURNCYI7BLWnOZ7LzdAmo9xiHnXSoWzs/lGZWMxDrE2Yx/fLgRtYfeBprHYgVL03kp+UzafZeYs6GDZclDWi5/CNHIxzOul+hFWowyLeUKBszALC4I2wRaigh5igoAPgjmPcn6FTYLADeJrAP6lofxQB0+agAbOnMzStXwXfhinx2aB1Pt7hd4Rw/BMmyhRapOAW9Kg9nR48xGHUbZNN8cmSh5p1JHS6l3h6ErZ+v7cShbsuDYvWvksfdMOJiHubPJRXpXPcyANnUbTDWsz+h0sbFHOTyc8b9K4z7xNsIYkwQsC5gUPqRD1ImOCAFROrk9QShDwBWTrMEzzYLF3FZhSShBi9+7bZCWQNpl3FfXEKEMa1NDtBSHWpt9PiUePNHwoilPwglDqnug4XJu4CuX7/Rm6N9pUvt8Eq3Lcu9KIFFdZQfeBo66gsshDby58CFgphQlHEeV8OJbfg6CX4kFQaTa/lCCUAiOO6stqiAXu0iNjDiWBdRCVVaApZpl6Z6m9Eh6KxfBHAGkzimdz9jUw4hWD87E0FQSkkuGqOcRuVv2YIGBiqazmLIZRpfkjZXB/Kl3ExCLQkn8VvNocQSBmknaoI6B40SYkAop8RialiaT7XptFbNEJ5RMlkfrM1/odIi53tUmPVTreUOr4VUztrkKwOEKIfJRO1eH/SdMIp3sRqa+yWeKKXmnL0Dz0LBCOWNlyGbPP2daufLTjYpCJVEhZVO9dnsO00PR1HzJzPWLBq/guNFT7aTHWe7VXwm+CjSmLWEzFwtnL4EvGBLHMZhNFJgu/YXV5GBMuv7m01Ods5KRifSALhnG5WWNu61KgR+s+YkE5jDzKF70G76dF7dr20NSABSa3tQ920cZa4hyLbXApg68aE+xu3Ma42YrQlJfNTAlsQjMfo2XLZaxNM4Fy+TYM5+V7+rayeWPHji2aX4o2CuTq2hSXl29DdpP2RevBSX6XLl1yac8880xefV+nvr4+SfNtdu/ePUmrqKhoUnY52MHYCGvwcOMl/+P/SV5hvEGCUPzLESsLVdWsiqR//A9fJiQIjQcQr0LMGTMm9GqzVqj+bpeiZtqqwZf3pbn/FnxpgvC5ac+jH3gwTHz5lbJfQ7bcF814geWWbU6bLQW+ETXJzNF5EV9KMfCNqakVFWFqTW1YumSZ42h5kBOERXYzw6+7Loy85dYw8uZbcvz06mvD7EGDw5yRo8Lwa64Po35/cxgJb6Yc5G8rd+XVYVrvPmHBtGlhxI03heEXdQ+Dz+oWhpx1dhhxxVVh0mtvBG+VL5g4KYy8869h1MOPhMVp/BxYNGtWGPPoY2HYBReGIeecE0Zcc12Y3PMds78bf+g009aHnHNuGGtaeXPA6x31+ONh6KWXhxn2e4SlX3weRt59Txh6yWVh9HPPfymCMPCkU0Ovr7UKo55Y5u8oB7MHDQz91t8o9N9lt7DQntuKICcIi83urWi1RqhZZ4NQ2XHdUNlhHePaobeZGJNeeiVM+fCj5Gb7t+sQKtt3CrXrbhDqjFVWprJdp6TcqDv/EmbU14eKNu1D3YYbh7rdO4fa3bqEynXWD1VrdQiDzzgrLEl3Ss+qrgv912wfKrfbOcyf0/idgjmmL9Ttf2CobL1mqFpvg1C9yeahr12zau99zf5unD6GX9wj9LFrTYnsFSgGhLD2sCOsva+F8a8sO0JvlAlj/6+tHio23izMSEPVVxbmTZgQRt97XxhjAucx7LQzQvXqbcLYp55OU8rD3MGDQp3d94DOe4ZFs5d962F5kBOEJW+/Harb2ss65vgwu25AmFNdk3BW//5h0fQZYbFJ3IzefcOsiv5h+nvvh4bvdg41m38rjH/uRStTGWb06p308unWY6vX+UZoOPSwsHDRorBk0eLkAQ/s+r1Q+fW2Yfw/Gh/C7AENocZ+RG3XfcKCeemRdN3OtgeyZhj2q/OTUWje2HFhas9/h0lGQF8deNAhoc4EY8mSRidLuUAQGo4/MRHIiW80HiU47eNeoXqDjY2bhKnv5X/rMo7siFF6BFGJMY8/mXSYIRc2PWti6Olnhqo12oaxTz+TppSHuUOGhNpNtwh1Xbq2rCBU2Yv65Oxz06zCwE1av8feoXLTLcOsdGuWMO3jj0PV2iYIP2nqa/+sxyWh0nr3yL80ulFn1yMImyeCsHDhgrDEhv7arnuHGhtlZg+O79ubO3x46Guj0dgHl7mzF5qQTrZpZ4L1puk2XxZ6LYkQmSBUmiBMfv8Dm1/nhro99grVbdqFMQ8+1FgohT2PZHSa/M/XknanmCAyHytvSt9+YeK/3wlzx42zdhuvyH+nWQea2LNnmDN6dFg8d16YaB1mSkVl+NzqoAcMveTyUNt+7TDo1LPCZMubmf7Ooaef1UQQFkyfFia++16YUlmZax8stf+f9sFHYcLTz4ZZNTVh7rDhoc46YyII6dlN0yx9wjvvhnlTpiQ1+VrthH/1DAumTg1LFi8K4154Psyy57is1UY0FYQ11gpDzjw7KeSZBaNDfZe9QpUJgp9vwTRTehoF4Ui78caeOMOUmQG77p6Un53GMjQKQjoizJ9n1/kiNBz+01C7VsfwSbdzw/xxy3YGCxNeey0MOPq4sCRdd5j85luhevudQ7+11wsVG24U+tk0NeTX54clJlhZ8DsQhGoTpInvvx8+tSmmes12Ybi9nCxGP/ZE6NOuY6gwoYRMYUxZcz5pjN4edN5vGnu2XUtYOHNGqNr1u6GPlZ1WWZX8vn5tberbe5/kGdR3+2Xobx1t8HY7hbpNtggfW/0GEwCQFYSpJiR9rWyVXXNJulK7YNLkMPDYX4Qqu/9+ltfX7mvwMT8PA7fdMRHoRekzqT/0J3Zvq4dx6ag3/skn7Vqtwqd/uD0MOfHk8JFdd9Qj+a77nCAsNkGosbm8wV7YQHuJ9OgGa3SA/TtvVNNe31QQGiOaBQSh5pubhvoddgkNh/w41H//4FC7yZahdvudEkVP8CPCgrmN0jzFekH1ZluFGhPIuh13tZd0WZiZul8RlM9Tnztg6qi0Ib3epomZ1gvmm+R/Zi+3/9dahzF35W9BkyDUcW8nnhLqN9os1JkQLZiaf9L8tH4VYfQ994Z5n34aFtj0NOrG34cqm8MH21wOZtqLrvnGN0Pdrp1tRGrc+TTFXl61CeKgH/woudZMmy5r113ffv8PwmIb7egMQ8//bajttG4YdMLJpne9HKZbO2Co6U5eEKabPlbbyTrTD3+cjAK0N9iU7irT4QbalDv5zbfDpBdeCnWmfzVssFGo23PvnCAMOfJnodr0uIlvN+pQU158OdR+Y6Pk+dfusGsy4mNpZJETBEaEmvU2DA1Wob5z1zBg9z1C/XdM2dt9z2RI9ihLEHb8Thh05NFh4GGHJzdRt9mWYdhFF4VFaZRvE0FwR9LNsIfDg6rZaPNQ1XoNu8YWYezf8tccPr3s8tC/dZswwcxPehzD7+zhn4Zaa3PgwT8y87Spb4KH2fCLk0wANjVhMCHYZjt7QBuGEbfc1lggh8YeCOZNmGh6UZ8w5qGHkl48wIbgJfPnJyUGHn5UqGrbMUx8tfHgyxHX32BTX+sw+k93JH/PsOmjxhTeAQceFBYvbryXcc88GypX+3oYetWySCIw9IymOgKCULO2CdGPDkuuNcemFZ5V3dbbhTkmnAJTFlNp44jQOHUNPupoGzXsvlJBmGzPB8V+wLe2DTNql+0vXfYrG9FEEKra2NRgUr8UJW/BQqPN3cYvMsuxZU0Nhx+ZvCAuONdGlEH2d6UNWZiZoMnUEDmbcKZZH8N+c0EYYOZR1YabhOl4IVPQ5qCf/iw00Kt32jWZHmCNCVxNx3VC/+12DPNnNzWnkpd3/EmhrsO6Yei554WpH1mvM+Gsxlowpdhj7mcjwmAbRvvbtSvsGtUmNA1bMBfvmZjHYNyjfw/9rYcOt17O72z44aGhxiylOelZUU0EIXWYjXn4UbOI2iSmqkcxQQBTbZivbtsp+c0e80xH4DckOkIBQZhkglBt0+0gm1KLoakg2M18YjpCKZQaERJBMFPNi8/kV14JNWaV1B/Y+G3DOVavmCAIQ+zlYUmMvXvZKWOJIJhg1dmwOMKU0DG3/TGMvvnWMPoW461/CKMfeMislaaft2kUBFMW7R4mpauWn151Tag2UxXdBAcXWDp/Qag/5LBQZfrDiOtvDHOGDQszuddvbx8G7NbZFLnGqWD+5Mmh1ub7BhuWUR5rzNQdfMyxyXVAVBD+9kijIFx2RfK3UEoQprz+RvIyG444Mtc+mGv3lrMa0qkhKgj2mwfaKOvrZtFUELAaflnaakAQGoqNCJ3WCwOPWBYrB3A61ZiGPjCV6jmmNNba8O8FIesU4cZRiJifxz/e9PSUYb+9KFS2ahPGPZF/7H4MSa+V+fhWY0DLwhkzQi2Wgyl4Y+57IEmbWT8g8WGge+jBYQXU2ANnulwwY9n5zcMvujjUmPnJQ0b4xzuH0EwThNpUEBalgjD24UdsujNBuKBp4GqpqWGWmYnVG28aarfaJhkphfFPP226xHphQBMdoYAg2G/X77H3HSa+9nqY9MZbubRlgvDWW6HGTJuB++4fRltPGH3t9WH0NdeHETaMTXzhhbR4IxCEgaY7MG/ljQhmPlbbnNSw7wFhWs93whS72GdXXBVq7YHhoJrwfGNbswfUh7oNbb42M3ThgvlJj6yzUQTNlt4/4f4Hk/+vsZ5QYy9gfuaI3pmck2y6CO2OuO76MPXtnsZ/hRE2Osw0My6LRBCOOyGxFORHABNffjXU2HRRt9W3w/yRo0w7nxSqzSSr33SrMP7Rx8J0U2AZ3Qas8w0ThD3D/HREANN7906mlgbuY5fdwoI0rhLM7NM31FmdugMOzI0IU+hsZo00mHUx+tbbwvRejaeZZB1K0z/8MNR2XC80HHxoYnklHeL0M0PN6m0TAR13/0NhlI1+1TZKNZjuUm/3tXh2Y2f6xDpg9Vrtc8KOUlrTpn0YeNwvci996kcfh/7t1g4VprhOSxXHnCAssoqYJNUm+RWYYybhFfZDMEUGmenjgSBUfXeP0NsewLSBEoTGy0wxQehnSidadX97if3bdQqV61jP2Ge/MN55zmaZIPRbf+NQYYrpwoWLzA6eHQbYEF1l16ywkaPfGu1CpSlzDT892l5sfLPGZLvnuq7fCxX2cPtZT6+wa/Wxa47LeO4Ad1d77PGhl1kkY22oFUgfZFp7P5si6k44JVE6x9xzX6g2pbLChKaf/Y5Pfn1eGGCmXN+ttw1zxy/7fmVS17T0Wrvf4Rcv26cApvfpE/rag67c7/u5CCN8CwNNYWXExPz85HeNusLAU08LvUzfGPVk4+g29YMPQl/rlFUH/WiZ+ThxUhj48xNClVkiFTZVVtizx0tZf9AhoWLbHcLC1PrhGfay+xlvpjWYYFZDbxvpa487PicI082i6W/6TH+bzmamB47lBGGpDc84RGY0DHRsCNPr6sLc9Hwk4QvrvdNNAKbV1YbF6QeyBBwb0/r0DlNsHp5iPXT6e++ZqTcocWZ4oH1Pq60N0wcPyoVv8e9sGwan/ue9MPWdd8PswYNzeoZ+hKC/F5kyO6OiXyIU09//IMwdOTJ8HvU6fhFmmsY91ZTOBWbzeyw0xXJaTbXlVeZ0i1l27ck2csjvMWvEZ8n9LnU+ioU2HDfss3+oMmHxQzZYbHksBs2w3/PFF8u0JVZap374cZhso8O8MWPtrszaGTEiTKmqCvOnTk3+xks4zRTYGaZ4MowLPKUZ/SvMWuiZmMtgpukJ0+1lLk2e7xdh1vBhYaqNlgvMOqMtzFt+88xPm1p+0+23TrffLOQEIf17pSL7Mr/KmDd6jFkWp4Sq1dYIw7r3WIHf1pJPZfnbWqWC8P8LZtvIUr3LrqHKps36Hx6Wcyp9lfE/QVgOLLbpr3L/A8Jwm+Pl4/9qI4T/B0/JfguO0BfhAAAAAElFTkSuQmCC"
                />
              </a>
            </div>
          </div>
        ),
      },
    ],
  ]

  return (
    <div className="footer">
      <CenteredLayout>
        {isMobile ? (
          <>
            <Collapse accordion>
              {footerItems.map((group, groupIndex) => (
                <Panel key={groupIndex} header={group[0].title}>
                  {group.map((subItem, subIndex) => {
                    if (isFooterClickableItem(subItem)) {
                      return (
                        <div
                          key={subIndex}
                          className="footer-item"
                          onClick={() => {
                            if (subItem.onClick) {
                              subItem.onClick()
                            }
                            if (subItem.modalConfig) {
                              setModalConfig(subItem.modalConfig)
                              setModalOpen(true)
                            }
                          }}
                        >
                          <div className="subitem-title">{subItem.title}</div>
                        </div>
                      )
                    }
                    return (
                      <div key={subIndex} className="subitem-title">
                        {group[0].title && subIndex === 0 ? null : subItem.title}
                      </div>
                    )
                  })}
                </Panel>
              ))}
            </Collapse>
          </>
        ) : (
          <>
            <Row justify={'space-between'}>
              {footerItems.map((item, index) => (
                <Col key={index}>
                  {item.map((subItem, subIndex) => {
                    if (isFooterClickableItem(subItem)) {
                      return (
                        <div
                          key={subIndex}
                          className="footer-item"
                          onClick={() => {
                            if (subItem.onClick) {
                              subItem.onClick()
                            }
                            if (subItem.modalConfig) {
                              setModalConfig(subItem.modalConfig)
                              setModalOpen(true)
                            }
                          }}
                        >
                          {subItem.title}
                        </div>
                      )
                    }
                    return (
                      <div key={subIndex} className="footer-title">
                        {subItem.title}
                      </div>
                    )
                  })}
                </Col>
              ))}
            </Row>
          </>
        )}
        <Divider />
        <Row justify="space-between" align="middle">
          {isMobile ? (
              <>
              <Col span={24}>
                <div className="copyright-align">Copyright © 2022 Derin Bilgi Sistemleri</div>
              </Col>
              <Col span={12} style={{ maxWidth: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={akbank} alt="Akbank" style={{ width: 40, marginRight: 8, marginTop: 5 }} />
                  <img src={finans} style={{ marginRight: 8, width: 40, marginTop: 5 }} alt="Finans" />
                  <img src={logoImg} style={{ marginRight: 0 }} alt="MasterCard" />
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col span={6}>
                <div className="copyright-align">Copyright © 2022 Derin Bilgi Sistemleri</div>
              </Col>
              <Col span={6} style={{ maxWidth: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={akbank} alt="Akbank" style={{ width: 40, marginRight: 8, marginTop: 5 }} />
                  <img src={finans} style={{ marginRight: 8, width: 40, marginTop: 5 }} alt="Finans" />
                  <img src={logoImg} style={{ marginRight: 0 }} alt="MasterCard" />
                </div>
              </Col>
            </>
          )}
        </Row>
      </CenteredLayout>
      {modalConfig && (
        <Modal
          className="modal-footer"
          width={DEFAULT_MAX_WIDTH}
          onCancel={() => {
            setModalConfig(null)
            setModalOpen(false)
          }}
          footer={null}
          open={modalOpen}
          title={<div className="baslik-ayar">{modalConfig.title}</div>}
        >
          {modalConfig.content}
        </Modal>
      )}
    </div>
  )
}

export default FooterComponent

